export default [
{"code":110000,"province":"北京市","city":"","district":""},
{"code":110100,"province":"","city":"北京市","district":""},
{"code":110101,"province":"","city":"","district":"东城区"},
{"code":110102,"province":"","city":"","district":"西城区"},
{"code":110105,"province":"","city":"","district":"朝阳区"},
{"code":110106,"province":"","city":"","district":"丰台区"},
{"code":110107,"province":"","city":"","district":"石景山区"},
{"code":110108,"province":"","city":"","district":"海淀区"},
{"code":110109,"province":"","city":"","district":"门头沟区"},
{"code":110111,"province":"","city":"","district":"房山区"},
{"code":110112,"province":"","city":"","district":"通州区"},
{"code":110113,"province":"","city":"","district":"顺义区"},
{"code":110114,"province":"","city":"","district":"昌平区"},
{"code":110115,"province":"","city":"","district":"大兴区"},
{"code":110116,"province":"","city":"","district":"怀柔区"},
{"code":110117,"province":"","city":"","district":"平谷区"},
{"code":110118,"province":"","city":"","district":"密云区"},
{"code":110119,"province":"","city":"","district":"延庆区"},
{"code":120000,"province":"天津市","city":"","district":""},
{"code":120100,"province":"","city":"天津市","district":""},
{"code":120101,"province":"","city":"","district":"和平区"},
{"code":120102,"province":"","city":"","district":"河东区"},
{"code":120103,"province":"","city":"","district":"河西区"},
{"code":120104,"province":"","city":"","district":"南开区"},
{"code":120105,"province":"","city":"","district":"河北区"},
{"code":120106,"province":"","city":"","district":"红桥区"},
{"code":120110,"province":"","city":"","district":"东丽区"},
{"code":120111,"province":"","city":"","district":"西青区"},
{"code":120112,"province":"","city":"","district":"津南区"},
{"code":120113,"province":"","city":"","district":"北辰区"},
{"code":120114,"province":"","city":"","district":"武清区"},
{"code":120115,"province":"","city":"","district":"宝坻区"},
{"code":120116,"province":"","city":"","district":"滨海新区"},
{"code":120117,"province":"","city":"","district":"宁河区"},
{"code":120118,"province":"","city":"","district":"静海区"},
{"code":120119,"province":"","city":"","district":"蓟州区"},
{"code":130000,"province":"河北省","city":"","district":""},
{"code":130100,"province":"","city":"石家庄市","district":""},
{"code":130102,"province":"","city":"","district":"长安区"},
{"code":130104,"province":"","city":"","district":"桥西区"},
{"code":130105,"province":"","city":"","district":"新华区"},
{"code":130107,"province":"","city":"","district":"井陉矿区"},
{"code":130108,"province":"","city":"","district":"裕华区"},
{"code":130109,"province":"","city":"","district":"藁城区"},
{"code":130110,"province":"","city":"","district":"鹿泉区"},
{"code":130111,"province":"","city":"","district":"栾城区"},
{"code":130121,"province":"","city":"","district":"井陉县"},
{"code":130123,"province":"","city":"","district":"正定县"},
{"code":130125,"province":"","city":"","district":"行唐县"},
{"code":130126,"province":"","city":"","district":"灵寿县"},
{"code":130127,"province":"","city":"","district":"高邑县"},
{"code":130128,"province":"","city":"","district":"深泽县"},
{"code":130129,"province":"","city":"","district":"赞皇县"},
{"code":130130,"province":"","city":"","district":"无极县"},
{"code":130131,"province":"","city":"","district":"平山县"},
{"code":130132,"province":"","city":"","district":"元氏县"},
{"code":130133,"province":"","city":"","district":"赵县"},
{"code":130181,"province":"","city":"","district":"辛集市"},
{"code":130183,"province":"","city":"","district":"晋州市"},
{"code":130184,"province":"","city":"","district":"新乐市"},
{"code":130200,"province":"","city":"唐山市","district":""},
{"code":130202,"province":"","city":"","district":"路南区"},
{"code":130203,"province":"","city":"","district":"路北区"},
{"code":130204,"province":"","city":"","district":"古冶区"},
{"code":130205,"province":"","city":"","district":"开平区"},
{"code":130207,"province":"","city":"","district":"丰南区"},
{"code":130208,"province":"","city":"","district":"丰润区"},
{"code":130209,"province":"","city":"","district":"曹妃甸区"},
{"code":130284,"province":"","city":"","district":"滦州市"},
{"code":130224,"province":"","city":"","district":"滦南县"},
{"code":130225,"province":"","city":"","district":"乐亭县"},
{"code":130227,"province":"","city":"","district":"迁西县"},
{"code":130229,"province":"","city":"","district":"玉田县"},
{"code":130281,"province":"","city":"","district":"遵化市"},
{"code":130283,"province":"","city":"","district":"迁安市"},
{"code":130300,"province":"","city":"秦皇岛市","district":""},
{"code":130302,"province":"","city":"","district":"海港区"},
{"code":130303,"province":"","city":"","district":"山海关区"},
{"code":130304,"province":"","city":"","district":"北戴河区"},
{"code":130306,"province":"","city":"","district":"抚宁区"},
{"code":130321,"province":"","city":"","district":"青龙满族自治县"},
{"code":130322,"province":"","city":"","district":"昌黎县"},
{"code":130324,"province":"","city":"","district":"卢龙县"},
{"code":130400,"province":"","city":"邯郸市","district":""},
{"code":130402,"province":"","city":"","district":"邯山区"},
{"code":130403,"province":"","city":"","district":"丛台区"},
{"code":130404,"province":"","city":"","district":"复兴区"},
{"code":130406,"province":"","city":"","district":"峰峰矿区"},
{"code":130407,"province":"","city":"","district":"肥乡区"},
{"code":130408,"province":"","city":"","district":"永年区"},
{"code":130423,"province":"","city":"","district":"临漳县"},
{"code":130424,"province":"","city":"","district":"成安县"},
{"code":130425,"province":"","city":"","district":"大名县"},
{"code":130426,"province":"","city":"","district":"涉县"},
{"code":130427,"province":"","city":"","district":"磁县"},
{"code":130430,"province":"","city":"","district":"邱县"},
{"code":130431,"province":"","city":"","district":"鸡泽县"},
{"code":130432,"province":"","city":"","district":"广平县"},
{"code":130433,"province":"","city":"","district":"馆陶县"},
{"code":130434,"province":"","city":"","district":"魏县"},
{"code":130435,"province":"","city":"","district":"曲周县"},
{"code":130481,"province":"","city":"","district":"武安市"},
{"code":130500,"province":"","city":"邢台市","district":""},
{"code":130502,"province":"","city":"","district":"桥东区"},
{"code":130503,"province":"","city":"","district":"桥西区"},
{"code":130521,"province":"","city":"","district":"邢台县"},
{"code":130522,"province":"","city":"","district":"临城县"},
{"code":130523,"province":"","city":"","district":"内丘县"},
{"code":130524,"province":"","city":"","district":"柏乡县"},
{"code":130525,"province":"","city":"","district":"隆尧县"},
{"code":130526,"province":"","city":"","district":"任县"},
{"code":130527,"province":"","city":"","district":"南和县"},
{"code":130528,"province":"","city":"","district":"宁晋县"},
{"code":130529,"province":"","city":"","district":"巨鹿县"},
{"code":130530,"province":"","city":"","district":"新河县"},
{"code":130531,"province":"","city":"","district":"广宗县"},
{"code":130532,"province":"","city":"","district":"平乡县"},
{"code":130533,"province":"","city":"","district":"威县"},
{"code":130534,"province":"","city":"","district":"清河县"},
{"code":130535,"province":"","city":"","district":"临西县"},
{"code":130581,"province":"","city":"","district":"南宫市"},
{"code":130582,"province":"","city":"","district":"沙河市"},
{"code":130600,"province":"","city":"保定市","district":""},
{"code":130602,"province":"","city":"","district":"竞秀区"},
{"code":130606,"province":"","city":"","district":"莲池区"},
{"code":130607,"province":"","city":"","district":"满城区"},
{"code":130608,"province":"","city":"","district":"清苑区"},
{"code":130609,"province":"","city":"","district":"徐水区"},
{"code":130623,"province":"","city":"","district":"涞水县"},
{"code":130624,"province":"","city":"","district":"阜平县"},
{"code":130626,"province":"","city":"","district":"定兴县"},
{"code":130627,"province":"","city":"","district":"唐县"},
{"code":130628,"province":"","city":"","district":"高阳县"},
{"code":130629,"province":"","city":"","district":"容城县"},
{"code":130630,"province":"","city":"","district":"涞源县"},
{"code":130631,"province":"","city":"","district":"望都县"},
{"code":130632,"province":"","city":"","district":"安新县"},
{"code":130633,"province":"","city":"","district":"易县"},
{"code":130634,"province":"","city":"","district":"曲阳县"},
{"code":130635,"province":"","city":"","district":"蠡县"},
{"code":130636,"province":"","city":"","district":"顺平县"},
{"code":130637,"province":"","city":"","district":"博野县"},
{"code":130638,"province":"","city":"","district":"雄县"},
{"code":130681,"province":"","city":"","district":"涿州市"},
{"code":130682,"province":"","city":"","district":"定州市"},
{"code":130683,"province":"","city":"","district":"安国市"},
{"code":130684,"province":"","city":"","district":"高碑店市"},
{"code":130700,"province":"","city":"张家口市","district":""},
{"code":130702,"province":"","city":"","district":"桥东区"},
{"code":130703,"province":"","city":"","district":"桥西区"},
{"code":130705,"province":"","city":"","district":"宣化区"},
{"code":130706,"province":"","city":"","district":"下花园区"},
{"code":130708,"province":"","city":"","district":"万全区"},
{"code":130709,"province":"","city":"","district":"崇礼区"},
{"code":130722,"province":"","city":"","district":"张北县"},
{"code":130723,"province":"","city":"","district":"康保县"},
{"code":130724,"province":"","city":"","district":"沽源县"},
{"code":130725,"province":"","city":"","district":"尚义县"},
{"code":130726,"province":"","city":"","district":"蔚县"},
{"code":130727,"province":"","city":"","district":"阳原县"},
{"code":130728,"province":"","city":"","district":"怀安县"},
{"code":130730,"province":"","city":"","district":"怀来县"},
{"code":130731,"province":"","city":"","district":"涿鹿县"},
{"code":130732,"province":"","city":"","district":"赤城县"},
{"code":130800,"province":"","city":"承德市","district":""},
{"code":130802,"province":"","city":"","district":"双桥区"},
{"code":130803,"province":"","city":"","district":"双滦区"},
{"code":130804,"province":"","city":"","district":"鹰手营子矿区"},
{"code":130821,"province":"","city":"","district":"承德县"},
{"code":130822,"province":"","city":"","district":"兴隆县"},
{"code":130881,"province":"","city":"","district":"平泉市"},
{"code":130824,"province":"","city":"","district":"滦平县"},
{"code":130825,"province":"","city":"","district":"隆化县"},
{"code":130826,"province":"","city":"","district":"丰宁满族自治县"},
{"code":130827,"province":"","city":"","district":"宽城满族自治县"},
{"code":130828,"province":"","city":"","district":"围场满族蒙古族自治县"},
{"code":130900,"province":"","city":"沧州市","district":""},
{"code":130902,"province":"","city":"","district":"新华区"},
{"code":130903,"province":"","city":"","district":"运河区"},
{"code":130921,"province":"","city":"","district":"沧县"},
{"code":130922,"province":"","city":"","district":"青县"},
{"code":130923,"province":"","city":"","district":"东光县"},
{"code":130924,"province":"","city":"","district":"海兴县"},
{"code":130925,"province":"","city":"","district":"盐山县"},
{"code":130926,"province":"","city":"","district":"肃宁县"},
{"code":130927,"province":"","city":"","district":"南皮县"},
{"code":130928,"province":"","city":"","district":"吴桥县"},
{"code":130929,"province":"","city":"","district":"献县"},
{"code":130930,"province":"","city":"","district":"孟村回族自治县"},
{"code":130981,"province":"","city":"","district":"泊头市"},
{"code":130982,"province":"","city":"","district":"任丘市"},
{"code":130983,"province":"","city":"","district":"黄骅市"},
{"code":130984,"province":"","city":"","district":"河间市"},
{"code":131000,"province":"","city":"廊坊市","district":""},
{"code":131002,"province":"","city":"","district":"安次区"},
{"code":131003,"province":"","city":"","district":"广阳区"},
{"code":131022,"province":"","city":"","district":"固安县"},
{"code":131023,"province":"","city":"","district":"永清县"},
{"code":131024,"province":"","city":"","district":"香河县"},
{"code":131025,"province":"","city":"","district":"大城县"},
{"code":131026,"province":"","city":"","district":"文安县"},
{"code":131028,"province":"","city":"","district":"大厂回族自治县"},
{"code":131081,"province":"","city":"","district":"霸州市"},
{"code":131082,"province":"","city":"","district":"三河市"},
{"code":131100,"province":"","city":"衡水市","district":""},
{"code":131102,"province":"","city":"","district":"桃城区"},
{"code":131103,"province":"","city":"","district":"冀州区"},
{"code":131121,"province":"","city":"","district":"枣强县"},
{"code":131122,"province":"","city":"","district":"武邑县"},
{"code":131123,"province":"","city":"","district":"武强县"},
{"code":131124,"province":"","city":"","district":"饶阳县"},
{"code":131125,"province":"","city":"","district":"安平县"},
{"code":131126,"province":"","city":"","district":"故城县"},
{"code":131127,"province":"","city":"","district":"景县"},
{"code":131128,"province":"","city":"","district":"阜城县"},
{"code":131182,"province":"","city":"","district":"深州市"},
{"code":140000,"province":"山西省","city":"","district":""},
{"code":140100,"province":"","city":"太原市","district":""},
{"code":140105,"province":"","city":"","district":"小店区"},
{"code":140106,"province":"","city":"","district":"迎泽区"},
{"code":140107,"province":"","city":"","district":"杏花岭区"},
{"code":140108,"province":"","city":"","district":"尖草坪区"},
{"code":140109,"province":"","city":"","district":"万柏林区"},
{"code":140110,"province":"","city":"","district":"晋源区"},
{"code":140121,"province":"","city":"","district":"清徐县"},
{"code":140122,"province":"","city":"","district":"阳曲县"},
{"code":140123,"province":"","city":"","district":"娄烦县"},
{"code":140181,"province":"","city":"","district":"古交市"},
{"code":140200,"province":"","city":"大同市","district":""},
{"code":140213,"province":"","city":"","district":"平城区"},
{"code":140214,"province":"","city":"","district":"云冈区"},
{"code":140215,"province":"","city":"","district":"云州区"},
{"code":140212,"province":"","city":"","district":"新荣区"},
{"code":140221,"province":"","city":"","district":"阳高县"},
{"code":140222,"province":"","city":"","district":"天镇县"},
{"code":140223,"province":"","city":"","district":"广灵县"},
{"code":140224,"province":"","city":"","district":"灵丘县"},
{"code":140225,"province":"","city":"","district":"浑源县"},
{"code":140226,"province":"","city":"","district":"左云县"},
{"code":140300,"province":"","city":"阳泉市","district":""},
{"code":140302,"province":"","city":"","district":"城区"},
{"code":140303,"province":"","city":"","district":"矿区"},
{"code":140311,"province":"","city":"","district":"郊区"},
{"code":140321,"province":"","city":"","district":"平定县"},
{"code":140322,"province":"","city":"","district":"盂县"},
{"code":140400,"province":"","city":"长治市","district":""},
{"code":140403,"province":"","city":"","district":"潞州区"},
{"code":140404,"province":"","city":"","district":"上党区"},
{"code":140405,"province":"","city":"","district":"屯留区"},
{"code":140406,"province":"","city":"","district":"潞城区"},
{"code":140423,"province":"","city":"","district":"襄垣县"},
{"code":140425,"province":"","city":"","district":"平顺县"},
{"code":140426,"province":"","city":"","district":"黎城县"},
{"code":140427,"province":"","city":"","district":"壶关县"},
{"code":140428,"province":"","city":"","district":"长子县"},
{"code":140429,"province":"","city":"","district":"武乡县"},
{"code":140430,"province":"","city":"","district":"沁县"},
{"code":140431,"province":"","city":"","district":"沁源县"},
{"code":140500,"province":"","city":"晋城市","district":""},
{"code":140502,"province":"","city":"","district":"城区"},
{"code":140521,"province":"","city":"","district":"沁水县"},
{"code":140522,"province":"","city":"","district":"阳城县"},
{"code":140524,"province":"","city":"","district":"陵川县"},
{"code":140525,"province":"","city":"","district":"泽州县"},
{"code":140581,"province":"","city":"","district":"高平市"},
{"code":140600,"province":"","city":"朔州市","district":""},
{"code":140602,"province":"","city":"","district":"朔城区"},
{"code":140603,"province":"","city":"","district":"平鲁区"},
{"code":140621,"province":"","city":"","district":"山阴县"},
{"code":140622,"province":"","city":"","district":"应县"},
{"code":140623,"province":"","city":"","district":"右玉县"},
{"code":140681,"province":"","city":"","district":"怀仁市"},
{"code":140700,"province":"","city":"晋中市","district":""},
{"code":140702,"province":"","city":"","district":"榆次区"},
{"code":140703,"province":"","city":"","district":"太谷区"},
{"code":140721,"province":"","city":"","district":"榆社县"},
{"code":140722,"province":"","city":"","district":"左权县"},
{"code":140723,"province":"","city":"","district":"和顺县"},
{"code":140724,"province":"","city":"","district":"昔阳县"},
{"code":140725,"province":"","city":"","district":"寿阳县"},
{"code":140727,"province":"","city":"","district":"祁县"},
{"code":140728,"province":"","city":"","district":"平遥县"},
{"code":140729,"province":"","city":"","district":"灵石县"},
{"code":140781,"province":"","city":"","district":"介休市"},
{"code":140800,"province":"","city":"运城市","district":""},
{"code":140802,"province":"","city":"","district":"盐湖区"},
{"code":140821,"province":"","city":"","district":"临猗县"},
{"code":140822,"province":"","city":"","district":"万荣县"},
{"code":140823,"province":"","city":"","district":"闻喜县"},
{"code":140824,"province":"","city":"","district":"稷山县"},
{"code":140825,"province":"","city":"","district":"新绛县"},
{"code":140826,"province":"","city":"","district":"绛县"},
{"code":140827,"province":"","city":"","district":"垣曲县"},
{"code":140828,"province":"","city":"","district":"夏县"},
{"code":140829,"province":"","city":"","district":"平陆县"},
{"code":140830,"province":"","city":"","district":"芮城县"},
{"code":140881,"province":"","city":"","district":"永济市"},
{"code":140882,"province":"","city":"","district":"河津市"},
{"code":140900,"province":"","city":"忻州市","district":""},
{"code":140902,"province":"","city":"","district":"忻府区"},
{"code":140921,"province":"","city":"","district":"定襄县"},
{"code":140922,"province":"","city":"","district":"五台县"},
{"code":140923,"province":"","city":"","district":"代县"},
{"code":140924,"province":"","city":"","district":"繁峙县"},
{"code":140925,"province":"","city":"","district":"宁武县"},
{"code":140926,"province":"","city":"","district":"静乐县"},
{"code":140927,"province":"","city":"","district":"神池县"},
{"code":140928,"province":"","city":"","district":"五寨县"},
{"code":140929,"province":"","city":"","district":"岢岚县"},
{"code":140930,"province":"","city":"","district":"河曲县"},
{"code":140931,"province":"","city":"","district":"保德县"},
{"code":140932,"province":"","city":"","district":"偏关县"},
{"code":140981,"province":"","city":"","district":"原平市"},
{"code":141000,"province":"","city":"临汾市","district":""},
{"code":141002,"province":"","city":"","district":"尧都区"},
{"code":141021,"province":"","city":"","district":"曲沃县"},
{"code":141022,"province":"","city":"","district":"翼城县"},
{"code":141023,"province":"","city":"","district":"襄汾县"},
{"code":141024,"province":"","city":"","district":"洪洞县"},
{"code":141025,"province":"","city":"","district":"古县"},
{"code":141026,"province":"","city":"","district":"安泽县"},
{"code":141027,"province":"","city":"","district":"浮山县"},
{"code":141028,"province":"","city":"","district":"吉县"},
{"code":141029,"province":"","city":"","district":"乡宁县"},
{"code":141030,"province":"","city":"","district":"大宁县"},
{"code":141031,"province":"","city":"","district":"隰县"},
{"code":141032,"province":"","city":"","district":"永和县"},
{"code":141033,"province":"","city":"","district":"蒲县"},
{"code":141034,"province":"","city":"","district":"汾西县"},
{"code":141081,"province":"","city":"","district":"侯马市"},
{"code":141082,"province":"","city":"","district":"霍州市"},
{"code":141100,"province":"","city":"吕梁市","district":""},
{"code":141102,"province":"","city":"","district":"离石区"},
{"code":141121,"province":"","city":"","district":"文水县"},
{"code":141122,"province":"","city":"","district":"交城县"},
{"code":141123,"province":"","city":"","district":"兴县"},
{"code":141124,"province":"","city":"","district":"临县"},
{"code":141125,"province":"","city":"","district":"柳林县"},
{"code":141126,"province":"","city":"","district":"石楼县"},
{"code":141127,"province":"","city":"","district":"岚县"},
{"code":141128,"province":"","city":"","district":"方山县"},
{"code":141129,"province":"","city":"","district":"中阳县"},
{"code":141130,"province":"","city":"","district":"交口县"},
{"code":141181,"province":"","city":"","district":"孝义市"},
{"code":141182,"province":"","city":"","district":"汾阳市"},
{"code":150000,"province":"内蒙古自治区","city":"","district":""},
{"code":150100,"province":"","city":"呼和浩特市","district":""},
{"code":150102,"province":"","city":"","district":"新城区"},
{"code":150103,"province":"","city":"","district":"回民区"},
{"code":150104,"province":"","city":"","district":"玉泉区"},
{"code":150105,"province":"","city":"","district":"赛罕区"},
{"code":150121,"province":"","city":"","district":"土默特左旗"},
{"code":150122,"province":"","city":"","district":"托克托县"},
{"code":150123,"province":"","city":"","district":"和林格尔县"},
{"code":150124,"province":"","city":"","district":"清水河县"},
{"code":150125,"province":"","city":"","district":"武川县"},
{"code":150200,"province":"","city":"包头市","district":""},
{"code":150202,"province":"","city":"","district":"东河区"},
{"code":150203,"province":"","city":"","district":"昆都仑区"},
{"code":150204,"province":"","city":"","district":"青山区"},
{"code":150205,"province":"","city":"","district":"石拐区"},
{"code":150206,"province":"","city":"","district":"白云鄂博矿区"},
{"code":150207,"province":"","city":"","district":"九原区"},
{"code":150221,"province":"","city":"","district":"土默特右旗"},
{"code":150222,"province":"","city":"","district":"固阳县"},
{"code":150223,"province":"","city":"","district":"达尔罕茂明安联合旗"},
{"code":150300,"province":"","city":"乌海市","district":""},
{"code":150302,"province":"","city":"","district":"海勃湾区"},
{"code":150303,"province":"","city":"","district":"海南区"},
{"code":150304,"province":"","city":"","district":"乌达区"},
{"code":150400,"province":"","city":"赤峰市","district":""},
{"code":150402,"province":"","city":"","district":"红山区"},
{"code":150403,"province":"","city":"","district":"元宝山区"},
{"code":150404,"province":"","city":"","district":"松山区"},
{"code":150421,"province":"","city":"","district":"阿鲁科尔沁旗"},
{"code":150422,"province":"","city":"","district":"巴林左旗"},
{"code":150423,"province":"","city":"","district":"巴林右旗"},
{"code":150424,"province":"","city":"","district":"林西县"},
{"code":150425,"province":"","city":"","district":"克什克腾旗"},
{"code":150426,"province":"","city":"","district":"翁牛特旗"},
{"code":150428,"province":"","city":"","district":"喀喇沁旗"},
{"code":150429,"province":"","city":"","district":"宁城县"},
{"code":150430,"province":"","city":"","district":"敖汉旗"},
{"code":150500,"province":"","city":"通辽市","district":""},
{"code":150502,"province":"","city":"","district":"科尔沁区"},
{"code":150521,"province":"","city":"","district":"科尔沁左翼中旗"},
{"code":150522,"province":"","city":"","district":"科尔沁左翼后旗"},
{"code":150523,"province":"","city":"","district":"开鲁县"},
{"code":150524,"province":"","city":"","district":"库伦旗"},
{"code":150525,"province":"","city":"","district":"奈曼旗"},
{"code":150526,"province":"","city":"","district":"扎鲁特旗"},
{"code":150581,"province":"","city":"","district":"霍林郭勒市"},
{"code":150600,"province":"","city":"鄂尔多斯市","district":""},
{"code":150602,"province":"","city":"","district":"东胜区"},
{"code":150603,"province":"","city":"","district":"康巴什区"},
{"code":150621,"province":"","city":"","district":"达拉特旗"},
{"code":150622,"province":"","city":"","district":"准格尔旗"},
{"code":150623,"province":"","city":"","district":"鄂托克前旗"},
{"code":150624,"province":"","city":"","district":"鄂托克旗"},
{"code":150625,"province":"","city":"","district":"杭锦旗"},
{"code":150626,"province":"","city":"","district":"乌审旗"},
{"code":150627,"province":"","city":"","district":"伊金霍洛旗"},
{"code":150700,"province":"","city":"呼伦贝尔市","district":""},
{"code":150702,"province":"","city":"","district":"海拉尔区"},
{"code":150703,"province":"","city":"","district":"扎赉诺尔区"},
{"code":150721,"province":"","city":"","district":"阿荣旗"},
{"code":150722,"province":"","city":"","district":"莫力达瓦达斡尔族自治旗"},
{"code":150723,"province":"","city":"","district":"鄂伦春自治旗"},
{"code":150724,"province":"","city":"","district":"鄂温克族自治旗"},
{"code":150725,"province":"","city":"","district":"陈巴尔虎旗"},
{"code":150726,"province":"","city":"","district":"新巴尔虎左旗"},
{"code":150727,"province":"","city":"","district":"新巴尔虎右旗"},
{"code":150781,"province":"","city":"","district":"满洲里市"},
{"code":150782,"province":"","city":"","district":"牙克石市"},
{"code":150783,"province":"","city":"","district":"扎兰屯市"},
{"code":150784,"province":"","city":"","district":"额尔古纳市"},
{"code":150785,"province":"","city":"","district":"根河市"},
{"code":150800,"province":"","city":"巴彦淖尔市","district":""},
{"code":150802,"province":"","city":"","district":"临河区"},
{"code":150821,"province":"","city":"","district":"五原县"},
{"code":150822,"province":"","city":"","district":"磴口县"},
{"code":150823,"province":"","city":"","district":"乌拉特前旗"},
{"code":150824,"province":"","city":"","district":"乌拉特中旗"},
{"code":150825,"province":"","city":"","district":"乌拉特后旗"},
{"code":150826,"province":"","city":"","district":"杭锦后旗"},
{"code":150900,"province":"","city":"乌兰察布市","district":""},
{"code":150902,"province":"","city":"","district":"集宁区"},
{"code":150921,"province":"","city":"","district":"卓资县"},
{"code":150922,"province":"","city":"","district":"化德县"},
{"code":150923,"province":"","city":"","district":"商都县"},
{"code":150924,"province":"","city":"","district":"兴和县"},
{"code":150925,"province":"","city":"","district":"凉城县"},
{"code":150926,"province":"","city":"","district":"察哈尔右翼前旗"},
{"code":150927,"province":"","city":"","district":"察哈尔右翼中旗"},
{"code":150928,"province":"","city":"","district":"察哈尔右翼后旗"},
{"code":150929,"province":"","city":"","district":"四子王旗"},
{"code":150981,"province":"","city":"","district":"丰镇市"},
{"code":152200,"province":"","city":"兴安盟","district":""},
{"code":152201,"province":"","city":"","district":"乌兰浩特市"},
{"code":152202,"province":"","city":"","district":"阿尔山市"},
{"code":152221,"province":"","city":"","district":"科尔沁右翼前旗"},
{"code":152222,"province":"","city":"","district":"科尔沁右翼中旗"},
{"code":152223,"province":"","city":"","district":"扎赉特旗"},
{"code":152224,"province":"","city":"","district":"突泉县"},
{"code":152500,"province":"","city":"锡林郭勒盟","district":""},
{"code":152501,"province":"","city":"","district":"二连浩特市"},
{"code":152502,"province":"","city":"","district":"锡林浩特市"},
{"code":152522,"province":"","city":"","district":"阿巴嘎旗"},
{"code":152523,"province":"","city":"","district":"苏尼特左旗"},
{"code":152524,"province":"","city":"","district":"苏尼特右旗"},
{"code":152525,"province":"","city":"","district":"东乌珠穆沁旗"},
{"code":152526,"province":"","city":"","district":"西乌珠穆沁旗"},
{"code":152527,"province":"","city":"","district":"太仆寺旗"},
{"code":152528,"province":"","city":"","district":"镶黄旗"},
{"code":152529,"province":"","city":"","district":"正镶白旗"},
{"code":152530,"province":"","city":"","district":"正蓝旗"},
{"code":152531,"province":"","city":"","district":"多伦县"},
{"code":152900,"province":"","city":"阿拉善盟","district":""},
{"code":152921,"province":"","city":"","district":"阿拉善左旗"},
{"code":152922,"province":"","city":"","district":"阿拉善右旗"},
{"code":152923,"province":"","city":"","district":"额济纳旗"},
{"code":210000,"province":"辽宁省","city":"","district":""},
{"code":210100,"province":"","city":"沈阳市","district":""},
{"code":210102,"province":"","city":"","district":"和平区"},
{"code":210103,"province":"","city":"","district":"沈河区"},
{"code":210104,"province":"","city":"","district":"大东区"},
{"code":210105,"province":"","city":"","district":"皇姑区"},
{"code":210106,"province":"","city":"","district":"铁西区"},
{"code":210111,"province":"","city":"","district":"苏家屯区"},
{"code":210112,"province":"","city":"","district":"浑南区"},
{"code":210113,"province":"","city":"","district":"沈北新区"},
{"code":210114,"province":"","city":"","district":"于洪区"},
{"code":210115,"province":"","city":"","district":"辽中区"},
{"code":210123,"province":"","city":"","district":"康平县"},
{"code":210124,"province":"","city":"","district":"法库县"},
{"code":210181,"province":"","city":"","district":"新民市"},
{"code":210200,"province":"","city":"大连市","district":""},
{"code":210202,"province":"","city":"","district":"中山区"},
{"code":210203,"province":"","city":"","district":"西岗区"},
{"code":210204,"province":"","city":"","district":"沙河口区"},
{"code":210211,"province":"","city":"","district":"甘井子区"},
{"code":210212,"province":"","city":"","district":"旅顺口区"},
{"code":210213,"province":"","city":"","district":"金州区"},
{"code":210224,"province":"","city":"","district":"长海县"},
{"code":210281,"province":"","city":"","district":"瓦房店市"},
{"code":210214,"province":"","city":"","district":"普兰店区"},
{"code":210283,"province":"","city":"","district":"庄河市"},
{"code":210300,"province":"","city":"鞍山市","district":""},
{"code":210302,"province":"","city":"","district":"铁东区"},
{"code":210303,"province":"","city":"","district":"铁西区"},
{"code":210304,"province":"","city":"","district":"立山区"},
{"code":210311,"province":"","city":"","district":"千山区"},
{"code":210321,"province":"","city":"","district":"台安县"},
{"code":210323,"province":"","city":"","district":"岫岩满族自治县"},
{"code":210381,"province":"","city":"","district":"海城市"},
{"code":210400,"province":"","city":"抚顺市","district":""},
{"code":210402,"province":"","city":"","district":"新抚区"},
{"code":210403,"province":"","city":"","district":"东洲区"},
{"code":210404,"province":"","city":"","district":"望花区"},
{"code":210411,"province":"","city":"","district":"顺城区"},
{"code":210421,"province":"","city":"","district":"抚顺县"},
{"code":210422,"province":"","city":"","district":"新宾满族自治县"},
{"code":210423,"province":"","city":"","district":"清原满族自治县"},
{"code":210500,"province":"","city":"本溪市","district":""},
{"code":210502,"province":"","city":"","district":"平山区"},
{"code":210503,"province":"","city":"","district":"溪湖区"},
{"code":210504,"province":"","city":"","district":"明山区"},
{"code":210505,"province":"","city":"","district":"南芬区"},
{"code":210521,"province":"","city":"","district":"本溪满族自治县"},
{"code":210522,"province":"","city":"","district":"桓仁满族自治县"},
{"code":210600,"province":"","city":"丹东市","district":""},
{"code":210602,"province":"","city":"","district":"元宝区"},
{"code":210603,"province":"","city":"","district":"振兴区"},
{"code":210604,"province":"","city":"","district":"振安区"},
{"code":210624,"province":"","city":"","district":"宽甸满族自治县"},
{"code":210681,"province":"","city":"","district":"东港市"},
{"code":210682,"province":"","city":"","district":"凤城市"},
{"code":210700,"province":"","city":"锦州市","district":""},
{"code":210702,"province":"","city":"","district":"古塔区"},
{"code":210703,"province":"","city":"","district":"凌河区"},
{"code":210711,"province":"","city":"","district":"太和区"},
{"code":210726,"province":"","city":"","district":"黑山县"},
{"code":210727,"province":"","city":"","district":"义县"},
{"code":210781,"province":"","city":"","district":"凌海市"},
{"code":210782,"province":"","city":"","district":"北镇市"},
{"code":210800,"province":"","city":"营口市","district":""},
{"code":210802,"province":"","city":"","district":"站前区"},
{"code":210803,"province":"","city":"","district":"西市区"},
{"code":210804,"province":"","city":"","district":"鲅鱼圈区"},
{"code":210811,"province":"","city":"","district":"老边区"},
{"code":210881,"province":"","city":"","district":"盖州市"},
{"code":210882,"province":"","city":"","district":"大石桥市"},
{"code":210900,"province":"","city":"阜新市","district":""},
{"code":210902,"province":"","city":"","district":"海州区"},
{"code":210903,"province":"","city":"","district":"新邱区"},
{"code":210904,"province":"","city":"","district":"太平区"},
{"code":210905,"province":"","city":"","district":"清河门区"},
{"code":210911,"province":"","city":"","district":"细河区"},
{"code":210921,"province":"","city":"","district":"阜新蒙古族自治县"},
{"code":210922,"province":"","city":"","district":"彰武县"},
{"code":211000,"province":"","city":"辽阳市","district":""},
{"code":211002,"province":"","city":"","district":"白塔区"},
{"code":211003,"province":"","city":"","district":"文圣区"},
{"code":211004,"province":"","city":"","district":"宏伟区"},
{"code":211005,"province":"","city":"","district":"弓长岭区"},
{"code":211011,"province":"","city":"","district":"太子河区"},
{"code":211021,"province":"","city":"","district":"辽阳县"},
{"code":211081,"province":"","city":"","district":"灯塔市"},
{"code":211100,"province":"","city":"盘锦市","district":""},
{"code":211102,"province":"","city":"","district":"双台子区"},
{"code":211103,"province":"","city":"","district":"兴隆台区"},
{"code":211104,"province":"","city":"","district":"大洼区"},
{"code":211122,"province":"","city":"","district":"盘山县"},
{"code":211200,"province":"","city":"铁岭市","district":""},
{"code":211202,"province":"","city":"","district":"银州区"},
{"code":211204,"province":"","city":"","district":"清河区"},
{"code":211221,"province":"","city":"","district":"铁岭县"},
{"code":211223,"province":"","city":"","district":"西丰县"},
{"code":211224,"province":"","city":"","district":"昌图县"},
{"code":211281,"province":"","city":"","district":"调兵山市"},
{"code":211282,"province":"","city":"","district":"开原市"},
{"code":211300,"province":"","city":"朝阳市","district":""},
{"code":211302,"province":"","city":"","district":"双塔区"},
{"code":211303,"province":"","city":"","district":"龙城区"},
{"code":211321,"province":"","city":"","district":"朝阳县"},
{"code":211322,"province":"","city":"","district":"建平县"},
{"code":211324,"province":"","city":"","district":"喀喇沁左翼蒙古族自治县"},
{"code":211381,"province":"","city":"","district":"北票市"},
{"code":211382,"province":"","city":"","district":"凌源市"},
{"code":211400,"province":"","city":"葫芦岛市","district":""},
{"code":211402,"province":"","city":"","district":"连山区"},
{"code":211403,"province":"","city":"","district":"龙港区"},
{"code":211404,"province":"","city":"","district":"南票区"},
{"code":211421,"province":"","city":"","district":"绥中县"},
{"code":211422,"province":"","city":"","district":"建昌县"},
{"code":211481,"province":"","city":"","district":"兴城市"},
{"code":220000,"province":"吉林省","city":"","district":""},
{"code":220100,"province":"","city":"长春市","district":""},
{"code":220102,"province":"","city":"","district":"南关区"},
{"code":220103,"province":"","city":"","district":"宽城区"},
{"code":220104,"province":"","city":"","district":"朝阳区"},
{"code":220105,"province":"","city":"","district":"二道区"},
{"code":220106,"province":"","city":"","district":"绿园区"},
{"code":220112,"province":"","city":"","district":"双阳区"},
{"code":220113,"province":"","city":"","district":"九台区"},
{"code":220122,"province":"","city":"","district":"农安县"},
{"code":220182,"province":"","city":"","district":"榆树市"},
{"code":220183,"province":"","city":"","district":"德惠市"},
{"code":220200,"province":"","city":"吉林市","district":""},
{"code":220202,"province":"","city":"","district":"昌邑区"},
{"code":220203,"province":"","city":"","district":"龙潭区"},
{"code":220204,"province":"","city":"","district":"船营区"},
{"code":220211,"province":"","city":"","district":"丰满区"},
{"code":220221,"province":"","city":"","district":"永吉县"},
{"code":220281,"province":"","city":"","district":"蛟河市"},
{"code":220282,"province":"","city":"","district":"桦甸市"},
{"code":220283,"province":"","city":"","district":"舒兰市"},
{"code":220284,"province":"","city":"","district":"磐石市"},
{"code":220300,"province":"","city":"四平市","district":""},
{"code":220302,"province":"","city":"","district":"铁西区"},
{"code":220303,"province":"","city":"","district":"铁东区"},
{"code":220322,"province":"","city":"","district":"梨树县"},
{"code":220323,"province":"","city":"","district":"伊通满族自治县"},
{"code":220381,"province":"","city":"","district":"公主岭市"},
{"code":220382,"province":"","city":"","district":"双辽市"},
{"code":220400,"province":"","city":"辽源市","district":""},
{"code":220402,"province":"","city":"","district":"龙山区"},
{"code":220403,"province":"","city":"","district":"西安区"},
{"code":220421,"province":"","city":"","district":"东丰县"},
{"code":220422,"province":"","city":"","district":"东辽县"},
{"code":220500,"province":"","city":"通化市","district":""},
{"code":220502,"province":"","city":"","district":"东昌区"},
{"code":220503,"province":"","city":"","district":"二道江区"},
{"code":220521,"province":"","city":"","district":"通化县"},
{"code":220523,"province":"","city":"","district":"辉南县"},
{"code":220524,"province":"","city":"","district":"柳河县"},
{"code":220581,"province":"","city":"","district":"梅河口市"},
{"code":220582,"province":"","city":"","district":"集安市"},
{"code":220600,"province":"","city":"白山市","district":""},
{"code":220602,"province":"","city":"","district":"浑江区"},
{"code":220605,"province":"","city":"","district":"江源区"},
{"code":220621,"province":"","city":"","district":"抚松县"},
{"code":220622,"province":"","city":"","district":"靖宇县"},
{"code":220623,"province":"","city":"","district":"长白朝鲜族自治县"},
{"code":220681,"province":"","city":"","district":"临江市"},
{"code":220700,"province":"","city":"松原市","district":""},
{"code":220702,"province":"","city":"","district":"宁江区"},
{"code":220721,"province":"","city":"","district":"前郭尔罗斯蒙古族自治县"},
{"code":220722,"province":"","city":"","district":"长岭县"},
{"code":220723,"province":"","city":"","district":"乾安县"},
{"code":220781,"province":"","city":"","district":"扶余市"},
{"code":220800,"province":"","city":"白城市","district":""},
{"code":220802,"province":"","city":"","district":"洮北区"},
{"code":220821,"province":"","city":"","district":"镇赉县"},
{"code":220822,"province":"","city":"","district":"通榆县"},
{"code":220881,"province":"","city":"","district":"洮南市"},
{"code":220882,"province":"","city":"","district":"大安市"},
{"code":222400,"province":"","city":"延边朝鲜族自治州","district":""},
{"code":222401,"province":"","city":"","district":"延吉市"},
{"code":222402,"province":"","city":"","district":"图们市"},
{"code":222403,"province":"","city":"","district":"敦化市"},
{"code":222404,"province":"","city":"","district":"珲春市"},
{"code":222405,"province":"","city":"","district":"龙井市"},
{"code":222406,"province":"","city":"","district":"和龙市"},
{"code":222424,"province":"","city":"","district":"汪清县"},
{"code":222426,"province":"","city":"","district":"安图县"},
{"code":230000,"province":"黑龙江省","city":"","district":""},
{"code":230100,"province":"","city":"哈尔滨市","district":""},
{"code":230102,"province":"","city":"","district":"道里区"},
{"code":230103,"province":"","city":"","district":"南岗区"},
{"code":230104,"province":"","city":"","district":"道外区"},
{"code":230108,"province":"","city":"","district":"平房区"},
{"code":230109,"province":"","city":"","district":"松北区"},
{"code":230110,"province":"","city":"","district":"香坊区"},
{"code":230111,"province":"","city":"","district":"呼兰区"},
{"code":230112,"province":"","city":"","district":"阿城区"},
{"code":230113,"province":"","city":"","district":"双城区"},
{"code":230123,"province":"","city":"","district":"依兰县"},
{"code":230124,"province":"","city":"","district":"方正县"},
{"code":230125,"province":"","city":"","district":"宾县"},
{"code":230126,"province":"","city":"","district":"巴彦县"},
{"code":230127,"province":"","city":"","district":"木兰县"},
{"code":230128,"province":"","city":"","district":"通河县"},
{"code":230129,"province":"","city":"","district":"延寿县"},
{"code":230183,"province":"","city":"","district":"尚志市"},
{"code":230184,"province":"","city":"","district":"五常市"},
{"code":230200,"province":"","city":"齐齐哈尔市","district":""},
{"code":230202,"province":"","city":"","district":"龙沙区"},
{"code":230203,"province":"","city":"","district":"建华区"},
{"code":230204,"province":"","city":"","district":"铁锋区"},
{"code":230205,"province":"","city":"","district":"昂昂溪区"},
{"code":230206,"province":"","city":"","district":"富拉尔基区"},
{"code":230207,"province":"","city":"","district":"碾子山区"},
{"code":230208,"province":"","city":"","district":"梅里斯达斡尔族区"},
{"code":230221,"province":"","city":"","district":"龙江县"},
{"code":230223,"province":"","city":"","district":"依安县"},
{"code":230224,"province":"","city":"","district":"泰来县"},
{"code":230225,"province":"","city":"","district":"甘南县"},
{"code":230227,"province":"","city":"","district":"富裕县"},
{"code":230229,"province":"","city":"","district":"克山县"},
{"code":230230,"province":"","city":"","district":"克东县"},
{"code":230231,"province":"","city":"","district":"拜泉县"},
{"code":230281,"province":"","city":"","district":"讷河市"},
{"code":230300,"province":"","city":"鸡西市","district":""},
{"code":230302,"province":"","city":"","district":"鸡冠区"},
{"code":230303,"province":"","city":"","district":"恒山区"},
{"code":230304,"province":"","city":"","district":"滴道区"},
{"code":230305,"province":"","city":"","district":"梨树区"},
{"code":230306,"province":"","city":"","district":"城子河区"},
{"code":230307,"province":"","city":"","district":"麻山区"},
{"code":230321,"province":"","city":"","district":"鸡东县"},
{"code":230381,"province":"","city":"","district":"虎林市"},
{"code":230382,"province":"","city":"","district":"密山市"},
{"code":230400,"province":"","city":"鹤岗市","district":""},
{"code":230402,"province":"","city":"","district":"向阳区"},
{"code":230403,"province":"","city":"","district":"工农区"},
{"code":230404,"province":"","city":"","district":"南山区"},
{"code":230405,"province":"","city":"","district":"兴安区"},
{"code":230406,"province":"","city":"","district":"东山区"},
{"code":230407,"province":"","city":"","district":"兴山区"},
{"code":230421,"province":"","city":"","district":"萝北县"},
{"code":230422,"province":"","city":"","district":"绥滨县"},
{"code":230500,"province":"","city":"双鸭山市","district":""},
{"code":230502,"province":"","city":"","district":"尖山区"},
{"code":230503,"province":"","city":"","district":"岭东区"},
{"code":230505,"province":"","city":"","district":"四方台区"},
{"code":230506,"province":"","city":"","district":"宝山区"},
{"code":230521,"province":"","city":"","district":"集贤县"},
{"code":230522,"province":"","city":"","district":"友谊县"},
{"code":230523,"province":"","city":"","district":"宝清县"},
{"code":230524,"province":"","city":"","district":"饶河县"},
{"code":230600,"province":"","city":"大庆市","district":""},
{"code":230602,"province":"","city":"","district":"萨尔图区"},
{"code":230603,"province":"","city":"","district":"龙凤区"},
{"code":230604,"province":"","city":"","district":"让胡路区"},
{"code":230605,"province":"","city":"","district":"红岗区"},
{"code":230606,"province":"","city":"","district":"大同区"},
{"code":230621,"province":"","city":"","district":"肇州县"},
{"code":230622,"province":"","city":"","district":"肇源县"},
{"code":230623,"province":"","city":"","district":"林甸县"},
{"code":230624,"province":"","city":"","district":"杜尔伯特蒙古族自治县"},
{"code":230700,"province":"","city":"伊春市","district":""},
{"code":230717,"province":"","city":"","district":"伊美区"},
{"code":230718,"province":"","city":"","district":"乌翠区"},
{"code":230719,"province":"","city":"","district":"友好区"},
{"code":230722,"province":"","city":"","district":"嘉荫县"},
{"code":230723,"province":"","city":"","district":"汤旺县"},
{"code":230724,"province":"","city":"","district":"丰林县"},
{"code":230725,"province":"","city":"","district":"大箐山县"},
{"code":230726,"province":"","city":"","district":"南岔县"},
{"code":230751,"province":"","city":"","district":"金林区"},
{"code":230781,"province":"","city":"","district":"铁力市"},
{"code":230800,"province":"","city":"佳木斯市","district":""},
{"code":230803,"province":"","city":"","district":"向阳区"},
{"code":230804,"province":"","city":"","district":"前进区"},
{"code":230805,"province":"","city":"","district":"东风区"},
{"code":230811,"province":"","city":"","district":"郊区"},
{"code":230822,"province":"","city":"","district":"桦南县"},
{"code":230826,"province":"","city":"","district":"桦川县"},
{"code":230828,"province":"","city":"","district":"汤原县"},
{"code":230881,"province":"","city":"","district":"同江市"},
{"code":230882,"province":"","city":"","district":"富锦市"},
{"code":230883,"province":"","city":"","district":"抚远市"},
{"code":230900,"province":"","city":"七台河市","district":""},
{"code":230902,"province":"","city":"","district":"新兴区"},
{"code":230903,"province":"","city":"","district":"桃山区"},
{"code":230904,"province":"","city":"","district":"茄子河区"},
{"code":230921,"province":"","city":"","district":"勃利县"},
{"code":231000,"province":"","city":"牡丹江市","district":""},
{"code":231002,"province":"","city":"","district":"东安区"},
{"code":231003,"province":"","city":"","district":"阳明区"},
{"code":231004,"province":"","city":"","district":"爱民区"},
{"code":231005,"province":"","city":"","district":"西安区"},
{"code":231025,"province":"","city":"","district":"林口县"},
{"code":231081,"province":"","city":"","district":"绥芬河市"},
{"code":231083,"province":"","city":"","district":"海林市"},
{"code":231084,"province":"","city":"","district":"宁安市"},
{"code":231085,"province":"","city":"","district":"穆棱市"},
{"code":231086,"province":"","city":"","district":"东宁市"},
{"code":231100,"province":"","city":"黑河市","district":""},
{"code":231102,"province":"","city":"","district":"爱辉区"},
{"code":231123,"province":"","city":"","district":"逊克县"},
{"code":231124,"province":"","city":"","district":"孙吴县"},
{"code":231181,"province":"","city":"","district":"北安市"},
{"code":231182,"province":"","city":"","district":"五大连池市"},
{"code":231183,"province":"","city":"","district":"嫩江市"},
{"code":231200,"province":"","city":"绥化市","district":""},
{"code":231202,"province":"","city":"","district":"北林区"},
{"code":231221,"province":"","city":"","district":"望奎县"},
{"code":231222,"province":"","city":"","district":"兰西县"},
{"code":231223,"province":"","city":"","district":"青冈县"},
{"code":231224,"province":"","city":"","district":"庆安县"},
{"code":231225,"province":"","city":"","district":"明水县"},
{"code":231226,"province":"","city":"","district":"绥棱县"},
{"code":231281,"province":"","city":"","district":"安达市"},
{"code":231282,"province":"","city":"","district":"肇东市"},
{"code":231283,"province":"","city":"","district":"海伦市"},
{"code":232700,"province":"","city":"大兴安岭地区","district":""},
{"code":232721,"province":"","city":"","district":"呼玛县"},
{"code":232722,"province":"","city":"","district":"塔河县"},
{"code":232701,"province":"","city":"","district":"漠河市"},
{"code":310000,"province":"上海市","city":"","district":""},
{"code":310100,"province":"","city":"上海市","district":""},
{"code":310101,"province":"","city":"","district":"黄浦区"},
{"code":310104,"province":"","city":"","district":"徐汇区"},
{"code":310105,"province":"","city":"","district":"长宁区"},
{"code":310106,"province":"","city":"","district":"静安区"},
{"code":310107,"province":"","city":"","district":"普陀区"},
{"code":310109,"province":"","city":"","district":"虹口区"},
{"code":310110,"province":"","city":"","district":"杨浦区"},
{"code":310112,"province":"","city":"","district":"闵行区"},
{"code":310113,"province":"","city":"","district":"宝山区"},
{"code":310114,"province":"","city":"","district":"嘉定区"},
{"code":310115,"province":"","city":"","district":"浦东新区"},
{"code":310116,"province":"","city":"","district":"金山区"},
{"code":310117,"province":"","city":"","district":"松江区"},
{"code":310118,"province":"","city":"","district":"青浦区"},
{"code":310120,"province":"","city":"","district":"奉贤区"},
{"code":310151,"province":"","city":"","district":"崇明区"},
{"code":320000,"province":"江苏省","city":"","district":""},
{"code":320100,"province":"","city":"南京市","district":""},
{"code":320102,"province":"","city":"","district":"玄武区"},
{"code":320104,"province":"","city":"","district":"秦淮区"},
{"code":320105,"province":"","city":"","district":"建邺区"},
{"code":320106,"province":"","city":"","district":"鼓楼区"},
{"code":320111,"province":"","city":"","district":"浦口区"},
{"code":320113,"province":"","city":"","district":"栖霞区"},
{"code":320114,"province":"","city":"","district":"雨花台区"},
{"code":320115,"province":"","city":"","district":"江宁区"},
{"code":320116,"province":"","city":"","district":"六合区"},
{"code":320117,"province":"","city":"","district":"溧水区"},
{"code":320118,"province":"","city":"","district":"高淳区"},
{"code":320200,"province":"","city":"无锡市","district":""},
{"code":320205,"province":"","city":"","district":"锡山区"},
{"code":320206,"province":"","city":"","district":"惠山区"},
{"code":320211,"province":"","city":"","district":"滨湖区"},
{"code":320213,"province":"","city":"","district":"梁溪区"},
{"code":320214,"province":"","city":"","district":"新吴区"},
{"code":320281,"province":"","city":"","district":"江阴市"},
{"code":320282,"province":"","city":"","district":"宜兴市"},
{"code":320300,"province":"","city":"徐州市","district":""},
{"code":320302,"province":"","city":"","district":"鼓楼区"},
{"code":320303,"province":"","city":"","district":"云龙区"},
{"code":320305,"province":"","city":"","district":"贾汪区"},
{"code":320311,"province":"","city":"","district":"泉山区"},
{"code":320312,"province":"","city":"","district":"铜山区"},
{"code":320321,"province":"","city":"","district":"丰县"},
{"code":320322,"province":"","city":"","district":"沛县"},
{"code":320324,"province":"","city":"","district":"睢宁县"},
{"code":320381,"province":"","city":"","district":"新沂市"},
{"code":320382,"province":"","city":"","district":"邳州市"},
{"code":320400,"province":"","city":"常州市","district":""},
{"code":320402,"province":"","city":"","district":"天宁区"},
{"code":320404,"province":"","city":"","district":"钟楼区"},
{"code":320411,"province":"","city":"","district":"新北区"},
{"code":320412,"province":"","city":"","district":"武进区"},
{"code":320413,"province":"","city":"","district":"金坛区"},
{"code":320481,"province":"","city":"","district":"溧阳市"},
{"code":320500,"province":"","city":"苏州市","district":""},
{"code":320505,"province":"","city":"","district":"虎丘区"},
{"code":320506,"province":"","city":"","district":"吴中区"},
{"code":320507,"province":"","city":"","district":"相城区"},
{"code":320508,"province":"","city":"","district":"姑苏区"},
{"code":320509,"province":"","city":"","district":"吴江区"},
{"code":320581,"province":"","city":"","district":"常熟市"},
{"code":320582,"province":"","city":"","district":"张家港市"},
{"code":320583,"province":"","city":"","district":"昆山市"},
{"code":320585,"province":"","city":"","district":"太仓市"},
{"code":320600,"province":"","city":"南通市","district":""},
{"code":320602,"province":"","city":"","district":"崇川区"},
{"code":320611,"province":"","city":"","district":"港闸区"},
{"code":320612,"province":"","city":"","district":"通州区"},
{"code":320685,"province":"","city":"","district":"海安市"},
{"code":320623,"province":"","city":"","district":"如东县"},
{"code":320681,"province":"","city":"","district":"启东市"},
{"code":320682,"province":"","city":"","district":"如皋市"},
{"code":320684,"province":"","city":"","district":"海门市"},
{"code":320700,"province":"","city":"连云港市","district":""},
{"code":320703,"province":"","city":"","district":"连云区"},
{"code":320706,"province":"","city":"","district":"海州区"},
{"code":320707,"province":"","city":"","district":"赣榆区"},
{"code":320722,"province":"","city":"","district":"东海县"},
{"code":320723,"province":"","city":"","district":"灌云县"},
{"code":320724,"province":"","city":"","district":"灌南县"},
{"code":320800,"province":"","city":"淮安市","district":""},
{"code":320803,"province":"","city":"","district":"淮安区"},
{"code":320804,"province":"","city":"","district":"淮阴区"},
{"code":320812,"province":"","city":"","district":"清江浦区"},
{"code":320813,"province":"","city":"","district":"洪泽区"},
{"code":320826,"province":"","city":"","district":"涟水县"},
{"code":320830,"province":"","city":"","district":"盱眙县"},
{"code":320831,"province":"","city":"","district":"金湖县"},
{"code":320900,"province":"","city":"盐城市","district":""},
{"code":320902,"province":"","city":"","district":"亭湖区"},
{"code":320903,"province":"","city":"","district":"盐都区"},
{"code":320904,"province":"","city":"","district":"大丰区"},
{"code":320921,"province":"","city":"","district":"响水县"},
{"code":320922,"province":"","city":"","district":"滨海县"},
{"code":320923,"province":"","city":"","district":"阜宁县"},
{"code":320924,"province":"","city":"","district":"射阳县"},
{"code":320925,"province":"","city":"","district":"建湖县"},
{"code":320981,"province":"","city":"","district":"东台市"},
{"code":321000,"province":"","city":"扬州市","district":""},
{"code":321002,"province":"","city":"","district":"广陵区"},
{"code":321003,"province":"","city":"","district":"邗江区"},
{"code":321012,"province":"","city":"","district":"江都区"},
{"code":321023,"province":"","city":"","district":"宝应县"},
{"code":321081,"province":"","city":"","district":"仪征市"},
{"code":321084,"province":"","city":"","district":"高邮市"},
{"code":321100,"province":"","city":"镇江市","district":""},
{"code":321102,"province":"","city":"","district":"京口区"},
{"code":321111,"province":"","city":"","district":"润州区"},
{"code":321112,"province":"","city":"","district":"丹徒区"},
{"code":321181,"province":"","city":"","district":"丹阳市"},
{"code":321182,"province":"","city":"","district":"扬中市"},
{"code":321183,"province":"","city":"","district":"句容市"},
{"code":321200,"province":"","city":"泰州市","district":""},
{"code":321202,"province":"","city":"","district":"海陵区"},
{"code":321203,"province":"","city":"","district":"高港区"},
{"code":321204,"province":"","city":"","district":"姜堰区"},
{"code":321281,"province":"","city":"","district":"兴化市"},
{"code":321282,"province":"","city":"","district":"靖江市"},
{"code":321283,"province":"","city":"","district":"泰兴市"},
{"code":321300,"province":"","city":"宿迁市","district":""},
{"code":321302,"province":"","city":"","district":"宿城区"},
{"code":321311,"province":"","city":"","district":"宿豫区"},
{"code":321322,"province":"","city":"","district":"沭阳县"},
{"code":321323,"province":"","city":"","district":"泗阳县"},
{"code":321324,"province":"","city":"","district":"泗洪县"},
{"code":330000,"province":"浙江省","city":"","district":""},
{"code":330100,"province":"","city":"杭州市","district":""},
{"code":330102,"province":"","city":"","district":"上城区"},
{"code":330103,"province":"","city":"","district":"下城区"},
{"code":330104,"province":"","city":"","district":"江干区"},
{"code":330105,"province":"","city":"","district":"拱墅区"},
{"code":330106,"province":"","city":"","district":"西湖区"},
{"code":330108,"province":"","city":"","district":"滨江区"},
{"code":330109,"province":"","city":"","district":"萧山区"},
{"code":330110,"province":"","city":"","district":"余杭区"},
{"code":330111,"province":"","city":"","district":"富阳区"},
{"code":330122,"province":"","city":"","district":"桐庐县"},
{"code":330127,"province":"","city":"","district":"淳安县"},
{"code":330182,"province":"","city":"","district":"建德市"},
{"code":330112,"province":"","city":"","district":"临安区"},
{"code":330200,"province":"","city":"宁波市","district":""},
{"code":330203,"province":"","city":"","district":"海曙区"},
{"code":330205,"province":"","city":"","district":"江北区"},
{"code":330206,"province":"","city":"","district":"北仑区"},
{"code":330211,"province":"","city":"","district":"镇海区"},
{"code":330212,"province":"","city":"","district":"鄞州区"},
{"code":330213,"province":"","city":"","district":"奉化区"},
{"code":330225,"province":"","city":"","district":"象山县"},
{"code":330226,"province":"","city":"","district":"宁海县"},
{"code":330281,"province":"","city":"","district":"余姚市"},
{"code":330282,"province":"","city":"","district":"慈溪市"},
{"code":330300,"province":"","city":"温州市","district":""},
{"code":330302,"province":"","city":"","district":"鹿城区"},
{"code":330303,"province":"","city":"","district":"龙湾区"},
{"code":330304,"province":"","city":"","district":"瓯海区"},
{"code":330305,"province":"","city":"","district":"洞头区"},
{"code":330324,"province":"","city":"","district":"永嘉县"},
{"code":330326,"province":"","city":"","district":"平阳县"},
{"code":330327,"province":"","city":"","district":"苍南县"},
{"code":330328,"province":"","city":"","district":"文成县"},
{"code":330329,"province":"","city":"","district":"泰顺县"},
{"code":330381,"province":"","city":"","district":"瑞安市"},
{"code":330382,"province":"","city":"","district":"乐清市"},
{"code":330383,"province":"","city":"","district":"龙港市"},
{"code":330400,"province":"","city":"嘉兴市","district":""},
{"code":330402,"province":"","city":"","district":"南湖区"},
{"code":330411,"province":"","city":"","district":"秀洲区"},
{"code":330421,"province":"","city":"","district":"嘉善县"},
{"code":330424,"province":"","city":"","district":"海盐县"},
{"code":330481,"province":"","city":"","district":"海宁市"},
{"code":330482,"province":"","city":"","district":"平湖市"},
{"code":330483,"province":"","city":"","district":"桐乡市"},
{"code":330500,"province":"","city":"湖州市","district":""},
{"code":330502,"province":"","city":"","district":"吴兴区"},
{"code":330503,"province":"","city":"","district":"南浔区"},
{"code":330521,"province":"","city":"","district":"德清县"},
{"code":330522,"province":"","city":"","district":"长兴县"},
{"code":330523,"province":"","city":"","district":"安吉县"},
{"code":330600,"province":"","city":"绍兴市","district":""},
{"code":330602,"province":"","city":"","district":"越城区"},
{"code":330603,"province":"","city":"","district":"柯桥区"},
{"code":330604,"province":"","city":"","district":"上虞区"},
{"code":330624,"province":"","city":"","district":"新昌县"},
{"code":330681,"province":"","city":"","district":"诸暨市"},
{"code":330683,"province":"","city":"","district":"嵊州市"},
{"code":330700,"province":"","city":"金华市","district":""},
{"code":330702,"province":"","city":"","district":"婺城区"},
{"code":330703,"province":"","city":"","district":"金东区"},
{"code":330723,"province":"","city":"","district":"武义县"},
{"code":330726,"province":"","city":"","district":"浦江县"},
{"code":330727,"province":"","city":"","district":"磐安县"},
{"code":330781,"province":"","city":"","district":"兰溪市"},
{"code":330782,"province":"","city":"","district":"义乌市"},
{"code":330783,"province":"","city":"","district":"东阳市"},
{"code":330784,"province":"","city":"","district":"永康市"},
{"code":330800,"province":"","city":"衢州市","district":""},
{"code":330802,"province":"","city":"","district":"柯城区"},
{"code":330803,"province":"","city":"","district":"衢江区"},
{"code":330822,"province":"","city":"","district":"常山县"},
{"code":330824,"province":"","city":"","district":"开化县"},
{"code":330825,"province":"","city":"","district":"龙游县"},
{"code":330881,"province":"","city":"","district":"江山市"},
{"code":330900,"province":"","city":"舟山市","district":""},
{"code":330902,"province":"","city":"","district":"定海区"},
{"code":330903,"province":"","city":"","district":"普陀区"},
{"code":330921,"province":"","city":"","district":"岱山县"},
{"code":330922,"province":"","city":"","district":"嵊泗县"},
{"code":331000,"province":"","city":"台州市","district":""},
{"code":331002,"province":"","city":"","district":"椒江区"},
{"code":331003,"province":"","city":"","district":"黄岩区"},
{"code":331004,"province":"","city":"","district":"路桥区"},
{"code":331083,"province":"","city":"","district":"玉环市"},
{"code":331022,"province":"","city":"","district":"三门县"},
{"code":331023,"province":"","city":"","district":"天台县"},
{"code":331024,"province":"","city":"","district":"仙居县"},
{"code":331081,"province":"","city":"","district":"温岭市"},
{"code":331082,"province":"","city":"","district":"临海市"},
{"code":331100,"province":"","city":"丽水市","district":""},
{"code":331102,"province":"","city":"","district":"莲都区"},
{"code":331121,"province":"","city":"","district":"青田县"},
{"code":331122,"province":"","city":"","district":"缙云县"},
{"code":331123,"province":"","city":"","district":"遂昌县"},
{"code":331124,"province":"","city":"","district":"松阳县"},
{"code":331125,"province":"","city":"","district":"云和县"},
{"code":331126,"province":"","city":"","district":"庆元县"},
{"code":331127,"province":"","city":"","district":"景宁畲族自治县"},
{"code":331181,"province":"","city":"","district":"龙泉市"},
{"code":340000,"province":"安徽省","city":"","district":""},
{"code":340100,"province":"","city":"合肥市","district":""},
{"code":340102,"province":"","city":"","district":"瑶海区"},
{"code":340103,"province":"","city":"","district":"庐阳区"},
{"code":340104,"province":"","city":"","district":"蜀山区"},
{"code":340111,"province":"","city":"","district":"包河区"},
{"code":340121,"province":"","city":"","district":"长丰县"},
{"code":340122,"province":"","city":"","district":"肥东县"},
{"code":340123,"province":"","city":"","district":"肥西县"},
{"code":340124,"province":"","city":"","district":"庐江县"},
{"code":340181,"province":"","city":"","district":"巢湖市"},
{"code":340200,"province":"","city":"芜湖市","district":""},
{"code":340202,"province":"","city":"","district":"镜湖区"},
{"code":340203,"province":"","city":"","district":"弋江区"},
{"code":340207,"province":"","city":"","district":"鸠江区"},
{"code":340208,"province":"","city":"","district":"三山区"},
{"code":340221,"province":"","city":"","district":"芜湖县"},
{"code":340222,"province":"","city":"","district":"繁昌县"},
{"code":340223,"province":"","city":"","district":"南陵县"},
{"code":340281,"province":"","city":"","district":"无为市"},
{"code":340300,"province":"","city":"蚌埠市","district":""},
{"code":340302,"province":"","city":"","district":"龙子湖区"},
{"code":340303,"province":"","city":"","district":"蚌山区"},
{"code":340304,"province":"","city":"","district":"禹会区"},
{"code":340311,"province":"","city":"","district":"淮上区"},
{"code":340321,"province":"","city":"","district":"怀远县"},
{"code":340322,"province":"","city":"","district":"五河县"},
{"code":340323,"province":"","city":"","district":"固镇县"},
{"code":340400,"province":"","city":"淮南市","district":""},
{"code":340402,"province":"","city":"","district":"大通区"},
{"code":340403,"province":"","city":"","district":"田家庵区"},
{"code":340404,"province":"","city":"","district":"谢家集区"},
{"code":340405,"province":"","city":"","district":"八公山区"},
{"code":340406,"province":"","city":"","district":"潘集区"},
{"code":340421,"province":"","city":"","district":"凤台县"},
{"code":340422,"province":"","city":"","district":"寿县"},
{"code":340500,"province":"","city":"马鞍山市","district":""},
{"code":340503,"province":"","city":"","district":"花山区"},
{"code":340504,"province":"","city":"","district":"雨山区"},
{"code":340506,"province":"","city":"","district":"博望区"},
{"code":340521,"province":"","city":"","district":"当涂县"},
{"code":340522,"province":"","city":"","district":"含山县"},
{"code":340523,"province":"","city":"","district":"和县"},
{"code":340600,"province":"","city":"淮北市","district":""},
{"code":340602,"province":"","city":"","district":"杜集区"},
{"code":340603,"province":"","city":"","district":"相山区"},
{"code":340604,"province":"","city":"","district":"烈山区"},
{"code":340621,"province":"","city":"","district":"濉溪县"},
{"code":340700,"province":"","city":"铜陵市","district":""},
{"code":340705,"province":"","city":"","district":"铜官区"},
{"code":340706,"province":"","city":"","district":"义安区"},
{"code":340711,"province":"","city":"","district":"郊区"},
{"code":340722,"province":"","city":"","district":"枞阳县"},
{"code":340800,"province":"","city":"安庆市","district":""},
{"code":340802,"province":"","city":"","district":"迎江区"},
{"code":340803,"province":"","city":"","district":"大观区"},
{"code":340811,"province":"","city":"","district":"宜秀区"},
{"code":340822,"province":"","city":"","district":"怀宁县"},
{"code":340882,"province":"","city":"","district":"潜山市"},
{"code":340825,"province":"","city":"","district":"太湖县"},
{"code":340826,"province":"","city":"","district":"宿松县"},
{"code":340827,"province":"","city":"","district":"望江县"},
{"code":340828,"province":"","city":"","district":"岳西县"},
{"code":340881,"province":"","city":"","district":"桐城市"},
{"code":341000,"province":"","city":"黄山市","district":""},
{"code":341002,"province":"","city":"","district":"屯溪区"},
{"code":341003,"province":"","city":"","district":"黄山区"},
{"code":341004,"province":"","city":"","district":"徽州区"},
{"code":341021,"province":"","city":"","district":"歙县"},
{"code":341022,"province":"","city":"","district":"休宁县"},
{"code":341023,"province":"","city":"","district":"黟县"},
{"code":341024,"province":"","city":"","district":"祁门县"},
{"code":341100,"province":"","city":"滁州市","district":""},
{"code":341102,"province":"","city":"","district":"琅琊区"},
{"code":341103,"province":"","city":"","district":"南谯区"},
{"code":341122,"province":"","city":"","district":"来安县"},
{"code":341124,"province":"","city":"","district":"全椒县"},
{"code":341125,"province":"","city":"","district":"定远县"},
{"code":341126,"province":"","city":"","district":"凤阳县"},
{"code":341181,"province":"","city":"","district":"天长市"},
{"code":341182,"province":"","city":"","district":"明光市"},
{"code":341200,"province":"","city":"阜阳市","district":""},
{"code":341202,"province":"","city":"","district":"颍州区"},
{"code":341203,"province":"","city":"","district":"颍东区"},
{"code":341204,"province":"","city":"","district":"颍泉区"},
{"code":341221,"province":"","city":"","district":"临泉县"},
{"code":341222,"province":"","city":"","district":"太和县"},
{"code":341225,"province":"","city":"","district":"阜南县"},
{"code":341226,"province":"","city":"","district":"颍上县"},
{"code":341282,"province":"","city":"","district":"界首市"},
{"code":341300,"province":"","city":"宿州市","district":""},
{"code":341302,"province":"","city":"","district":"埇桥区"},
{"code":341321,"province":"","city":"","district":"砀山县"},
{"code":341322,"province":"","city":"","district":"萧县"},
{"code":341323,"province":"","city":"","district":"灵璧县"},
{"code":341324,"province":"","city":"","district":"泗县"},
{"code":341500,"province":"","city":"六安市","district":""},
{"code":341502,"province":"","city":"","district":"金安区"},
{"code":341503,"province":"","city":"","district":"裕安区"},
{"code":341504,"province":"","city":"","district":"叶集区"},
{"code":341522,"province":"","city":"","district":"霍邱县"},
{"code":341523,"province":"","city":"","district":"舒城县"},
{"code":341524,"province":"","city":"","district":"金寨县"},
{"code":341525,"province":"","city":"","district":"霍山县"},
{"code":341600,"province":"","city":"亳州市","district":""},
{"code":341602,"province":"","city":"","district":"谯城区"},
{"code":341621,"province":"","city":"","district":"涡阳县"},
{"code":341622,"province":"","city":"","district":"蒙城县"},
{"code":341623,"province":"","city":"","district":"利辛县"},
{"code":341700,"province":"","city":"池州市","district":""},
{"code":341702,"province":"","city":"","district":"贵池区"},
{"code":341721,"province":"","city":"","district":"东至县"},
{"code":341722,"province":"","city":"","district":"石台县"},
{"code":341723,"province":"","city":"","district":"青阳县"},
{"code":341800,"province":"","city":"宣城市","district":""},
{"code":341802,"province":"","city":"","district":"宣州区"},
{"code":341821,"province":"","city":"","district":"郎溪县"},
{"code":341823,"province":"","city":"","district":"泾县"},
{"code":341824,"province":"","city":"","district":"绩溪县"},
{"code":341825,"province":"","city":"","district":"旌德县"},
{"code":341881,"province":"","city":"","district":"宁国市"},
{"code":341882,"province":"","city":"","district":"广德市"},
{"code":350000,"province":"福建省","city":"","district":""},
{"code":350100,"province":"","city":"福州市","district":""},
{"code":350102,"province":"","city":"","district":"鼓楼区"},
{"code":350103,"province":"","city":"","district":"台江区"},
{"code":350104,"province":"","city":"","district":"仓山区"},
{"code":350105,"province":"","city":"","district":"马尾区"},
{"code":350111,"province":"","city":"","district":"晋安区"},
{"code":350121,"province":"","city":"","district":"闽侯县"},
{"code":350122,"province":"","city":"","district":"连江县"},
{"code":350123,"province":"","city":"","district":"罗源县"},
{"code":350124,"province":"","city":"","district":"闽清县"},
{"code":350125,"province":"","city":"","district":"永泰县"},
{"code":350128,"province":"","city":"","district":"平潭县"},
{"code":350181,"province":"","city":"","district":"福清市"},
{"code":350112,"province":"","city":"","district":"长乐区"},
{"code":350200,"province":"","city":"厦门市","district":""},
{"code":350203,"province":"","city":"","district":"思明区"},
{"code":350205,"province":"","city":"","district":"海沧区"},
{"code":350206,"province":"","city":"","district":"湖里区"},
{"code":350211,"province":"","city":"","district":"集美区"},
{"code":350212,"province":"","city":"","district":"同安区"},
{"code":350213,"province":"","city":"","district":"翔安区"},
{"code":350300,"province":"","city":"莆田市","district":""},
{"code":350302,"province":"","city":"","district":"城厢区"},
{"code":350303,"province":"","city":"","district":"涵江区"},
{"code":350304,"province":"","city":"","district":"荔城区"},
{"code":350305,"province":"","city":"","district":"秀屿区"},
{"code":350322,"province":"","city":"","district":"仙游县"},
{"code":350400,"province":"","city":"三明市","district":""},
{"code":350402,"province":"","city":"","district":"梅列区"},
{"code":350403,"province":"","city":"","district":"三元区"},
{"code":350421,"province":"","city":"","district":"明溪县"},
{"code":350423,"province":"","city":"","district":"清流县"},
{"code":350424,"province":"","city":"","district":"宁化县"},
{"code":350425,"province":"","city":"","district":"大田县"},
{"code":350426,"province":"","city":"","district":"尤溪县"},
{"code":350427,"province":"","city":"","district":"沙县"},
{"code":350428,"province":"","city":"","district":"将乐县"},
{"code":350429,"province":"","city":"","district":"泰宁县"},
{"code":350430,"province":"","city":"","district":"建宁县"},
{"code":350481,"province":"","city":"","district":"永安市"},
{"code":350500,"province":"","city":"泉州市","district":""},
{"code":350502,"province":"","city":"","district":"鲤城区"},
{"code":350503,"province":"","city":"","district":"丰泽区"},
{"code":350504,"province":"","city":"","district":"洛江区"},
{"code":350505,"province":"","city":"","district":"泉港区"},
{"code":350521,"province":"","city":"","district":"惠安县"},
{"code":350524,"province":"","city":"","district":"安溪县"},
{"code":350525,"province":"","city":"","district":"永春县"},
{"code":350526,"province":"","city":"","district":"德化县"},
{"code":350527,"province":"","city":"","district":"金门县"},
{"code":350581,"province":"","city":"","district":"石狮市"},
{"code":350582,"province":"","city":"","district":"晋江市"},
{"code":350583,"province":"","city":"","district":"南安市"},
{"code":350600,"province":"","city":"漳州市","district":""},
{"code":350602,"province":"","city":"","district":"芗城区"},
{"code":350603,"province":"","city":"","district":"龙文区"},
{"code":350622,"province":"","city":"","district":"云霄县"},
{"code":350623,"province":"","city":"","district":"漳浦县"},
{"code":350624,"province":"","city":"","district":"诏安县"},
{"code":350625,"province":"","city":"","district":"长泰县"},
{"code":350626,"province":"","city":"","district":"东山县"},
{"code":350627,"province":"","city":"","district":"南靖县"},
{"code":350628,"province":"","city":"","district":"平和县"},
{"code":350629,"province":"","city":"","district":"华安县"},
{"code":350681,"province":"","city":"","district":"龙海市"},
{"code":350700,"province":"","city":"南平市","district":""},
{"code":350702,"province":"","city":"","district":"延平区"},
{"code":350703,"province":"","city":"","district":"建阳区"},
{"code":350721,"province":"","city":"","district":"顺昌县"},
{"code":350722,"province":"","city":"","district":"浦城县"},
{"code":350723,"province":"","city":"","district":"光泽县"},
{"code":350724,"province":"","city":"","district":"松溪县"},
{"code":350725,"province":"","city":"","district":"政和县"},
{"code":350781,"province":"","city":"","district":"邵武市"},
{"code":350782,"province":"","city":"","district":"武夷山市"},
{"code":350783,"province":"","city":"","district":"建瓯市"},
{"code":350800,"province":"","city":"龙岩市","district":""},
{"code":350802,"province":"","city":"","district":"新罗区"},
{"code":350803,"province":"","city":"","district":"永定区"},
{"code":350821,"province":"","city":"","district":"长汀县"},
{"code":350823,"province":"","city":"","district":"上杭县"},
{"code":350824,"province":"","city":"","district":"武平县"},
{"code":350825,"province":"","city":"","district":"连城县"},
{"code":350881,"province":"","city":"","district":"漳平市"},
{"code":350900,"province":"","city":"宁德市","district":""},
{"code":350902,"province":"","city":"","district":"蕉城区"},
{"code":350921,"province":"","city":"","district":"霞浦县"},
{"code":350922,"province":"","city":"","district":"古田县"},
{"code":350923,"province":"","city":"","district":"屏南县"},
{"code":350924,"province":"","city":"","district":"寿宁县"},
{"code":350925,"province":"","city":"","district":"周宁县"},
{"code":350926,"province":"","city":"","district":"柘荣县"},
{"code":350981,"province":"","city":"","district":"福安市"},
{"code":350982,"province":"","city":"","district":"福鼎市"},
{"code":360000,"province":"江西省","city":"","district":""},
{"code":360100,"province":"","city":"南昌市","district":""},
{"code":360102,"province":"","city":"","district":"东湖区"},
{"code":360103,"province":"","city":"","district":"西湖区"},
{"code":360104,"province":"","city":"","district":"青云谱区"},
{"code":360111,"province":"","city":"","district":"青山湖区"},
{"code":360112,"province":"","city":"","district":"新建区"},
{"code":360113,"province":"","city":"","district":"红谷滩区"},
{"code":360121,"province":"","city":"","district":"南昌县"},
{"code":360123,"province":"","city":"","district":"安义县"},
{"code":360124,"province":"","city":"","district":"进贤县"},
{"code":360200,"province":"","city":"景德镇市","district":""},
{"code":360202,"province":"","city":"","district":"昌江区"},
{"code":360203,"province":"","city":"","district":"珠山区"},
{"code":360222,"province":"","city":"","district":"浮梁县"},
{"code":360281,"province":"","city":"","district":"乐平市"},
{"code":360300,"province":"","city":"萍乡市","district":""},
{"code":360302,"province":"","city":"","district":"安源区"},
{"code":360313,"province":"","city":"","district":"湘东区"},
{"code":360321,"province":"","city":"","district":"莲花县"},
{"code":360322,"province":"","city":"","district":"上栗县"},
{"code":360323,"province":"","city":"","district":"芦溪县"},
{"code":360400,"province":"","city":"九江市","district":""},
{"code":360402,"province":"","city":"","district":"濂溪区"},
{"code":360403,"province":"","city":"","district":"浔阳区"},
{"code":360404,"province":"","city":"","district":"柴桑区"},
{"code":360423,"province":"","city":"","district":"武宁县"},
{"code":360424,"province":"","city":"","district":"修水县"},
{"code":360425,"province":"","city":"","district":"永修县"},
{"code":360426,"province":"","city":"","district":"德安县"},
{"code":360483,"province":"","city":"","district":"庐山市"},
{"code":360428,"province":"","city":"","district":"都昌县"},
{"code":360429,"province":"","city":"","district":"湖口县"},
{"code":360430,"province":"","city":"","district":"彭泽县"},
{"code":360481,"province":"","city":"","district":"瑞昌市"},
{"code":360482,"province":"","city":"","district":"共青城市"},
{"code":360500,"province":"","city":"新余市","district":""},
{"code":360502,"province":"","city":"","district":"渝水区"},
{"code":360521,"province":"","city":"","district":"分宜县"},
{"code":360600,"province":"","city":"鹰潭市","district":""},
{"code":360602,"province":"","city":"","district":"月湖区"},
{"code":360603,"province":"","city":"","district":"余江区"},
{"code":360681,"province":"","city":"","district":"贵溪市"},
{"code":360700,"province":"","city":"赣州市","district":""},
{"code":360702,"province":"","city":"","district":"章贡区"},
{"code":360703,"province":"","city":"","district":"南康区"},
{"code":360704,"province":"","city":"","district":"赣县区"},
{"code":360722,"province":"","city":"","district":"信丰县"},
{"code":360723,"province":"","city":"","district":"大余县"},
{"code":360724,"province":"","city":"","district":"上犹县"},
{"code":360725,"province":"","city":"","district":"崇义县"},
{"code":360726,"province":"","city":"","district":"安远县"},
{"code":360727,"province":"","city":"","district":"龙南县"},
{"code":360728,"province":"","city":"","district":"定南县"},
{"code":360729,"province":"","city":"","district":"全南县"},
{"code":360730,"province":"","city":"","district":"宁都县"},
{"code":360731,"province":"","city":"","district":"于都县"},
{"code":360732,"province":"","city":"","district":"兴国县"},
{"code":360733,"province":"","city":"","district":"会昌县"},
{"code":360734,"province":"","city":"","district":"寻乌县"},
{"code":360735,"province":"","city":"","district":"石城县"},
{"code":360781,"province":"","city":"","district":"瑞金市"},
{"code":360800,"province":"","city":"吉安市","district":""},
{"code":360802,"province":"","city":"","district":"吉州区"},
{"code":360803,"province":"","city":"","district":"青原区"},
{"code":360821,"province":"","city":"","district":"吉安县"},
{"code":360822,"province":"","city":"","district":"吉水县"},
{"code":360823,"province":"","city":"","district":"峡江县"},
{"code":360824,"province":"","city":"","district":"新干县"},
{"code":360825,"province":"","city":"","district":"永丰县"},
{"code":360826,"province":"","city":"","district":"泰和县"},
{"code":360827,"province":"","city":"","district":"遂川县"},
{"code":360828,"province":"","city":"","district":"万安县"},
{"code":360829,"province":"","city":"","district":"安福县"},
{"code":360830,"province":"","city":"","district":"永新县"},
{"code":360881,"province":"","city":"","district":"井冈山市"},
{"code":360900,"province":"","city":"宜春市","district":""},
{"code":360902,"province":"","city":"","district":"袁州区"},
{"code":360921,"province":"","city":"","district":"奉新县"},
{"code":360922,"province":"","city":"","district":"万载县"},
{"code":360923,"province":"","city":"","district":"上高县"},
{"code":360924,"province":"","city":"","district":"宜丰县"},
{"code":360925,"province":"","city":"","district":"靖安县"},
{"code":360926,"province":"","city":"","district":"铜鼓县"},
{"code":360981,"province":"","city":"","district":"丰城市"},
{"code":360982,"province":"","city":"","district":"樟树市"},
{"code":360983,"province":"","city":"","district":"高安市"},
{"code":361000,"province":"","city":"抚州市","district":""},
{"code":361002,"province":"","city":"","district":"临川区"},
{"code":361021,"province":"","city":"","district":"南城县"},
{"code":361022,"province":"","city":"","district":"黎川县"},
{"code":361023,"province":"","city":"","district":"南丰县"},
{"code":361024,"province":"","city":"","district":"崇仁县"},
{"code":361025,"province":"","city":"","district":"乐安县"},
{"code":361026,"province":"","city":"","district":"宜黄县"},
{"code":361027,"province":"","city":"","district":"金溪县"},
{"code":361028,"province":"","city":"","district":"资溪县"},
{"code":361003,"province":"","city":"","district":"东乡区"},
{"code":361030,"province":"","city":"","district":"广昌县"},
{"code":361100,"province":"","city":"上饶市","district":""},
{"code":361102,"province":"","city":"","district":"信州区"},
{"code":361103,"province":"","city":"","district":"广丰区"},
{"code":361104,"province":"","city":"","district":"广信区"},
{"code":361123,"province":"","city":"","district":"玉山县"},
{"code":361124,"province":"","city":"","district":"铅山县"},
{"code":361125,"province":"","city":"","district":"横峰县"},
{"code":361126,"province":"","city":"","district":"弋阳县"},
{"code":361127,"province":"","city":"","district":"余干县"},
{"code":361128,"province":"","city":"","district":"鄱阳县"},
{"code":361129,"province":"","city":"","district":"万年县"},
{"code":361130,"province":"","city":"","district":"婺源县"},
{"code":361181,"province":"","city":"","district":"德兴市"},
{"code":370000,"province":"山东省","city":"","district":""},
{"code":370100,"province":"","city":"济南市","district":""},
{"code":370102,"province":"","city":"","district":"历下区"},
{"code":370103,"province":"","city":"","district":"市中区"},
{"code":370104,"province":"","city":"","district":"槐荫区"},
{"code":370105,"province":"","city":"","district":"天桥区"},
{"code":370112,"province":"","city":"","district":"历城区"},
{"code":370113,"province":"","city":"","district":"长清区"},
{"code":370124,"province":"","city":"","district":"平阴县"},
{"code":370115,"province":"","city":"","district":"济阳区"},
{"code":370126,"province":"","city":"","district":"商河县"},
{"code":370114,"province":"","city":"","district":"章丘区"},
{"code":370116,"province":"","city":"","district":"莱芜区"},
{"code":370117,"province":"","city":"","district":"钢城区"},
{"code":370200,"province":"","city":"青岛市","district":""},
{"code":370202,"province":"","city":"","district":"市南区"},
{"code":370203,"province":"","city":"","district":"市北区"},
{"code":370211,"province":"","city":"","district":"黄岛区"},
{"code":370212,"province":"","city":"","district":"崂山区"},
{"code":370213,"province":"","city":"","district":"李沧区"},
{"code":370214,"province":"","city":"","district":"城阳区"},
{"code":370215,"province":"","city":"","district":"即墨区"},
{"code":370281,"province":"","city":"","district":"胶州市"},
{"code":370283,"province":"","city":"","district":"平度市"},
{"code":370285,"province":"","city":"","district":"莱西市"},
{"code":370300,"province":"","city":"淄博市","district":""},
{"code":370302,"province":"","city":"","district":"淄川区"},
{"code":370303,"province":"","city":"","district":"张店区"},
{"code":370304,"province":"","city":"","district":"博山区"},
{"code":370305,"province":"","city":"","district":"临淄区"},
{"code":370306,"province":"","city":"","district":"周村区"},
{"code":370321,"province":"","city":"","district":"桓台县"},
{"code":370322,"province":"","city":"","district":"高青县"},
{"code":370323,"province":"","city":"","district":"沂源县"},
{"code":370400,"province":"","city":"枣庄市","district":""},
{"code":370402,"province":"","city":"","district":"市中区"},
{"code":370403,"province":"","city":"","district":"薛城区"},
{"code":370404,"province":"","city":"","district":"峄城区"},
{"code":370405,"province":"","city":"","district":"台儿庄区"},
{"code":370406,"province":"","city":"","district":"山亭区"},
{"code":370481,"province":"","city":"","district":"滕州市"},
{"code":370500,"province":"","city":"东营市","district":""},
{"code":370502,"province":"","city":"","district":"东营区"},
{"code":370503,"province":"","city":"","district":"河口区"},
{"code":370505,"province":"","city":"","district":"垦利区"},
{"code":370522,"province":"","city":"","district":"利津县"},
{"code":370523,"province":"","city":"","district":"广饶县"},
{"code":370600,"province":"","city":"烟台市","district":""},
{"code":370602,"province":"","city":"","district":"芝罘区"},
{"code":370611,"province":"","city":"","district":"福山区"},
{"code":370612,"province":"","city":"","district":"牟平区"},
{"code":370613,"province":"","city":"","district":"莱山区"},
{"code":370634,"province":"","city":"","district":"长岛县"},
{"code":370681,"province":"","city":"","district":"龙口市"},
{"code":370682,"province":"","city":"","district":"莱阳市"},
{"code":370683,"province":"","city":"","district":"莱州市"},
{"code":370684,"province":"","city":"","district":"蓬莱市"},
{"code":370685,"province":"","city":"","district":"招远市"},
{"code":370686,"province":"","city":"","district":"栖霞市"},
{"code":370687,"province":"","city":"","district":"海阳市"},
{"code":370700,"province":"","city":"潍坊市","district":""},
{"code":370702,"province":"","city":"","district":"潍城区"},
{"code":370703,"province":"","city":"","district":"寒亭区"},
{"code":370704,"province":"","city":"","district":"坊子区"},
{"code":370705,"province":"","city":"","district":"奎文区"},
{"code":370724,"province":"","city":"","district":"临朐县"},
{"code":370725,"province":"","city":"","district":"昌乐县"},
{"code":370781,"province":"","city":"","district":"青州市"},
{"code":370782,"province":"","city":"","district":"诸城市"},
{"code":370783,"province":"","city":"","district":"寿光市"},
{"code":370784,"province":"","city":"","district":"安丘市"},
{"code":370785,"province":"","city":"","district":"高密市"},
{"code":370786,"province":"","city":"","district":"昌邑市"},
{"code":370800,"province":"","city":"济宁市","district":""},
{"code":370811,"province":"","city":"","district":"任城区"},
{"code":370812,"province":"","city":"","district":"兖州区"},
{"code":370826,"province":"","city":"","district":"微山县"},
{"code":370827,"province":"","city":"","district":"鱼台县"},
{"code":370828,"province":"","city":"","district":"金乡县"},
{"code":370829,"province":"","city":"","district":"嘉祥县"},
{"code":370830,"province":"","city":"","district":"汶上县"},
{"code":370831,"province":"","city":"","district":"泗水县"},
{"code":370832,"province":"","city":"","district":"梁山县"},
{"code":370881,"province":"","city":"","district":"曲阜市"},
{"code":370883,"province":"","city":"","district":"邹城市"},
{"code":370900,"province":"","city":"泰安市","district":""},
{"code":370902,"province":"","city":"","district":"泰山区"},
{"code":370911,"province":"","city":"","district":"岱岳区"},
{"code":370921,"province":"","city":"","district":"宁阳县"},
{"code":370923,"province":"","city":"","district":"东平县"},
{"code":370982,"province":"","city":"","district":"新泰市"},
{"code":370983,"province":"","city":"","district":"肥城市"},
{"code":371000,"province":"","city":"威海市","district":""},
{"code":371002,"province":"","city":"","district":"环翠区"},
{"code":371003,"province":"","city":"","district":"文登区"},
{"code":371082,"province":"","city":"","district":"荣成市"},
{"code":371083,"province":"","city":"","district":"乳山市"},
{"code":371100,"province":"","city":"日照市","district":""},
{"code":371102,"province":"","city":"","district":"东港区"},
{"code":371103,"province":"","city":"","district":"岚山区"},
{"code":371121,"province":"","city":"","district":"五莲县"},
{"code":371122,"province":"","city":"","district":"莒县"},
{"code":371300,"province":"","city":"临沂市","district":""},
{"code":371302,"province":"","city":"","district":"兰山区"},
{"code":371311,"province":"","city":"","district":"罗庄区"},
{"code":371312,"province":"","city":"","district":"河东区"},
{"code":371321,"province":"","city":"","district":"沂南县"},
{"code":371322,"province":"","city":"","district":"郯城县"},
{"code":371323,"province":"","city":"","district":"沂水县"},
{"code":371324,"province":"","city":"","district":"兰陵县"},
{"code":371325,"province":"","city":"","district":"费县"},
{"code":371326,"province":"","city":"","district":"平邑县"},
{"code":371327,"province":"","city":"","district":"莒南县"},
{"code":371328,"province":"","city":"","district":"蒙阴县"},
{"code":371329,"province":"","city":"","district":"临沭县"},
{"code":371400,"province":"","city":"德州市","district":""},
{"code":371402,"province":"","city":"","district":"德城区"},
{"code":371403,"province":"","city":"","district":"陵城区"},
{"code":371422,"province":"","city":"","district":"宁津县"},
{"code":371423,"province":"","city":"","district":"庆云县"},
{"code":371424,"province":"","city":"","district":"临邑县"},
{"code":371425,"province":"","city":"","district":"齐河县"},
{"code":371426,"province":"","city":"","district":"平原县"},
{"code":371427,"province":"","city":"","district":"夏津县"},
{"code":371428,"province":"","city":"","district":"武城县"},
{"code":371481,"province":"","city":"","district":"乐陵市"},
{"code":371482,"province":"","city":"","district":"禹城市"},
{"code":371500,"province":"","city":"聊城市","district":""},
{"code":371502,"province":"","city":"","district":"东昌府区"},
{"code":371503,"province":"","city":"","district":"茌平区"},
{"code":371521,"province":"","city":"","district":"阳谷县"},
{"code":371522,"province":"","city":"","district":"莘县"},
{"code":371524,"province":"","city":"","district":"东阿县"},
{"code":371525,"province":"","city":"","district":"冠县"},
{"code":371526,"province":"","city":"","district":"高唐县"},
{"code":371581,"province":"","city":"","district":"临清市"},
{"code":371600,"province":"","city":"滨州市","district":""},
{"code":371602,"province":"","city":"","district":"滨城区"},
{"code":371603,"province":"","city":"","district":"沾化区"},
{"code":371621,"province":"","city":"","district":"惠民县"},
{"code":371622,"province":"","city":"","district":"阳信县"},
{"code":371623,"province":"","city":"","district":"无棣县"},
{"code":371625,"province":"","city":"","district":"博兴县"},
{"code":371681,"province":"","city":"","district":"邹平市"},
{"code":371700,"province":"","city":"菏泽市","district":""},
{"code":371702,"province":"","city":"","district":"牡丹区"},
{"code":371703,"province":"","city":"","district":"定陶区"},
{"code":371721,"province":"","city":"","district":"曹县"},
{"code":371722,"province":"","city":"","district":"单县"},
{"code":371723,"province":"","city":"","district":"成武县"},
{"code":371724,"province":"","city":"","district":"巨野县"},
{"code":371725,"province":"","city":"","district":"郓城县"},
{"code":371726,"province":"","city":"","district":"鄄城县"},
{"code":371728,"province":"","city":"","district":"东明县"},
{"code":410000,"province":"河南省","city":"","district":""},
{"code":410100,"province":"","city":"郑州市","district":""},
{"code":410102,"province":"","city":"","district":"中原区"},
{"code":410103,"province":"","city":"","district":"二七区"},
{"code":410104,"province":"","city":"","district":"管城回族区"},
{"code":410105,"province":"","city":"","district":"金水区"},
{"code":410106,"province":"","city":"","district":"上街区"},
{"code":410108,"province":"","city":"","district":"惠济区"},
{"code":410122,"province":"","city":"","district":"中牟县"},
{"code":410181,"province":"","city":"","district":"巩义市"},
{"code":410182,"province":"","city":"","district":"荥阳市"},
{"code":410183,"province":"","city":"","district":"新密市"},
{"code":410184,"province":"","city":"","district":"新郑市"},
{"code":410185,"province":"","city":"","district":"登封市"},
{"code":410200,"province":"","city":"开封市","district":""},
{"code":410202,"province":"","city":"","district":"龙亭区"},
{"code":410203,"province":"","city":"","district":"顺河回族区"},
{"code":410204,"province":"","city":"","district":"鼓楼区"},
{"code":410205,"province":"","city":"","district":"禹王台区"},
{"code":410212,"province":"","city":"","district":"祥符区"},
{"code":410221,"province":"","city":"","district":"杞县"},
{"code":410222,"province":"","city":"","district":"通许县"},
{"code":410223,"province":"","city":"","district":"尉氏县"},
{"code":410225,"province":"","city":"","district":"兰考县"},
{"code":410300,"province":"","city":"洛阳市","district":""},
{"code":410302,"province":"","city":"","district":"老城区"},
{"code":410303,"province":"","city":"","district":"西工区"},
{"code":410304,"province":"","city":"","district":"瀍河回族区"},
{"code":410305,"province":"","city":"","district":"涧西区"},
{"code":410306,"province":"","city":"","district":"吉利区"},
{"code":410311,"province":"","city":"","district":"洛龙区"},
{"code":410322,"province":"","city":"","district":"孟津县"},
{"code":410323,"province":"","city":"","district":"新安县"},
{"code":410324,"province":"","city":"","district":"栾川县"},
{"code":410325,"province":"","city":"","district":"嵩县"},
{"code":410326,"province":"","city":"","district":"汝阳县"},
{"code":410327,"province":"","city":"","district":"宜阳县"},
{"code":410328,"province":"","city":"","district":"洛宁县"},
{"code":410329,"province":"","city":"","district":"伊川县"},
{"code":410381,"province":"","city":"","district":"偃师市"},
{"code":410400,"province":"","city":"平顶山市","district":""},
{"code":410402,"province":"","city":"","district":"新华区"},
{"code":410403,"province":"","city":"","district":"卫东区"},
{"code":410404,"province":"","city":"","district":"石龙区"},
{"code":410411,"province":"","city":"","district":"湛河区"},
{"code":410421,"province":"","city":"","district":"宝丰县"},
{"code":410422,"province":"","city":"","district":"叶县"},
{"code":410423,"province":"","city":"","district":"鲁山县"},
{"code":410425,"province":"","city":"","district":"郏县"},
{"code":410481,"province":"","city":"","district":"舞钢市"},
{"code":410482,"province":"","city":"","district":"汝州市"},
{"code":410500,"province":"","city":"安阳市","district":""},
{"code":410502,"province":"","city":"","district":"文峰区"},
{"code":410503,"province":"","city":"","district":"北关区"},
{"code":410505,"province":"","city":"","district":"殷都区"},
{"code":410506,"province":"","city":"","district":"龙安区"},
{"code":410522,"province":"","city":"","district":"安阳县"},
{"code":410523,"province":"","city":"","district":"汤阴县"},
{"code":410526,"province":"","city":"","district":"滑县"},
{"code":410527,"province":"","city":"","district":"内黄县"},
{"code":410581,"province":"","city":"","district":"林州市"},
{"code":410600,"province":"","city":"鹤壁市","district":""},
{"code":410602,"province":"","city":"","district":"鹤山区"},
{"code":410603,"province":"","city":"","district":"山城区"},
{"code":410611,"province":"","city":"","district":"淇滨区"},
{"code":410621,"province":"","city":"","district":"浚县"},
{"code":410622,"province":"","city":"","district":"淇县"},
{"code":410700,"province":"","city":"新乡市","district":""},
{"code":410702,"province":"","city":"","district":"红旗区"},
{"code":410703,"province":"","city":"","district":"卫滨区"},
{"code":410704,"province":"","city":"","district":"凤泉区"},
{"code":410711,"province":"","city":"","district":"牧野区"},
{"code":410721,"province":"","city":"","district":"新乡县"},
{"code":410724,"province":"","city":"","district":"获嘉县"},
{"code":410725,"province":"","city":"","district":"原阳县"},
{"code":410726,"province":"","city":"","district":"延津县"},
{"code":410727,"province":"","city":"","district":"封丘县"},
{"code":410781,"province":"","city":"","district":"卫辉市"},
{"code":410782,"province":"","city":"","district":"辉县市"},
{"code":410783,"province":"","city":"","district":"长垣市"},
{"code":410800,"province":"","city":"焦作市","district":""},
{"code":410802,"province":"","city":"","district":"解放区"},
{"code":410803,"province":"","city":"","district":"中站区"},
{"code":410804,"province":"","city":"","district":"马村区"},
{"code":410811,"province":"","city":"","district":"山阳区"},
{"code":410821,"province":"","city":"","district":"修武县"},
{"code":410822,"province":"","city":"","district":"博爱县"},
{"code":410823,"province":"","city":"","district":"武陟县"},
{"code":410825,"province":"","city":"","district":"温县"},
{"code":410882,"province":"","city":"","district":"沁阳市"},
{"code":410883,"province":"","city":"","district":"孟州市"},
{"code":410900,"province":"","city":"濮阳市","district":""},
{"code":410902,"province":"","city":"","district":"华龙区"},
{"code":410922,"province":"","city":"","district":"清丰县"},
{"code":410923,"province":"","city":"","district":"南乐县"},
{"code":410926,"province":"","city":"","district":"范县"},
{"code":410927,"province":"","city":"","district":"台前县"},
{"code":410928,"province":"","city":"","district":"濮阳县"},
{"code":411000,"province":"","city":"许昌市","district":""},
{"code":411002,"province":"","city":"","district":"魏都区"},
{"code":411003,"province":"","city":"","district":"建安区"},
{"code":411024,"province":"","city":"","district":"鄢陵县"},
{"code":411025,"province":"","city":"","district":"襄城县"},
{"code":411081,"province":"","city":"","district":"禹州市"},
{"code":411082,"province":"","city":"","district":"长葛市"},
{"code":411100,"province":"","city":"漯河市","district":""},
{"code":411102,"province":"","city":"","district":"源汇区"},
{"code":411103,"province":"","city":"","district":"郾城区"},
{"code":411104,"province":"","city":"","district":"召陵区"},
{"code":411121,"province":"","city":"","district":"舞阳县"},
{"code":411122,"province":"","city":"","district":"临颍县"},
{"code":411200,"province":"","city":"三门峡市","district":""},
{"code":411202,"province":"","city":"","district":"湖滨区"},
{"code":411203,"province":"","city":"","district":"陕州区"},
{"code":411221,"province":"","city":"","district":"渑池县"},
{"code":411224,"province":"","city":"","district":"卢氏县"},
{"code":411281,"province":"","city":"","district":"义马市"},
{"code":411282,"province":"","city":"","district":"灵宝市"},
{"code":411300,"province":"","city":"南阳市","district":""},
{"code":411302,"province":"","city":"","district":"宛城区"},
{"code":411303,"province":"","city":"","district":"卧龙区"},
{"code":411321,"province":"","city":"","district":"南召县"},
{"code":411322,"province":"","city":"","district":"方城县"},
{"code":411323,"province":"","city":"","district":"西峡县"},
{"code":411324,"province":"","city":"","district":"镇平县"},
{"code":411325,"province":"","city":"","district":"内乡县"},
{"code":411326,"province":"","city":"","district":"淅川县"},
{"code":411327,"province":"","city":"","district":"社旗县"},
{"code":411328,"province":"","city":"","district":"唐河县"},
{"code":411329,"province":"","city":"","district":"新野县"},
{"code":411330,"province":"","city":"","district":"桐柏县"},
{"code":411381,"province":"","city":"","district":"邓州市"},
{"code":411400,"province":"","city":"商丘市","district":""},
{"code":411402,"province":"","city":"","district":"梁园区"},
{"code":411403,"province":"","city":"","district":"睢阳区"},
{"code":411421,"province":"","city":"","district":"民权县"},
{"code":411422,"province":"","city":"","district":"睢县"},
{"code":411423,"province":"","city":"","district":"宁陵县"},
{"code":411424,"province":"","city":"","district":"柘城县"},
{"code":411425,"province":"","city":"","district":"虞城县"},
{"code":411426,"province":"","city":"","district":"夏邑县"},
{"code":411481,"province":"","city":"","district":"永城市"},
{"code":411500,"province":"","city":"信阳市","district":""},
{"code":411502,"province":"","city":"","district":"浉河区"},
{"code":411503,"province":"","city":"","district":"平桥区"},
{"code":411521,"province":"","city":"","district":"罗山县"},
{"code":411522,"province":"","city":"","district":"光山县"},
{"code":411523,"province":"","city":"","district":"新县"},
{"code":411524,"province":"","city":"","district":"商城县"},
{"code":411525,"province":"","city":"","district":"固始县"},
{"code":411526,"province":"","city":"","district":"潢川县"},
{"code":411527,"province":"","city":"","district":"淮滨县"},
{"code":411528,"province":"","city":"","district":"息县"},
{"code":411600,"province":"","city":"周口市","district":""},
{"code":411602,"province":"","city":"","district":"川汇区"},
{"code":411603,"province":"","city":"","district":"淮阳区"},
{"code":411621,"province":"","city":"","district":"扶沟县"},
{"code":411622,"province":"","city":"","district":"西华县"},
{"code":411623,"province":"","city":"","district":"商水县"},
{"code":411624,"province":"","city":"","district":"沈丘县"},
{"code":411625,"province":"","city":"","district":"郸城县"},
{"code":411627,"province":"","city":"","district":"太康县"},
{"code":411628,"province":"","city":"","district":"鹿邑县"},
{"code":411681,"province":"","city":"","district":"项城市"},
{"code":411700,"province":"","city":"驻马店市","district":""},
{"code":411702,"province":"","city":"","district":"驿城区"},
{"code":411721,"province":"","city":"","district":"西平县"},
{"code":411722,"province":"","city":"","district":"上蔡县"},
{"code":411723,"province":"","city":"","district":"平舆县"},
{"code":411724,"province":"","city":"","district":"正阳县"},
{"code":411725,"province":"","city":"","district":"确山县"},
{"code":411726,"province":"","city":"","district":"泌阳县"},
{"code":411727,"province":"","city":"","district":"汝南县"},
{"code":411728,"province":"","city":"","district":"遂平县"},
{"code":411729,"province":"","city":"","district":"新蔡县"},
{"code":419001,"province":"","city":"济源市","district":""},
{"code":420000,"province":"湖北省","city":"","district":""},
{"code":420100,"province":"","city":"武汉市","district":""},
{"code":420102,"province":"","city":"","district":"江岸区"},
{"code":420103,"province":"","city":"","district":"江汉区"},
{"code":420104,"province":"","city":"","district":"硚口区"},
{"code":420105,"province":"","city":"","district":"汉阳区"},
{"code":420106,"province":"","city":"","district":"武昌区"},
{"code":420107,"province":"","city":"","district":"青山区"},
{"code":420111,"province":"","city":"","district":"洪山区"},
{"code":420112,"province":"","city":"","district":"东西湖区"},
{"code":420113,"province":"","city":"","district":"汉南区"},
{"code":420114,"province":"","city":"","district":"蔡甸区"},
{"code":420115,"province":"","city":"","district":"江夏区"},
{"code":420116,"province":"","city":"","district":"黄陂区"},
{"code":420117,"province":"","city":"","district":"新洲区"},
{"code":420200,"province":"","city":"黄石市","district":""},
{"code":420202,"province":"","city":"","district":"黄石港区"},
{"code":420203,"province":"","city":"","district":"西塞山区"},
{"code":420204,"province":"","city":"","district":"下陆区"},
{"code":420205,"province":"","city":"","district":"铁山区"},
{"code":420222,"province":"","city":"","district":"阳新县"},
{"code":420281,"province":"","city":"","district":"大冶市"},
{"code":420300,"province":"","city":"十堰市","district":""},
{"code":420302,"province":"","city":"","district":"茅箭区"},
{"code":420303,"province":"","city":"","district":"张湾区"},
{"code":420304,"province":"","city":"","district":"郧阳区"},
{"code":420322,"province":"","city":"","district":"郧西县"},
{"code":420323,"province":"","city":"","district":"竹山县"},
{"code":420324,"province":"","city":"","district":"竹溪县"},
{"code":420325,"province":"","city":"","district":"房县"},
{"code":420381,"province":"","city":"","district":"丹江口市"},
{"code":420500,"province":"","city":"宜昌市","district":""},
{"code":420502,"province":"","city":"","district":"西陵区"},
{"code":420503,"province":"","city":"","district":"伍家岗区"},
{"code":420504,"province":"","city":"","district":"点军区"},
{"code":420505,"province":"","city":"","district":"猇亭区"},
{"code":420506,"province":"","city":"","district":"夷陵区"},
{"code":420525,"province":"","city":"","district":"远安县"},
{"code":420526,"province":"","city":"","district":"兴山县"},
{"code":420527,"province":"","city":"","district":"秭归县"},
{"code":420528,"province":"","city":"","district":"长阳土家族自治县"},
{"code":420529,"province":"","city":"","district":"五峰土家族自治县"},
{"code":420581,"province":"","city":"","district":"宜都市"},
{"code":420582,"province":"","city":"","district":"当阳市"},
{"code":420583,"province":"","city":"","district":"枝江市"},
{"code":420600,"province":"","city":"襄阳市","district":""},
{"code":420602,"province":"","city":"","district":"襄城区"},
{"code":420606,"province":"","city":"","district":"樊城区"},
{"code":420607,"province":"","city":"","district":"襄州区"},
{"code":420624,"province":"","city":"","district":"南漳县"},
{"code":420625,"province":"","city":"","district":"谷城县"},
{"code":420626,"province":"","city":"","district":"保康县"},
{"code":420682,"province":"","city":"","district":"老河口市"},
{"code":420683,"province":"","city":"","district":"枣阳市"},
{"code":420684,"province":"","city":"","district":"宜城市"},
{"code":420700,"province":"","city":"鄂州市","district":""},
{"code":420702,"province":"","city":"","district":"梁子湖区"},
{"code":420703,"province":"","city":"","district":"华容区"},
{"code":420704,"province":"","city":"","district":"鄂城区"},
{"code":420800,"province":"","city":"荆门市","district":""},
{"code":420802,"province":"","city":"","district":"东宝区"},
{"code":420804,"province":"","city":"","district":"掇刀区"},
{"code":420882,"province":"","city":"","district":"京山市"},
{"code":420822,"province":"","city":"","district":"沙洋县"},
{"code":420881,"province":"","city":"","district":"钟祥市"},
{"code":420900,"province":"","city":"孝感市","district":""},
{"code":420902,"province":"","city":"","district":"孝南区"},
{"code":420921,"province":"","city":"","district":"孝昌县"},
{"code":420922,"province":"","city":"","district":"大悟县"},
{"code":420923,"province":"","city":"","district":"云梦县"},
{"code":420981,"province":"","city":"","district":"应城市"},
{"code":420982,"province":"","city":"","district":"安陆市"},
{"code":420984,"province":"","city":"","district":"汉川市"},
{"code":421000,"province":"","city":"荆州市","district":""},
{"code":421002,"province":"","city":"","district":"沙市区"},
{"code":421003,"province":"","city":"","district":"荆州区"},
{"code":421022,"province":"","city":"","district":"公安县"},
{"code":421023,"province":"","city":"","district":"监利县"},
{"code":421024,"province":"","city":"","district":"江陵县"},
{"code":421081,"province":"","city":"","district":"石首市"},
{"code":421083,"province":"","city":"","district":"洪湖市"},
{"code":421087,"province":"","city":"","district":"松滋市"},
{"code":421100,"province":"","city":"黄冈市","district":""},
{"code":421102,"province":"","city":"","district":"黄州区"},
{"code":421121,"province":"","city":"","district":"团风县"},
{"code":421122,"province":"","city":"","district":"红安县"},
{"code":421123,"province":"","city":"","district":"罗田县"},
{"code":421124,"province":"","city":"","district":"英山县"},
{"code":421125,"province":"","city":"","district":"浠水县"},
{"code":421126,"province":"","city":"","district":"蕲春县"},
{"code":421127,"province":"","city":"","district":"黄梅县"},
{"code":421181,"province":"","city":"","district":"麻城市"},
{"code":421182,"province":"","city":"","district":"武穴市"},
{"code":421200,"province":"","city":"咸宁市","district":""},
{"code":421202,"province":"","city":"","district":"咸安区"},
{"code":421221,"province":"","city":"","district":"嘉鱼县"},
{"code":421222,"province":"","city":"","district":"通城县"},
{"code":421223,"province":"","city":"","district":"崇阳县"},
{"code":421224,"province":"","city":"","district":"通山县"},
{"code":421281,"province":"","city":"","district":"赤壁市"},
{"code":421300,"province":"","city":"随州市","district":""},
{"code":421303,"province":"","city":"","district":"曾都区"},
{"code":421321,"province":"","city":"","district":"随县"},
{"code":421381,"province":"","city":"","district":"广水市"},
{"code":422800,"province":"","city":"恩施土家族苗族自治州","district":""},
{"code":422801,"province":"","city":"","district":"恩施市"},
{"code":422802,"province":"","city":"","district":"利川市"},
{"code":422822,"province":"","city":"","district":"建始县"},
{"code":422823,"province":"","city":"","district":"巴东县"},
{"code":422825,"province":"","city":"","district":"宣恩县"},
{"code":422826,"province":"","city":"","district":"咸丰县"},
{"code":422827,"province":"","city":"","district":"来凤县"},
{"code":422828,"province":"","city":"","district":"鹤峰县"},
{"code":429004,"province":"","city":"","district":"仙桃市"},
{"code":429005,"province":"","city":"","district":"潜江市"},
{"code":429006,"province":"","city":"","district":"天门市"},
{"code":429021,"province":"","city":"","district":"神农架林区"},
{"code":430000,"province":"湖南省","city":"","district":""},
{"code":430100,"province":"","city":"长沙市","district":""},
{"code":430102,"province":"","city":"","district":"芙蓉区"},
{"code":430103,"province":"","city":"","district":"天心区"},
{"code":430104,"province":"","city":"","district":"岳麓区"},
{"code":430105,"province":"","city":"","district":"开福区"},
{"code":430111,"province":"","city":"","district":"雨花区"},
{"code":430112,"province":"","city":"","district":"望城区"},
{"code":430121,"province":"","city":"","district":"长沙县"},
{"code":430181,"province":"","city":"","district":"浏阳市"},
{"code":430182,"province":"","city":"","district":"宁乡市"},
{"code":430200,"province":"","city":"株洲市","district":""},
{"code":430202,"province":"","city":"","district":"荷塘区"},
{"code":430203,"province":"","city":"","district":"芦淞区"},
{"code":430204,"province":"","city":"","district":"石峰区"},
{"code":430211,"province":"","city":"","district":"天元区"},
{"code":430212,"province":"","city":"","district":"渌口区"},
{"code":430223,"province":"","city":"","district":"攸县"},
{"code":430224,"province":"","city":"","district":"茶陵县"},
{"code":430225,"province":"","city":"","district":"炎陵县"},
{"code":430281,"province":"","city":"","district":"醴陵市"},
{"code":430300,"province":"","city":"湘潭市","district":""},
{"code":430302,"province":"","city":"","district":"雨湖区"},
{"code":430304,"province":"","city":"","district":"岳塘区"},
{"code":430321,"province":"","city":"","district":"湘潭县"},
{"code":430381,"province":"","city":"","district":"湘乡市"},
{"code":430382,"province":"","city":"","district":"韶山市"},
{"code":430400,"province":"","city":"衡阳市","district":""},
{"code":430405,"province":"","city":"","district":"珠晖区"},
{"code":430406,"province":"","city":"","district":"雁峰区"},
{"code":430407,"province":"","city":"","district":"石鼓区"},
{"code":430408,"province":"","city":"","district":"蒸湘区"},
{"code":430412,"province":"","city":"","district":"南岳区"},
{"code":430421,"province":"","city":"","district":"衡阳县"},
{"code":430422,"province":"","city":"","district":"衡南县"},
{"code":430423,"province":"","city":"","district":"衡山县"},
{"code":430424,"province":"","city":"","district":"衡东县"},
{"code":430426,"province":"","city":"","district":"祁东县"},
{"code":430481,"province":"","city":"","district":"耒阳市"},
{"code":430482,"province":"","city":"","district":"常宁市"},
{"code":430500,"province":"","city":"邵阳市","district":""},
{"code":430502,"province":"","city":"","district":"双清区"},
{"code":430503,"province":"","city":"","district":"大祥区"},
{"code":430511,"province":"","city":"","district":"北塔区"},
{"code":430522,"province":"","city":"","district":"新邵县"},
{"code":430523,"province":"","city":"","district":"邵阳县"},
{"code":430524,"province":"","city":"","district":"隆回县"},
{"code":430525,"province":"","city":"","district":"洞口县"},
{"code":430527,"province":"","city":"","district":"绥宁县"},
{"code":430528,"province":"","city":"","district":"新宁县"},
{"code":430529,"province":"","city":"","district":"城步苗族自治县"},
{"code":430581,"province":"","city":"","district":"武冈市"},
{"code":430582,"province":"","city":"","district":"邵东市"},
{"code":430600,"province":"","city":"岳阳市","district":""},
{"code":430602,"province":"","city":"","district":"岳阳楼区"},
{"code":430603,"province":"","city":"","district":"云溪区"},
{"code":430611,"province":"","city":"","district":"君山区"},
{"code":430621,"province":"","city":"","district":"岳阳县"},
{"code":430623,"province":"","city":"","district":"华容县"},
{"code":430624,"province":"","city":"","district":"湘阴县"},
{"code":430626,"province":"","city":"","district":"平江县"},
{"code":430681,"province":"","city":"","district":"汨罗市"},
{"code":430682,"province":"","city":"","district":"临湘市"},
{"code":430700,"province":"","city":"常德市","district":""},
{"code":430702,"province":"","city":"","district":"武陵区"},
{"code":430703,"province":"","city":"","district":"鼎城区"},
{"code":430721,"province":"","city":"","district":"安乡县"},
{"code":430722,"province":"","city":"","district":"汉寿县"},
{"code":430723,"province":"","city":"","district":"澧县"},
{"code":430724,"province":"","city":"","district":"临澧县"},
{"code":430725,"province":"","city":"","district":"桃源县"},
{"code":430726,"province":"","city":"","district":"石门县"},
{"code":430781,"province":"","city":"","district":"津市市"},
{"code":430800,"province":"","city":"张家界市","district":""},
{"code":430802,"province":"","city":"","district":"永定区"},
{"code":430811,"province":"","city":"","district":"武陵源区"},
{"code":430821,"province":"","city":"","district":"慈利县"},
{"code":430822,"province":"","city":"","district":"桑植县"},
{"code":430900,"province":"","city":"益阳市","district":""},
{"code":430902,"province":"","city":"","district":"资阳区"},
{"code":430903,"province":"","city":"","district":"赫山区"},
{"code":430921,"province":"","city":"","district":"南县"},
{"code":430922,"province":"","city":"","district":"桃江县"},
{"code":430923,"province":"","city":"","district":"安化县"},
{"code":430981,"province":"","city":"","district":"沅江市"},
{"code":431000,"province":"","city":"郴州市","district":""},
{"code":431002,"province":"","city":"","district":"北湖区"},
{"code":431003,"province":"","city":"","district":"苏仙区"},
{"code":431021,"province":"","city":"","district":"桂阳县"},
{"code":431022,"province":"","city":"","district":"宜章县"},
{"code":431023,"province":"","city":"","district":"永兴县"},
{"code":431024,"province":"","city":"","district":"嘉禾县"},
{"code":431025,"province":"","city":"","district":"临武县"},
{"code":431026,"province":"","city":"","district":"汝城县"},
{"code":431027,"province":"","city":"","district":"桂东县"},
{"code":431028,"province":"","city":"","district":"安仁县"},
{"code":431081,"province":"","city":"","district":"资兴市"},
{"code":431100,"province":"","city":"永州市","district":""},
{"code":431102,"province":"","city":"","district":"零陵区"},
{"code":431103,"province":"","city":"","district":"冷水滩区"},
{"code":431121,"province":"","city":"","district":"祁阳县"},
{"code":431122,"province":"","city":"","district":"东安县"},
{"code":431123,"province":"","city":"","district":"双牌县"},
{"code":431124,"province":"","city":"","district":"道县"},
{"code":431125,"province":"","city":"","district":"江永县"},
{"code":431126,"province":"","city":"","district":"宁远县"},
{"code":431127,"province":"","city":"","district":"蓝山县"},
{"code":431128,"province":"","city":"","district":"新田县"},
{"code":431129,"province":"","city":"","district":"江华瑶族自治县"},
{"code":431200,"province":"","city":"怀化市","district":""},
{"code":431202,"province":"","city":"","district":"鹤城区"},
{"code":431221,"province":"","city":"","district":"中方县"},
{"code":431222,"province":"","city":"","district":"沅陵县"},
{"code":431223,"province":"","city":"","district":"辰溪县"},
{"code":431224,"province":"","city":"","district":"溆浦县"},
{"code":431225,"province":"","city":"","district":"会同县"},
{"code":431226,"province":"","city":"","district":"麻阳苗族自治县"},
{"code":431227,"province":"","city":"","district":"新晃侗族自治县"},
{"code":431228,"province":"","city":"","district":"芷江侗族自治县"},
{"code":431229,"province":"","city":"","district":"靖州苗族侗族自治县"},
{"code":431230,"province":"","city":"","district":"通道侗族自治县"},
{"code":431281,"province":"","city":"","district":"洪江市"},
{"code":431300,"province":"","city":"娄底市","district":""},
{"code":431302,"province":"","city":"","district":"娄星区"},
{"code":431321,"province":"","city":"","district":"双峰县"},
{"code":431322,"province":"","city":"","district":"新化县"},
{"code":431381,"province":"","city":"","district":"冷水江市"},
{"code":431382,"province":"","city":"","district":"涟源市"},
{"code":433100,"province":"","city":"湘西土家族苗族自治州","district":""},
{"code":433101,"province":"","city":"","district":"吉首市"},
{"code":433122,"province":"","city":"","district":"泸溪县"},
{"code":433123,"province":"","city":"","district":"凤凰县"},
{"code":433124,"province":"","city":"","district":"花垣县"},
{"code":433125,"province":"","city":"","district":"保靖县"},
{"code":433126,"province":"","city":"","district":"古丈县"},
{"code":433127,"province":"","city":"","district":"永顺县"},
{"code":433130,"province":"","city":"","district":"龙山县"},
{"code":440000,"province":"广东省","city":"","district":""},
{"code":440100,"province":"","city":"广州市","district":""},
{"code":440103,"province":"","city":"","district":"荔湾区"},
{"code":440104,"province":"","city":"","district":"越秀区"},
{"code":440105,"province":"","city":"","district":"海珠区"},
{"code":440106,"province":"","city":"","district":"天河区"},
{"code":440111,"province":"","city":"","district":"白云区"},
{"code":440112,"province":"","city":"","district":"黄埔区"},
{"code":440113,"province":"","city":"","district":"番禺区"},
{"code":440114,"province":"","city":"","district":"花都区"},
{"code":440115,"province":"","city":"","district":"南沙区"},
{"code":440117,"province":"","city":"","district":"从化区"},
{"code":440118,"province":"","city":"","district":"增城区"},
{"code":440200,"province":"","city":"韶关市","district":""},
{"code":440203,"province":"","city":"","district":"武江区"},
{"code":440204,"province":"","city":"","district":"浈江区"},
{"code":440205,"province":"","city":"","district":"曲江区"},
{"code":440222,"province":"","city":"","district":"始兴县"},
{"code":440224,"province":"","city":"","district":"仁化县"},
{"code":440229,"province":"","city":"","district":"翁源县"},
{"code":440232,"province":"","city":"","district":"乳源瑶族自治县"},
{"code":440233,"province":"","city":"","district":"新丰县"},
{"code":440281,"province":"","city":"","district":"乐昌市"},
{"code":440282,"province":"","city":"","district":"南雄市"},
{"code":440300,"province":"","city":"深圳市","district":""},
{"code":440303,"province":"","city":"","district":"罗湖区"},
{"code":440304,"province":"","city":"","district":"福田区"},
{"code":440305,"province":"","city":"","district":"南山区"},
{"code":440306,"province":"","city":"","district":"宝安区"},
{"code":440307,"province":"","city":"","district":"龙岗区"},
{"code":440308,"province":"","city":"","district":"盐田区"},
{"code":440309,"province":"","city":"","district":"龙华区"},
{"code":440310,"province":"","city":"","district":"坪山区"},
{"code":440311,"province":"","city":"","district":"光明区"},
{"code":440400,"province":"","city":"珠海市","district":""},
{"code":440402,"province":"","city":"","district":"香洲区"},
{"code":440403,"province":"","city":"","district":"斗门区"},
{"code":440404,"province":"","city":"","district":"金湾区"},
{"code":440500,"province":"","city":"汕头市","district":""},
{"code":440507,"province":"","city":"","district":"龙湖区"},
{"code":440511,"province":"","city":"","district":"金平区"},
{"code":440512,"province":"","city":"","district":"濠江区"},
{"code":440513,"province":"","city":"","district":"潮阳区"},
{"code":440514,"province":"","city":"","district":"潮南区"},
{"code":440515,"province":"","city":"","district":"澄海区"},
{"code":440523,"province":"","city":"","district":"南澳县"},
{"code":440600,"province":"","city":"佛山市","district":""},
{"code":440604,"province":"","city":"","district":"禅城区"},
{"code":440605,"province":"","city":"","district":"南海区"},
{"code":440606,"province":"","city":"","district":"顺德区"},
{"code":440607,"province":"","city":"","district":"三水区"},
{"code":440608,"province":"","city":"","district":"高明区"},
{"code":440700,"province":"","city":"江门市","district":""},
{"code":440703,"province":"","city":"","district":"蓬江区"},
{"code":440704,"province":"","city":"","district":"江海区"},
{"code":440705,"province":"","city":"","district":"新会区"},
{"code":440781,"province":"","city":"","district":"台山市"},
{"code":440783,"province":"","city":"","district":"开平市"},
{"code":440784,"province":"","city":"","district":"鹤山市"},
{"code":440785,"province":"","city":"","district":"恩平市"},
{"code":440800,"province":"","city":"湛江市","district":""},
{"code":440802,"province":"","city":"","district":"赤坎区"},
{"code":440803,"province":"","city":"","district":"霞山区"},
{"code":440804,"province":"","city":"","district":"坡头区"},
{"code":440811,"province":"","city":"","district":"麻章区"},
{"code":440823,"province":"","city":"","district":"遂溪县"},
{"code":440825,"province":"","city":"","district":"徐闻县"},
{"code":440881,"province":"","city":"","district":"廉江市"},
{"code":440882,"province":"","city":"","district":"雷州市"},
{"code":440883,"province":"","city":"","district":"吴川市"},
{"code":440900,"province":"","city":"茂名市","district":""},
{"code":440902,"province":"","city":"","district":"茂南区"},
{"code":440904,"province":"","city":"","district":"电白区"},
{"code":440981,"province":"","city":"","district":"高州市"},
{"code":440982,"province":"","city":"","district":"化州市"},
{"code":440983,"province":"","city":"","district":"信宜市"},
{"code":441200,"province":"","city":"肇庆市","district":""},
{"code":441202,"province":"","city":"","district":"端州区"},
{"code":441203,"province":"","city":"","district":"鼎湖区"},
{"code":441204,"province":"","city":"","district":"高要区"},
{"code":441223,"province":"","city":"","district":"广宁县"},
{"code":441224,"province":"","city":"","district":"怀集县"},
{"code":441225,"province":"","city":"","district":"封开县"},
{"code":441226,"province":"","city":"","district":"德庆县"},
{"code":441284,"province":"","city":"","district":"四会市"},
{"code":441300,"province":"","city":"惠州市","district":""},
{"code":441302,"province":"","city":"","district":"惠城区"},
{"code":441303,"province":"","city":"","district":"惠阳区"},
{"code":441322,"province":"","city":"","district":"博罗县"},
{"code":441323,"province":"","city":"","district":"惠东县"},
{"code":441324,"province":"","city":"","district":"龙门县"},
{"code":441400,"province":"","city":"梅州市","district":""},
{"code":441402,"province":"","city":"","district":"梅江区"},
{"code":441403,"province":"","city":"","district":"梅县区"},
{"code":441422,"province":"","city":"","district":"大埔县"},
{"code":441423,"province":"","city":"","district":"丰顺县"},
{"code":441424,"province":"","city":"","district":"五华县"},
{"code":441426,"province":"","city":"","district":"平远县"},
{"code":441427,"province":"","city":"","district":"蕉岭县"},
{"code":441481,"province":"","city":"","district":"兴宁市"},
{"code":441500,"province":"","city":"汕尾市","district":""},
{"code":441502,"province":"","city":"","district":"城区"},
{"code":441521,"province":"","city":"","district":"海丰县"},
{"code":441523,"province":"","city":"","district":"陆河县"},
{"code":441581,"province":"","city":"","district":"陆丰市"},
{"code":441600,"province":"","city":"河源市","district":""},
{"code":441602,"province":"","city":"","district":"源城区"},
{"code":441621,"province":"","city":"","district":"紫金县"},
{"code":441622,"province":"","city":"","district":"龙川县"},
{"code":441623,"province":"","city":"","district":"连平县"},
{"code":441624,"province":"","city":"","district":"和平县"},
{"code":441625,"province":"","city":"","district":"东源县"},
{"code":441700,"province":"","city":"阳江市","district":""},
{"code":441702,"province":"","city":"","district":"江城区"},
{"code":441704,"province":"","city":"","district":"阳东区"},
{"code":441721,"province":"","city":"","district":"阳西县"},
{"code":441781,"province":"","city":"","district":"阳春市"},
{"code":441800,"province":"","city":"清远市","district":""},
{"code":441802,"province":"","city":"","district":"清城区"},
{"code":441803,"province":"","city":"","district":"清新区"},
{"code":441821,"province":"","city":"","district":"佛冈县"},
{"code":441823,"province":"","city":"","district":"阳山县"},
{"code":441825,"province":"","city":"","district":"连山壮族瑶族自治县"},
{"code":441826,"province":"","city":"","district":"连南瑶族自治县"},
{"code":441881,"province":"","city":"","district":"英德市"},
{"code":441882,"province":"","city":"","district":"连州市"},
{"code":441900,"province":"","city":"东莞市","district":""},
{"code":442000,"province":"","city":"中山市","district":""},
{"code":445100,"province":"","city":"潮州市","district":""},
{"code":445102,"province":"","city":"","district":"湘桥区"},
{"code":445103,"province":"","city":"","district":"潮安区"},
{"code":445122,"province":"","city":"","district":"饶平县"},
{"code":445200,"province":"","city":"揭阳市","district":""},
{"code":445202,"province":"","city":"","district":"榕城区"},
{"code":445203,"province":"","city":"","district":"揭东区"},
{"code":445222,"province":"","city":"","district":"揭西县"},
{"code":445224,"province":"","city":"","district":"惠来县"},
{"code":445281,"province":"","city":"","district":"普宁市"},
{"code":445300,"province":"","city":"云浮市","district":""},
{"code":445302,"province":"","city":"","district":"云城区"},
{"code":445303,"province":"","city":"","district":"云安区"},
{"code":445321,"province":"","city":"","district":"新兴县"},
{"code":445322,"province":"","city":"","district":"郁南县"},
{"code":445381,"province":"","city":"","district":"罗定市"},
{"code":450000,"province":"广西壮族自治区","city":"","district":""},
{"code":450100,"province":"","city":"南宁市","district":""},
{"code":450102,"province":"","city":"","district":"兴宁区"},
{"code":450103,"province":"","city":"","district":"青秀区"},
{"code":450105,"province":"","city":"","district":"江南区"},
{"code":450107,"province":"","city":"","district":"西乡塘区"},
{"code":450108,"province":"","city":"","district":"良庆区"},
{"code":450109,"province":"","city":"","district":"邕宁区"},
{"code":450110,"province":"","city":"","district":"武鸣区"},
{"code":450123,"province":"","city":"","district":"隆安县"},
{"code":450124,"province":"","city":"","district":"马山县"},
{"code":450125,"province":"","city":"","district":"上林县"},
{"code":450126,"province":"","city":"","district":"宾阳县"},
{"code":450127,"province":"","city":"","district":"横县"},
{"code":450200,"province":"","city":"柳州市","district":""},
{"code":450202,"province":"","city":"","district":"城中区"},
{"code":450203,"province":"","city":"","district":"鱼峰区"},
{"code":450204,"province":"","city":"","district":"柳南区"},
{"code":450205,"province":"","city":"","district":"柳北区"},
{"code":450206,"province":"","city":"","district":"柳江区"},
{"code":450222,"province":"","city":"","district":"柳城县"},
{"code":450223,"province":"","city":"","district":"鹿寨县"},
{"code":450224,"province":"","city":"","district":"融安县"},
{"code":450225,"province":"","city":"","district":"融水苗族自治县"},
{"code":450226,"province":"","city":"","district":"三江侗族自治县"},
{"code":450300,"province":"","city":"桂林市","district":""},
{"code":450302,"province":"","city":"","district":"秀峰区"},
{"code":450303,"province":"","city":"","district":"叠彩区"},
{"code":450304,"province":"","city":"","district":"象山区"},
{"code":450305,"province":"","city":"","district":"七星区"},
{"code":450311,"province":"","city":"","district":"雁山区"},
{"code":450312,"province":"","city":"","district":"临桂区"},
{"code":450321,"province":"","city":"","district":"阳朔县"},
{"code":450323,"province":"","city":"","district":"灵川县"},
{"code":450324,"province":"","city":"","district":"全州县"},
{"code":450325,"province":"","city":"","district":"兴安县"},
{"code":450326,"province":"","city":"","district":"永福县"},
{"code":450327,"province":"","city":"","district":"灌阳县"},
{"code":450328,"province":"","city":"","district":"龙胜各族自治县"},
{"code":450329,"province":"","city":"","district":"资源县"},
{"code":450330,"province":"","city":"","district":"平乐县"},
{"code":450381,"province":"","city":"","district":"荔浦市"},
{"code":450332,"province":"","city":"","district":"恭城瑶族自治县"},
{"code":450400,"province":"","city":"梧州市","district":""},
{"code":450403,"province":"","city":"","district":"万秀区"},
{"code":450405,"province":"","city":"","district":"长洲区"},
{"code":450406,"province":"","city":"","district":"龙圩区"},
{"code":450421,"province":"","city":"","district":"苍梧县"},
{"code":450422,"province":"","city":"","district":"藤县"},
{"code":450423,"province":"","city":"","district":"蒙山县"},
{"code":450481,"province":"","city":"","district":"岑溪市"},
{"code":450500,"province":"","city":"北海市","district":""},
{"code":450502,"province":"","city":"","district":"海城区"},
{"code":450503,"province":"","city":"","district":"银海区"},
{"code":450512,"province":"","city":"","district":"铁山港区"},
{"code":450521,"province":"","city":"","district":"合浦县"},
{"code":450600,"province":"","city":"防城港市","district":""},
{"code":450602,"province":"","city":"","district":"港口区"},
{"code":450603,"province":"","city":"","district":"防城区"},
{"code":450621,"province":"","city":"","district":"上思县"},
{"code":450681,"province":"","city":"","district":"东兴市"},
{"code":450700,"province":"","city":"钦州市","district":""},
{"code":450702,"province":"","city":"","district":"钦南区"},
{"code":450703,"province":"","city":"","district":"钦北区"},
{"code":450721,"province":"","city":"","district":"灵山县"},
{"code":450722,"province":"","city":"","district":"浦北县"},
{"code":450800,"province":"","city":"贵港市","district":""},
{"code":450802,"province":"","city":"","district":"港北区"},
{"code":450803,"province":"","city":"","district":"港南区"},
{"code":450804,"province":"","city":"","district":"覃塘区"},
{"code":450821,"province":"","city":"","district":"平南县"},
{"code":450881,"province":"","city":"","district":"桂平市"},
{"code":450900,"province":"","city":"玉林市","district":""},
{"code":450902,"province":"","city":"","district":"玉州区"},
{"code":450903,"province":"","city":"","district":"福绵区"},
{"code":450921,"province":"","city":"","district":"容县"},
{"code":450922,"province":"","city":"","district":"陆川县"},
{"code":450923,"province":"","city":"","district":"博白县"},
{"code":450924,"province":"","city":"","district":"兴业县"},
{"code":450981,"province":"","city":"","district":"北流市"},
{"code":451000,"province":"","city":"百色市","district":""},
{"code":451002,"province":"","city":"","district":"右江区"},
{"code":451003,"province":"","city":"","district":"田阳区"},
{"code":451022,"province":"","city":"","district":"田东县"},
{"code":451024,"province":"","city":"","district":"德保县"},
{"code":451026,"province":"","city":"","district":"那坡县"},
{"code":451027,"province":"","city":"","district":"凌云县"},
{"code":451028,"province":"","city":"","district":"乐业县"},
{"code":451029,"province":"","city":"","district":"田林县"},
{"code":451030,"province":"","city":"","district":"西林县"},
{"code":451031,"province":"","city":"","district":"隆林各族自治县"},
{"code":451081,"province":"","city":"","district":"靖西市"},
{"code":451082,"province":"","city":"","district":"平果市"},
{"code":451100,"province":"","city":"贺州市","district":""},
{"code":451102,"province":"","city":"","district":"八步区"},
{"code":451103,"province":"","city":"","district":"平桂区"},
{"code":451121,"province":"","city":"","district":"昭平县"},
{"code":451122,"province":"","city":"","district":"钟山县"},
{"code":451123,"province":"","city":"","district":"富川瑶族自治县"},
{"code":451200,"province":"","city":"河池市","district":""},
{"code":451202,"province":"","city":"","district":"金城江区"},
{"code":451221,"province":"","city":"","district":"南丹县"},
{"code":451222,"province":"","city":"","district":"天峨县"},
{"code":451223,"province":"","city":"","district":"凤山县"},
{"code":451224,"province":"","city":"","district":"东兰县"},
{"code":451225,"province":"","city":"","district":"罗城仫佬族自治县"},
{"code":451226,"province":"","city":"","district":"环江毛南族自治县"},
{"code":451227,"province":"","city":"","district":"巴马瑶族自治县"},
{"code":451228,"province":"","city":"","district":"都安瑶族自治县"},
{"code":451229,"province":"","city":"","district":"大化瑶族自治县"},
{"code":451203,"province":"","city":"","district":"宜州区"},
{"code":451300,"province":"","city":"来宾市","district":""},
{"code":451302,"province":"","city":"","district":"兴宾区"},
{"code":451321,"province":"","city":"","district":"忻城县"},
{"code":451322,"province":"","city":"","district":"象州县"},
{"code":451323,"province":"","city":"","district":"武宣县"},
{"code":451324,"province":"","city":"","district":"金秀瑶族自治县"},
{"code":451381,"province":"","city":"","district":"合山市"},
{"code":451400,"province":"","city":"崇左市","district":""},
{"code":451402,"province":"","city":"","district":"江州区"},
{"code":451421,"province":"","city":"","district":"扶绥县"},
{"code":451422,"province":"","city":"","district":"宁明县"},
{"code":451423,"province":"","city":"","district":"龙州县"},
{"code":451424,"province":"","city":"","district":"大新县"},
{"code":451425,"province":"","city":"","district":"天等县"},
{"code":451481,"province":"","city":"","district":"凭祥市"},
{"code":460000,"province":"海南省","city":"","district":""},
{"code":460100,"province":"","city":"海口市","district":""},
{"code":460105,"province":"","city":"","district":"秀英区"},
{"code":460106,"province":"","city":"","district":"龙华区"},
{"code":460107,"province":"","city":"","district":"琼山区"},
{"code":460108,"province":"","city":"","district":"美兰区"},
{"code":460200,"province":"","city":"三亚市","district":""},
{"code":460202,"province":"","city":"","district":"海棠区"},
{"code":460203,"province":"","city":"","district":"吉阳区"},
{"code":460204,"province":"","city":"","district":"天涯区"},
{"code":460205,"province":"","city":"","district":"崖州区"},
{"code":460300,"province":"","city":"三沙市","district":""},
{"code":460400,"province":"","city":"","district":"儋州市"},
{"code":469001,"province":"","city":"","district":"五指山市"},
{"code":469002,"province":"","city":"","district":"琼海市"},
{"code":469005,"province":"","city":"","district":"文昌市"},
{"code":469006,"province":"","city":"","district":"万宁市"},
{"code":469007,"province":"","city":"","district":"东方市"},
{"code":469021,"province":"","city":"","district":"定安县"},
{"code":469022,"province":"","city":"","district":"屯昌县"},
{"code":469023,"province":"","city":"","district":"澄迈县"},
{"code":469024,"province":"","city":"","district":"临高县"},
{"code":469025,"province":"","city":"","district":"白沙黎族自治县"},
{"code":469026,"province":"","city":"","district":"昌江黎族自治县"},
{"code":469027,"province":"","city":"","district":"乐东黎族自治县"},
{"code":469028,"province":"","city":"","district":"陵水黎族自治县"},
{"code":469029,"province":"","city":"","district":"保亭黎族苗族自治县"},
{"code":469030,"province":"","city":"","district":"琼中黎族苗族自治县"},
{"code":500000,"province":"重庆市","city":"","district":""},
{"code":500100,"province":"","city":"重庆市","district":""},
{"code":500101,"province":"","city":"","district":"万州区"},
{"code":500102,"province":"","city":"","district":"涪陵区"},
{"code":500103,"province":"","city":"","district":"渝中区"},
{"code":500104,"province":"","city":"","district":"大渡口区"},
{"code":500105,"province":"","city":"","district":"江北区"},
{"code":500106,"province":"","city":"","district":"沙坪坝区"},
{"code":500107,"province":"","city":"","district":"九龙坡区"},
{"code":500108,"province":"","city":"","district":"南岸区"},
{"code":500109,"province":"","city":"","district":"北碚区"},
{"code":500110,"province":"","city":"","district":"綦江区"},
{"code":500111,"province":"","city":"","district":"大足区"},
{"code":500112,"province":"","city":"","district":"渝北区"},
{"code":500113,"province":"","city":"","district":"巴南区"},
{"code":500114,"province":"","city":"","district":"黔江区"},
{"code":500115,"province":"","city":"","district":"长寿区"},
{"code":500116,"province":"","city":"","district":"江津区"},
{"code":500117,"province":"","city":"","district":"合川区"},
{"code":500118,"province":"","city":"","district":"永川区"},
{"code":500119,"province":"","city":"","district":"南川区"},
{"code":500120,"province":"","city":"","district":"璧山区"},
{"code":500151,"province":"","city":"","district":"铜梁区"},
{"code":500152,"province":"","city":"","district":"潼南区"},
{"code":500153,"province":"","city":"","district":"荣昌区"},
{"code":500154,"province":"","city":"","district":"开州区"},
{"code":500155,"province":"","city":"","district":"梁平区"},
{"code":500229,"province":"","city":"","district":"城口县"},
{"code":500230,"province":"","city":"","district":"丰都县"},
{"code":500231,"province":"","city":"","district":"垫江县"},
{"code":500156,"province":"","city":"","district":"武隆区"},
{"code":500233,"province":"","city":"","district":"忠县"},
{"code":500235,"province":"","city":"","district":"云阳县"},
{"code":500236,"province":"","city":"","district":"奉节县"},
{"code":500237,"province":"","city":"","district":"巫山县"},
{"code":500238,"province":"","city":"","district":"巫溪县"},
{"code":500240,"province":"","city":"","district":"石柱土家族自治县"},
{"code":500241,"province":"","city":"","district":"秀山土家族苗族自治县"},
{"code":500242,"province":"","city":"","district":"酉阳土家族苗族自治县"},
{"code":500243,"province":"","city":"","district":"彭水苗族土家族自治县"},
{"code":510000,"province":"四川省","city":"","district":""},
{"code":510100,"province":"","city":"成都市","district":""},
{"code":510104,"province":"","city":"","district":"锦江区"},
{"code":510105,"province":"","city":"","district":"青羊区"},
{"code":510106,"province":"","city":"","district":"金牛区"},
{"code":510107,"province":"","city":"","district":"武侯区"},
{"code":510108,"province":"","city":"","district":"成华区"},
{"code":510112,"province":"","city":"","district":"龙泉驿区"},
{"code":510113,"province":"","city":"","district":"青白江区"},
{"code":510114,"province":"","city":"","district":"新都区"},
{"code":510115,"province":"","city":"","district":"温江区"},
{"code":510116,"province":"","city":"","district":"双流区"},
{"code":510121,"province":"","city":"","district":"金堂县"},
{"code":510117,"province":"","city":"","district":"郫都区"},
{"code":510129,"province":"","city":"","district":"大邑县"},
{"code":510131,"province":"","city":"","district":"蒲江县"},
{"code":510132,"province":"","city":"","district":"新津县"},
{"code":510181,"province":"","city":"","district":"都江堰市"},
{"code":510182,"province":"","city":"","district":"彭州市"},
{"code":510183,"province":"","city":"","district":"邛崃市"},
{"code":510184,"province":"","city":"","district":"崇州市"},
{"code":510185,"province":"","city":"","district":"简阳市"},
{"code":510300,"province":"","city":"自贡市","district":""},
{"code":510302,"province":"","city":"","district":"自流井区"},
{"code":510303,"province":"","city":"","district":"贡井区"},
{"code":510304,"province":"","city":"","district":"大安区"},
{"code":510311,"province":"","city":"","district":"沿滩区"},
{"code":510321,"province":"","city":"","district":"荣县"},
{"code":510322,"province":"","city":"","district":"富顺县"},
{"code":510400,"province":"","city":"攀枝花市","district":""},
{"code":510402,"province":"","city":"","district":"东区"},
{"code":510403,"province":"","city":"","district":"西区"},
{"code":510411,"province":"","city":"","district":"仁和区"},
{"code":510421,"province":"","city":"","district":"米易县"},
{"code":510422,"province":"","city":"","district":"盐边县"},
{"code":510500,"province":"","city":"泸州市","district":""},
{"code":510502,"province":"","city":"","district":"江阳区"},
{"code":510503,"province":"","city":"","district":"纳溪区"},
{"code":510504,"province":"","city":"","district":"龙马潭区"},
{"code":510521,"province":"","city":"","district":"泸县"},
{"code":510522,"province":"","city":"","district":"合江县"},
{"code":510524,"province":"","city":"","district":"叙永县"},
{"code":510525,"province":"","city":"","district":"古蔺县"},
{"code":510600,"province":"","city":"德阳市","district":""},
{"code":510603,"province":"","city":"","district":"旌阳区"},
{"code":510604,"province":"","city":"","district":"罗江区"},
{"code":510623,"province":"","city":"","district":"中江县"},
{"code":510681,"province":"","city":"","district":"广汉市"},
{"code":510682,"province":"","city":"","district":"什邡市"},
{"code":510683,"province":"","city":"","district":"绵竹市"},
{"code":510700,"province":"","city":"绵阳市","district":""},
{"code":510703,"province":"","city":"","district":"涪城区"},
{"code":510704,"province":"","city":"","district":"游仙区"},
{"code":510705,"province":"","city":"","district":"安州区"},
{"code":510722,"province":"","city":"","district":"三台县"},
{"code":510723,"province":"","city":"","district":"盐亭县"},
{"code":510725,"province":"","city":"","district":"梓潼县"},
{"code":510726,"province":"","city":"","district":"北川羌族自治县"},
{"code":510727,"province":"","city":"","district":"平武县"},
{"code":510781,"province":"","city":"","district":"江油市"},
{"code":510800,"province":"","city":"广元市","district":""},
{"code":510802,"province":"","city":"","district":"利州区"},
{"code":510811,"province":"","city":"","district":"昭化区"},
{"code":510812,"province":"","city":"","district":"朝天区"},
{"code":510821,"province":"","city":"","district":"旺苍县"},
{"code":510822,"province":"","city":"","district":"青川县"},
{"code":510823,"province":"","city":"","district":"剑阁县"},
{"code":510824,"province":"","city":"","district":"苍溪县"},
{"code":510900,"province":"","city":"遂宁市","district":""},
{"code":510903,"province":"","city":"","district":"船山区"},
{"code":510904,"province":"","city":"","district":"安居区"},
{"code":510921,"province":"","city":"","district":"蓬溪县"},
{"code":510923,"province":"","city":"","district":"大英县"},
{"code":510981,"province":"","city":"","district":"射洪市"},
{"code":511000,"province":"","city":"内江市","district":""},
{"code":511002,"province":"","city":"","district":"市中区"},
{"code":511011,"province":"","city":"","district":"东兴区"},
{"code":511024,"province":"","city":"","district":"威远县"},
{"code":511025,"province":"","city":"","district":"资中县"},
{"code":511083,"province":"","city":"","district":"隆昌市"},
{"code":511100,"province":"","city":"乐山市","district":""},
{"code":511102,"province":"","city":"","district":"市中区"},
{"code":511111,"province":"","city":"","district":"沙湾区"},
{"code":511112,"province":"","city":"","district":"五通桥区"},
{"code":511113,"province":"","city":"","district":"金口河区"},
{"code":511123,"province":"","city":"","district":"犍为县"},
{"code":511124,"province":"","city":"","district":"井研县"},
{"code":511126,"province":"","city":"","district":"夹江县"},
{"code":511129,"province":"","city":"","district":"沐川县"},
{"code":511132,"province":"","city":"","district":"峨边彝族自治县"},
{"code":511133,"province":"","city":"","district":"马边彝族自治县"},
{"code":511181,"province":"","city":"","district":"峨眉山市"},
{"code":511300,"province":"","city":"南充市","district":""},
{"code":511302,"province":"","city":"","district":"顺庆区"},
{"code":511303,"province":"","city":"","district":"高坪区"},
{"code":511304,"province":"","city":"","district":"嘉陵区"},
{"code":511321,"province":"","city":"","district":"南部县"},
{"code":511322,"province":"","city":"","district":"营山县"},
{"code":511323,"province":"","city":"","district":"蓬安县"},
{"code":511324,"province":"","city":"","district":"仪陇县"},
{"code":511325,"province":"","city":"","district":"西充县"},
{"code":511381,"province":"","city":"","district":"阆中市"},
{"code":511400,"province":"","city":"眉山市","district":""},
{"code":511402,"province":"","city":"","district":"东坡区"},
{"code":511403,"province":"","city":"","district":"彭山区"},
{"code":511421,"province":"","city":"","district":"仁寿县"},
{"code":511423,"province":"","city":"","district":"洪雅县"},
{"code":511424,"province":"","city":"","district":"丹棱县"},
{"code":511425,"province":"","city":"","district":"青神县"},
{"code":511500,"province":"","city":"宜宾市","district":""},
{"code":511502,"province":"","city":"","district":"翠屏区"},
{"code":511503,"province":"","city":"","district":"南溪区"},
{"code":511504,"province":"","city":"","district":"叙州区"},
{"code":511523,"province":"","city":"","district":"江安县"},
{"code":511524,"province":"","city":"","district":"长宁县"},
{"code":511525,"province":"","city":"","district":"高县"},
{"code":511526,"province":"","city":"","district":"珙县"},
{"code":511527,"province":"","city":"","district":"筠连县"},
{"code":511528,"province":"","city":"","district":"兴文县"},
{"code":511529,"province":"","city":"","district":"屏山县"},
{"code":511600,"province":"","city":"广安市","district":""},
{"code":511602,"province":"","city":"","district":"广安区"},
{"code":511603,"province":"","city":"","district":"前锋区"},
{"code":511621,"province":"","city":"","district":"岳池县"},
{"code":511622,"province":"","city":"","district":"武胜县"},
{"code":511623,"province":"","city":"","district":"邻水县"},
{"code":511681,"province":"","city":"","district":"华蓥市"},
{"code":511700,"province":"","city":"达州市","district":""},
{"code":511702,"province":"","city":"","district":"通川区"},
{"code":511703,"province":"","city":"","district":"达川区"},
{"code":511722,"province":"","city":"","district":"宣汉县"},
{"code":511723,"province":"","city":"","district":"开江县"},
{"code":511724,"province":"","city":"","district":"大竹县"},
{"code":511725,"province":"","city":"","district":"渠县"},
{"code":511781,"province":"","city":"","district":"万源市"},
{"code":511800,"province":"","city":"雅安市","district":""},
{"code":511802,"province":"","city":"","district":"雨城区"},
{"code":511803,"province":"","city":"","district":"名山区"},
{"code":511822,"province":"","city":"","district":"荥经县"},
{"code":511823,"province":"","city":"","district":"汉源县"},
{"code":511824,"province":"","city":"","district":"石棉县"},
{"code":511825,"province":"","city":"","district":"天全县"},
{"code":511826,"province":"","city":"","district":"芦山县"},
{"code":511827,"province":"","city":"","district":"宝兴县"},
{"code":511900,"province":"","city":"巴中市","district":""},
{"code":511902,"province":"","city":"","district":"巴州区"},
{"code":511903,"province":"","city":"","district":"恩阳区"},
{"code":511921,"province":"","city":"","district":"通江县"},
{"code":511922,"province":"","city":"","district":"南江县"},
{"code":511923,"province":"","city":"","district":"平昌县"},
{"code":512000,"province":"","city":"资阳市","district":""},
{"code":512002,"province":"","city":"","district":"雁江区"},
{"code":512021,"province":"","city":"","district":"安岳县"},
{"code":512022,"province":"","city":"","district":"乐至县"},
{"code":513200,"province":"","city":"阿坝藏族羌族自治州","district":""},
{"code":513201,"province":"","city":"","district":"马尔康市"},
{"code":513221,"province":"","city":"","district":"汶川县"},
{"code":513222,"province":"","city":"","district":"理县"},
{"code":513223,"province":"","city":"","district":"茂县"},
{"code":513224,"province":"","city":"","district":"松潘县"},
{"code":513225,"province":"","city":"","district":"九寨沟县"},
{"code":513226,"province":"","city":"","district":"金川县"},
{"code":513227,"province":"","city":"","district":"小金县"},
{"code":513228,"province":"","city":"","district":"黑水县"},
{"code":513230,"province":"","city":"","district":"壤塘县"},
{"code":513231,"province":"","city":"","district":"阿坝县"},
{"code":513232,"province":"","city":"","district":"若尔盖县"},
{"code":513233,"province":"","city":"","district":"红原县"},
{"code":513300,"province":"","city":"甘孜藏族自治州","district":""},
{"code":513301,"province":"","city":"","district":"康定市"},
{"code":513322,"province":"","city":"","district":"泸定县"},
{"code":513323,"province":"","city":"","district":"丹巴县"},
{"code":513324,"province":"","city":"","district":"九龙县"},
{"code":513325,"province":"","city":"","district":"雅江县"},
{"code":513326,"province":"","city":"","district":"道孚县"},
{"code":513327,"province":"","city":"","district":"炉霍县"},
{"code":513328,"province":"","city":"","district":"甘孜县"},
{"code":513329,"province":"","city":"","district":"新龙县"},
{"code":513330,"province":"","city":"","district":"德格县"},
{"code":513331,"province":"","city":"","district":"白玉县"},
{"code":513332,"province":"","city":"","district":"石渠县"},
{"code":513333,"province":"","city":"","district":"色达县"},
{"code":513334,"province":"","city":"","district":"理塘县"},
{"code":513335,"province":"","city":"","district":"巴塘县"},
{"code":513336,"province":"","city":"","district":"乡城县"},
{"code":513337,"province":"","city":"","district":"稻城县"},
{"code":513338,"province":"","city":"","district":"得荣县"},
{"code":513400,"province":"","city":"凉山彝族自治州","district":""},
{"code":513401,"province":"","city":"","district":"西昌市"},
{"code":513422,"province":"","city":"","district":"木里藏族自治县"},
{"code":513423,"province":"","city":"","district":"盐源县"},
{"code":513424,"province":"","city":"","district":"德昌县"},
{"code":513425,"province":"","city":"","district":"会理县"},
{"code":513426,"province":"","city":"","district":"会东县"},
{"code":513427,"province":"","city":"","district":"宁南县"},
{"code":513428,"province":"","city":"","district":"普格县"},
{"code":513429,"province":"","city":"","district":"布拖县"},
{"code":513430,"province":"","city":"","district":"金阳县"},
{"code":513431,"province":"","city":"","district":"昭觉县"},
{"code":513432,"province":"","city":"","district":"喜德县"},
{"code":513433,"province":"","city":"","district":"冕宁县"},
{"code":513434,"province":"","city":"","district":"越西县"},
{"code":513435,"province":"","city":"","district":"甘洛县"},
{"code":513436,"province":"","city":"","district":"美姑县"},
{"code":513437,"province":"","city":"","district":"雷波县"},
{"code":520000,"province":"贵州省","city":"","district":""},
{"code":520100,"province":"","city":"贵阳市","district":""},
{"code":520102,"province":"","city":"","district":"南明区"},
{"code":520103,"province":"","city":"","district":"云岩区"},
{"code":520111,"province":"","city":"","district":"花溪区"},
{"code":520112,"province":"","city":"","district":"乌当区"},
{"code":520113,"province":"","city":"","district":"白云区"},
{"code":520115,"province":"","city":"","district":"观山湖区"},
{"code":520121,"province":"","city":"","district":"开阳县"},
{"code":520122,"province":"","city":"","district":"息烽县"},
{"code":520123,"province":"","city":"","district":"修文县"},
{"code":520181,"province":"","city":"","district":"清镇市"},
{"code":520200,"province":"","city":"六盘水市","district":""},
{"code":520201,"province":"","city":"","district":"钟山区"},
{"code":520203,"province":"","city":"","district":"六枝特区"},
{"code":520221,"province":"","city":"","district":"水城县"},
{"code":520281,"province":"","city":"","district":"盘州市"},
{"code":520300,"province":"","city":"遵义市","district":""},
{"code":520302,"province":"","city":"","district":"红花岗区"},
{"code":520303,"province":"","city":"","district":"汇川区"},
{"code":520304,"province":"","city":"","district":"播州区"},
{"code":520322,"province":"","city":"","district":"桐梓县"},
{"code":520323,"province":"","city":"","district":"绥阳县"},
{"code":520324,"province":"","city":"","district":"正安县"},
{"code":520325,"province":"","city":"","district":"道真仡佬族苗族自治县"},
{"code":520326,"province":"","city":"","district":"务川仡佬族苗族自治县"},
{"code":520327,"province":"","city":"","district":"凤冈县"},
{"code":520328,"province":"","city":"","district":"湄潭县"},
{"code":520329,"province":"","city":"","district":"余庆县"},
{"code":520330,"province":"","city":"","district":"习水县"},
{"code":520381,"province":"","city":"","district":"赤水市"},
{"code":520382,"province":"","city":"","district":"仁怀市"},
{"code":520400,"province":"","city":"安顺市","district":""},
{"code":520402,"province":"","city":"","district":"西秀区"},
{"code":520403,"province":"","city":"","district":"平坝区"},
{"code":520422,"province":"","city":"","district":"普定县"},
{"code":520423,"province":"","city":"","district":"镇宁布依族苗族自治县"},
{"code":520424,"province":"","city":"","district":"关岭布依族苗族自治县"},
{"code":520425,"province":"","city":"","district":"紫云苗族布依族自治县"},
{"code":520500,"province":"","city":"毕节市","district":""},
{"code":520502,"province":"","city":"","district":"七星关区"},
{"code":520521,"province":"","city":"","district":"大方县"},
{"code":520522,"province":"","city":"","district":"黔西县"},
{"code":520523,"province":"","city":"","district":"金沙县"},
{"code":520524,"province":"","city":"","district":"织金县"},
{"code":520525,"province":"","city":"","district":"纳雍县"},
{"code":520526,"province":"","city":"","district":"威宁彝族回族苗族自治县"},
{"code":520527,"province":"","city":"","district":"赫章县"},
{"code":520600,"province":"","city":"铜仁市","district":""},
{"code":520602,"province":"","city":"","district":"碧江区"},
{"code":520603,"province":"","city":"","district":"万山区"},
{"code":520621,"province":"","city":"","district":"江口县"},
{"code":520622,"province":"","city":"","district":"玉屏侗族自治县"},
{"code":520623,"province":"","city":"","district":"石阡县"},
{"code":520624,"province":"","city":"","district":"思南县"},
{"code":520625,"province":"","city":"","district":"印江土家族苗族自治县"},
{"code":520626,"province":"","city":"","district":"德江县"},
{"code":520627,"province":"","city":"","district":"沿河土家族自治县"},
{"code":520628,"province":"","city":"","district":"松桃苗族自治县"},
{"code":522300,"province":"","city":"黔西南布依族苗族自治州","district":""},
{"code":522301,"province":"","city":"","district":"兴义市"},
{"code":522302,"province":"","city":"","district":"兴仁市"},
{"code":522323,"province":"","city":"","district":"普安县"},
{"code":522324,"province":"","city":"","district":"晴隆县"},
{"code":522325,"province":"","city":"","district":"贞丰县"},
{"code":522326,"province":"","city":"","district":"望谟县"},
{"code":522327,"province":"","city":"","district":"册亨县"},
{"code":522328,"province":"","city":"","district":"安龙县"},
{"code":522600,"province":"","city":"黔东南苗族侗族自治州","district":""},
{"code":522601,"province":"","city":"","district":"凯里市"},
{"code":522622,"province":"","city":"","district":"黄平县"},
{"code":522623,"province":"","city":"","district":"施秉县"},
{"code":522624,"province":"","city":"","district":"三穗县"},
{"code":522625,"province":"","city":"","district":"镇远县"},
{"code":522626,"province":"","city":"","district":"岑巩县"},
{"code":522627,"province":"","city":"","district":"天柱县"},
{"code":522628,"province":"","city":"","district":"锦屏县"},
{"code":522629,"province":"","city":"","district":"剑河县"},
{"code":522630,"province":"","city":"","district":"台江县"},
{"code":522631,"province":"","city":"","district":"黎平县"},
{"code":522632,"province":"","city":"","district":"榕江县"},
{"code":522633,"province":"","city":"","district":"从江县"},
{"code":522634,"province":"","city":"","district":"雷山县"},
{"code":522635,"province":"","city":"","district":"麻江县"},
{"code":522636,"province":"","city":"","district":"丹寨县"},
{"code":522700,"province":"","city":"黔南布依族苗族自治州","district":""},
{"code":522701,"province":"","city":"","district":"都匀市"},
{"code":522702,"province":"","city":"","district":"福泉市"},
{"code":522722,"province":"","city":"","district":"荔波县"},
{"code":522723,"province":"","city":"","district":"贵定县"},
{"code":522725,"province":"","city":"","district":"瓮安县"},
{"code":522726,"province":"","city":"","district":"独山县"},
{"code":522727,"province":"","city":"","district":"平塘县"},
{"code":522728,"province":"","city":"","district":"罗甸县"},
{"code":522729,"province":"","city":"","district":"长顺县"},
{"code":522730,"province":"","city":"","district":"龙里县"},
{"code":522731,"province":"","city":"","district":"惠水县"},
{"code":522732,"province":"","city":"","district":"三都水族自治县"},
{"code":530000,"province":"云南省","city":"","district":""},
{"code":530100,"province":"","city":"昆明市","district":""},
{"code":530102,"province":"","city":"","district":"五华区"},
{"code":530103,"province":"","city":"","district":"盘龙区"},
{"code":530111,"province":"","city":"","district":"官渡区"},
{"code":530112,"province":"","city":"","district":"西山区"},
{"code":530113,"province":"","city":"","district":"东川区"},
{"code":530114,"province":"","city":"","district":"呈贡区"},
{"code":530115,"province":"","city":"","district":"晋宁区"},
{"code":530124,"province":"","city":"","district":"富民县"},
{"code":530125,"province":"","city":"","district":"宜良县"},
{"code":530126,"province":"","city":"","district":"石林彝族自治县"},
{"code":530127,"province":"","city":"","district":"嵩明县"},
{"code":530128,"province":"","city":"","district":"禄劝彝族苗族自治县"},
{"code":530129,"province":"","city":"","district":"寻甸回族彝族自治县"},
{"code":530181,"province":"","city":"","district":"安宁市"},
{"code":530300,"province":"","city":"曲靖市","district":""},
{"code":530302,"province":"","city":"","district":"麒麟区"},
{"code":530303,"province":"","city":"","district":"沾益区"},
{"code":530304,"province":"","city":"","district":"马龙区"},
{"code":530322,"province":"","city":"","district":"陆良县"},
{"code":530323,"province":"","city":"","district":"师宗县"},
{"code":530324,"province":"","city":"","district":"罗平县"},
{"code":530325,"province":"","city":"","district":"富源县"},
{"code":530326,"province":"","city":"","district":"会泽县"},
{"code":530381,"province":"","city":"","district":"宣威市"},
{"code":530400,"province":"","city":"玉溪市","district":""},
{"code":530402,"province":"","city":"","district":"红塔区"},
{"code":530403,"province":"","city":"","district":"江川区"},
{"code":530423,"province":"","city":"","district":"通海县"},
{"code":530424,"province":"","city":"","district":"华宁县"},
{"code":530425,"province":"","city":"","district":"易门县"},
{"code":530426,"province":"","city":"","district":"峨山彝族自治县"},
{"code":530427,"province":"","city":"","district":"新平彝族傣族自治县"},
{"code":530428,"province":"","city":"","district":"元江哈尼族彝族傣族自治县"},
{"code":530481,"province":"","city":"","district":"澄江市"},
{"code":530500,"province":"","city":"保山市","district":""},
{"code":530502,"province":"","city":"","district":"隆阳区"},
{"code":530521,"province":"","city":"","district":"施甸县"},
{"code":530581,"province":"","city":"","district":"腾冲市"},
{"code":530523,"province":"","city":"","district":"龙陵县"},
{"code":530524,"province":"","city":"","district":"昌宁县"},
{"code":530600,"province":"","city":"昭通市","district":""},
{"code":530602,"province":"","city":"","district":"昭阳区"},
{"code":530621,"province":"","city":"","district":"鲁甸县"},
{"code":530622,"province":"","city":"","district":"巧家县"},
{"code":530623,"province":"","city":"","district":"盐津县"},
{"code":530624,"province":"","city":"","district":"大关县"},
{"code":530625,"province":"","city":"","district":"永善县"},
{"code":530626,"province":"","city":"","district":"绥江县"},
{"code":530627,"province":"","city":"","district":"镇雄县"},
{"code":530628,"province":"","city":"","district":"彝良县"},
{"code":530629,"province":"","city":"","district":"威信县"},
{"code":530681,"province":"","city":"","district":"水富市"},
{"code":530700,"province":"","city":"丽江市","district":""},
{"code":530702,"province":"","city":"","district":"古城区"},
{"code":530721,"province":"","city":"","district":"玉龙纳西族自治县"},
{"code":530722,"province":"","city":"","district":"永胜县"},
{"code":530723,"province":"","city":"","district":"华坪县"},
{"code":530724,"province":"","city":"","district":"宁蒗彝族自治县"},
{"code":530800,"province":"","city":"普洱市","district":""},
{"code":530802,"province":"","city":"","district":"思茅区"},
{"code":530821,"province":"","city":"","district":"宁洱哈尼族彝族自治县"},
{"code":530822,"province":"","city":"","district":"墨江哈尼族自治县"},
{"code":530823,"province":"","city":"","district":"景东彝族自治县"},
{"code":530824,"province":"","city":"","district":"景谷傣族彝族自治县"},
{"code":530825,"province":"","city":"","district":"镇沅彝族哈尼族拉祜族自治县"},
{"code":530826,"province":"","city":"","district":"江城哈尼族彝族自治县"},
{"code":530827,"province":"","city":"","district":"孟连傣族拉祜族佤族自治县"},
{"code":530828,"province":"","city":"","district":"澜沧拉祜族自治县"},
{"code":530829,"province":"","city":"","district":"西盟佤族自治县"},
{"code":530900,"province":"","city":"临沧市","district":""},
{"code":530902,"province":"","city":"","district":"临翔区"},
{"code":530921,"province":"","city":"","district":"凤庆县"},
{"code":530922,"province":"","city":"","district":"云县"},
{"code":530923,"province":"","city":"","district":"永德县"},
{"code":530924,"province":"","city":"","district":"镇康县"},
{"code":530925,"province":"","city":"","district":"双江拉祜族佤族布朗族傣族自治县"},
{"code":530926,"province":"","city":"","district":"耿马傣族佤族自治县"},
{"code":530927,"province":"","city":"","district":"沧源佤族自治县"},
{"code":532300,"province":"","city":"楚雄彝族自治州","district":""},
{"code":532301,"province":"","city":"","district":"楚雄市"},
{"code":532322,"province":"","city":"","district":"双柏县"},
{"code":532323,"province":"","city":"","district":"牟定县"},
{"code":532324,"province":"","city":"","district":"南华县"},
{"code":532325,"province":"","city":"","district":"姚安县"},
{"code":532326,"province":"","city":"","district":"大姚县"},
{"code":532327,"province":"","city":"","district":"永仁县"},
{"code":532328,"province":"","city":"","district":"元谋县"},
{"code":532329,"province":"","city":"","district":"武定县"},
{"code":532331,"province":"","city":"","district":"禄丰县"},
{"code":532500,"province":"","city":"红河哈尼族彝族自治州","district":""},
{"code":532501,"province":"","city":"","district":"个旧市"},
{"code":532502,"province":"","city":"","district":"开远市"},
{"code":532503,"province":"","city":"","district":"蒙自市"},
{"code":532504,"province":"","city":"","district":"弥勒市"},
{"code":532523,"province":"","city":"","district":"屏边苗族自治县"},
{"code":532524,"province":"","city":"","district":"建水县"},
{"code":532525,"province":"","city":"","district":"石屏县"},
{"code":532527,"province":"","city":"","district":"泸西县"},
{"code":532528,"province":"","city":"","district":"元阳县"},
{"code":532529,"province":"","city":"","district":"红河县"},
{"code":532530,"province":"","city":"","district":"金平苗族瑶族傣族自治县"},
{"code":532531,"province":"","city":"","district":"绿春县"},
{"code":532532,"province":"","city":"","district":"河口瑶族自治县"},
{"code":532600,"province":"","city":"文山壮族苗族自治州","district":""},
{"code":532601,"province":"","city":"","district":"文山市"},
{"code":532622,"province":"","city":"","district":"砚山县"},
{"code":532623,"province":"","city":"","district":"西畴县"},
{"code":532624,"province":"","city":"","district":"麻栗坡县"},
{"code":532625,"province":"","city":"","district":"马关县"},
{"code":532626,"province":"","city":"","district":"丘北县"},
{"code":532627,"province":"","city":"","district":"广南县"},
{"code":532628,"province":"","city":"","district":"富宁县"},
{"code":532800,"province":"","city":"西双版纳傣族自治州","district":""},
{"code":532801,"province":"","city":"","district":"景洪市"},
{"code":532822,"province":"","city":"","district":"勐海县"},
{"code":532823,"province":"","city":"","district":"勐腊县"},
{"code":532900,"province":"","city":"大理白族自治州","district":""},
{"code":532901,"province":"","city":"","district":"大理市"},
{"code":532922,"province":"","city":"","district":"漾濞彝族自治县"},
{"code":532923,"province":"","city":"","district":"祥云县"},
{"code":532924,"province":"","city":"","district":"宾川县"},
{"code":532925,"province":"","city":"","district":"弥渡县"},
{"code":532926,"province":"","city":"","district":"南涧彝族自治县"},
{"code":532927,"province":"","city":"","district":"巍山彝族回族自治县"},
{"code":532928,"province":"","city":"","district":"永平县"},
{"code":532929,"province":"","city":"","district":"云龙县"},
{"code":532930,"province":"","city":"","district":"洱源县"},
{"code":532931,"province":"","city":"","district":"剑川县"},
{"code":532932,"province":"","city":"","district":"鹤庆县"},
{"code":533100,"province":"","city":"德宏傣族景颇族自治州","district":""},
{"code":533102,"province":"","city":"","district":"瑞丽市"},
{"code":533103,"province":"","city":"","district":"芒市"},
{"code":533122,"province":"","city":"","district":"梁河县"},
{"code":533123,"province":"","city":"","district":"盈江县"},
{"code":533124,"province":"","city":"","district":"陇川县"},
{"code":533300,"province":"","city":"怒江傈僳族自治州","district":""},
{"code":533301,"province":"","city":"","district":"泸水市"},
{"code":533323,"province":"","city":"","district":"福贡县"},
{"code":533324,"province":"","city":"","district":"贡山独龙族怒族自治县"},
{"code":533325,"province":"","city":"","district":"兰坪白族普米族自治县"},
{"code":533400,"province":"","city":"迪庆藏族自治州","district":""},
{"code":533401,"province":"","city":"","district":"香格里拉市"},
{"code":533422,"province":"","city":"","district":"德钦县"},
{"code":533423,"province":"","city":"","district":"维西傈僳族自治县"},
{"code":540000,"province":"西藏自治区","city":"","district":""},
{"code":540100,"province":"","city":"拉萨市","district":""},
{"code":540102,"province":"","city":"","district":"城关区"},
{"code":540103,"province":"","city":"","district":"堆龙德庆区"},
{"code":540104,"province":"","city":"","district":"达孜区"},
{"code":540121,"province":"","city":"","district":"林周县"},
{"code":540122,"province":"","city":"","district":"当雄县"},
{"code":540123,"province":"","city":"","district":"尼木县"},
{"code":540124,"province":"","city":"","district":"曲水县"},
{"code":540127,"province":"","city":"","district":"墨竹工卡县"},
{"code":540200,"province":"","city":"日喀则市","district":""},
{"code":540202,"province":"","city":"","district":"桑珠孜区"},
{"code":540221,"province":"","city":"","district":"南木林县"},
{"code":540222,"province":"","city":"","district":"江孜县"},
{"code":540223,"province":"","city":"","district":"定日县"},
{"code":540224,"province":"","city":"","district":"萨迦县"},
{"code":540225,"province":"","city":"","district":"拉孜县"},
{"code":540226,"province":"","city":"","district":"昂仁县"},
{"code":540227,"province":"","city":"","district":"谢通门县"},
{"code":540228,"province":"","city":"","district":"白朗县"},
{"code":540229,"province":"","city":"","district":"仁布县"},
{"code":540230,"province":"","city":"","district":"康马县"},
{"code":540231,"province":"","city":"","district":"定结县"},
{"code":540232,"province":"","city":"","district":"仲巴县"},
{"code":540233,"province":"","city":"","district":"亚东县"},
{"code":540234,"province":"","city":"","district":"吉隆县"},
{"code":540235,"province":"","city":"","district":"聂拉木县"},
{"code":540236,"province":"","city":"","district":"萨嘎县"},
{"code":540237,"province":"","city":"","district":"岗巴县"},
{"code":540300,"province":"","city":"昌都市","district":""},
{"code":540302,"province":"","city":"","district":"卡若区"},
{"code":540321,"province":"","city":"","district":"江达县"},
{"code":540322,"province":"","city":"","district":"贡觉县"},
{"code":540323,"province":"","city":"","district":"类乌齐县"},
{"code":540324,"province":"","city":"","district":"丁青县"},
{"code":540325,"province":"","city":"","district":"察雅县"},
{"code":540326,"province":"","city":"","district":"八宿县"},
{"code":540327,"province":"","city":"","district":"左贡县"},
{"code":540328,"province":"","city":"","district":"芒康县"},
{"code":540329,"province":"","city":"","district":"洛隆县"},
{"code":540330,"province":"","city":"","district":"边坝县"},
{"code":540400,"province":"","city":"林芝市","district":""},
{"code":540402,"province":"","city":"","district":"巴宜区"},
{"code":540421,"province":"","city":"","district":"工布江达县"},
{"code":540422,"province":"","city":"","district":"米林县"},
{"code":540423,"province":"","city":"","district":"墨脱县"},
{"code":540424,"province":"","city":"","district":"波密县"},
{"code":540425,"province":"","city":"","district":"察隅县"},
{"code":540426,"province":"","city":"","district":"朗县"},
{"code":540500,"province":"","city":"山南市","district":""},
{"code":540502,"province":"","city":"","district":"乃东区"},
{"code":540521,"province":"","city":"","district":"扎囊县"},
{"code":540522,"province":"","city":"","district":"贡嘎县"},
{"code":540523,"province":"","city":"","district":"桑日县"},
{"code":540524,"province":"","city":"","district":"琼结县"},
{"code":540525,"province":"","city":"","district":"曲松县"},
{"code":540526,"province":"","city":"","district":"措美县"},
{"code":540527,"province":"","city":"","district":"洛扎县"},
{"code":540528,"province":"","city":"","district":"加查县"},
{"code":540529,"province":"","city":"","district":"隆子县"},
{"code":540530,"province":"","city":"","district":"错那县"},
{"code":540531,"province":"","city":"","district":"浪卡子县"},
{"code":540600,"province":"","city":"那曲市","district":""},
{"code":540602,"province":"","city":"","district":"色尼区"},
{"code":540621,"province":"","city":"","district":"嘉黎县"},
{"code":540622,"province":"","city":"","district":"比如县"},
{"code":540623,"province":"","city":"","district":"聂荣县"},
{"code":540624,"province":"","city":"","district":"安多县"},
{"code":540625,"province":"","city":"","district":"申扎县"},
{"code":540626,"province":"","city":"","district":"索县"},
{"code":540627,"province":"","city":"","district":"班戈县"},
{"code":540628,"province":"","city":"","district":"巴青县"},
{"code":540629,"province":"","city":"","district":"尼玛县"},
{"code":540630,"province":"","city":"","district":"双湖县"},
{"code":542500,"province":"","city":"阿里地区","district":""},
{"code":542521,"province":"","city":"","district":"普兰县"},
{"code":542522,"province":"","city":"","district":"札达县"},
{"code":542523,"province":"","city":"","district":"噶尔县"},
{"code":542524,"province":"","city":"","district":"日土县"},
{"code":542525,"province":"","city":"","district":"革吉县"},
{"code":542526,"province":"","city":"","district":"改则县"},
{"code":542527,"province":"","city":"","district":"措勤县"},
{"code":610000,"province":"陕西省","city":"","district":""},
{"code":610100,"province":"","city":"西安市","district":""},
{"code":610102,"province":"","city":"","district":"新城区"},
{"code":610103,"province":"","city":"","district":"碑林区"},
{"code":610104,"province":"","city":"","district":"莲湖区"},
{"code":610111,"province":"","city":"","district":"灞桥区"},
{"code":610112,"province":"","city":"","district":"未央区"},
{"code":610113,"province":"","city":"","district":"雁塔区"},
{"code":610114,"province":"","city":"","district":"阎良区"},
{"code":610115,"province":"","city":"","district":"临潼区"},
{"code":610116,"province":"","city":"","district":"长安区"},
{"code":610117,"province":"","city":"","district":"高陵区"},
{"code":610122,"province":"","city":"","district":"蓝田县"},
{"code":610124,"province":"","city":"","district":"周至县"},
{"code":610118,"province":"","city":"","district":"鄠邑区"},
{"code":610200,"province":"","city":"铜川市","district":""},
{"code":610202,"province":"","city":"","district":"王益区"},
{"code":610203,"province":"","city":"","district":"印台区"},
{"code":610204,"province":"","city":"","district":"耀州区"},
{"code":610222,"province":"","city":"","district":"宜君县"},
{"code":610300,"province":"","city":"宝鸡市","district":""},
{"code":610302,"province":"","city":"","district":"渭滨区"},
{"code":610303,"province":"","city":"","district":"金台区"},
{"code":610304,"province":"","city":"","district":"陈仓区"},
{"code":610322,"province":"","city":"","district":"凤翔县"},
{"code":610323,"province":"","city":"","district":"岐山县"},
{"code":610324,"province":"","city":"","district":"扶风县"},
{"code":610326,"province":"","city":"","district":"眉县"},
{"code":610327,"province":"","city":"","district":"陇县"},
{"code":610328,"province":"","city":"","district":"千阳县"},
{"code":610329,"province":"","city":"","district":"麟游县"},
{"code":610330,"province":"","city":"","district":"凤县"},
{"code":610331,"province":"","city":"","district":"太白县"},
{"code":610400,"province":"","city":"咸阳市","district":""},
{"code":610402,"province":"","city":"","district":"秦都区"},
{"code":610403,"province":"","city":"","district":"杨陵区"},
{"code":610404,"province":"","city":"","district":"渭城区"},
{"code":610422,"province":"","city":"","district":"三原县"},
{"code":610423,"province":"","city":"","district":"泾阳县"},
{"code":610424,"province":"","city":"","district":"乾县"},
{"code":610425,"province":"","city":"","district":"礼泉县"},
{"code":610426,"province":"","city":"","district":"永寿县"},
{"code":610482,"province":"","city":"","district":"彬州市"},
{"code":610428,"province":"","city":"","district":"长武县"},
{"code":610429,"province":"","city":"","district":"旬邑县"},
{"code":610430,"province":"","city":"","district":"淳化县"},
{"code":610431,"province":"","city":"","district":"武功县"},
{"code":610481,"province":"","city":"","district":"兴平市"},
{"code":610500,"province":"","city":"渭南市","district":""},
{"code":610502,"province":"","city":"","district":"临渭区"},
{"code":610503,"province":"","city":"","district":"华州区"},
{"code":610522,"province":"","city":"","district":"潼关县"},
{"code":610523,"province":"","city":"","district":"大荔县"},
{"code":610524,"province":"","city":"","district":"合阳县"},
{"code":610525,"province":"","city":"","district":"澄城县"},
{"code":610526,"province":"","city":"","district":"蒲城县"},
{"code":610527,"province":"","city":"","district":"白水县"},
{"code":610528,"province":"","city":"","district":"富平县"},
{"code":610581,"province":"","city":"","district":"韩城市"},
{"code":610582,"province":"","city":"","district":"华阴市"},
{"code":610600,"province":"","city":"延安市","district":""},
{"code":610602,"province":"","city":"","district":"宝塔区"},
{"code":610603,"province":"","city":"","district":"安塞区"},
{"code":610621,"province":"","city":"","district":"延长县"},
{"code":610622,"province":"","city":"","district":"延川县"},
{"code":610625,"province":"","city":"","district":"志丹县"},
{"code":610626,"province":"","city":"","district":"吴起县"},
{"code":610627,"province":"","city":"","district":"甘泉县"},
{"code":610628,"province":"","city":"","district":"富县"},
{"code":610629,"province":"","city":"","district":"洛川县"},
{"code":610630,"province":"","city":"","district":"宜川县"},
{"code":610631,"province":"","city":"","district":"黄龙县"},
{"code":610632,"province":"","city":"","district":"黄陵县"},
{"code":610681,"province":"","city":"","district":"子长市"},
{"code":610700,"province":"","city":"汉中市","district":""},
{"code":610702,"province":"","city":"","district":"汉台区"},
{"code":610703,"province":"","city":"","district":"南郑区"},
{"code":610722,"province":"","city":"","district":"城固县"},
{"code":610723,"province":"","city":"","district":"洋县"},
{"code":610724,"province":"","city":"","district":"西乡县"},
{"code":610725,"province":"","city":"","district":"勉县"},
{"code":610726,"province":"","city":"","district":"宁强县"},
{"code":610727,"province":"","city":"","district":"略阳县"},
{"code":610728,"province":"","city":"","district":"镇巴县"},
{"code":610729,"province":"","city":"","district":"留坝县"},
{"code":610730,"province":"","city":"","district":"佛坪县"},
{"code":610800,"province":"","city":"榆林市","district":""},
{"code":610802,"province":"","city":"","district":"榆阳区"},
{"code":610803,"province":"","city":"","district":"横山区"},
{"code":610881,"province":"","city":"","district":"神木市"},
{"code":610822,"province":"","city":"","district":"府谷县"},
{"code":610824,"province":"","city":"","district":"靖边县"},
{"code":610825,"province":"","city":"","district":"定边县"},
{"code":610826,"province":"","city":"","district":"绥德县"},
{"code":610827,"province":"","city":"","district":"米脂县"},
{"code":610828,"province":"","city":"","district":"佳县"},
{"code":610829,"province":"","city":"","district":"吴堡县"},
{"code":610830,"province":"","city":"","district":"清涧县"},
{"code":610831,"province":"","city":"","district":"子洲县"},
{"code":610900,"province":"","city":"安康市","district":""},
{"code":610902,"province":"","city":"","district":"汉滨区"},
{"code":610921,"province":"","city":"","district":"汉阴县"},
{"code":610922,"province":"","city":"","district":"石泉县"},
{"code":610923,"province":"","city":"","district":"宁陕县"},
{"code":610924,"province":"","city":"","district":"紫阳县"},
{"code":610925,"province":"","city":"","district":"岚皋县"},
{"code":610926,"province":"","city":"","district":"平利县"},
{"code":610927,"province":"","city":"","district":"镇坪县"},
{"code":610928,"province":"","city":"","district":"旬阳县"},
{"code":610929,"province":"","city":"","district":"白河县"},
{"code":611000,"province":"","city":"商洛市","district":""},
{"code":611002,"province":"","city":"","district":"商州区"},
{"code":611021,"province":"","city":"","district":"洛南县"},
{"code":611022,"province":"","city":"","district":"丹凤县"},
{"code":611023,"province":"","city":"","district":"商南县"},
{"code":611024,"province":"","city":"","district":"山阳县"},
{"code":611025,"province":"","city":"","district":"镇安县"},
{"code":611026,"province":"","city":"","district":"柞水县"},
{"code":620000,"province":"甘肃省","city":"","district":""},
{"code":620100,"province":"","city":"兰州市","district":""},
{"code":620102,"province":"","city":"","district":"城关区"},
{"code":620103,"province":"","city":"","district":"七里河区"},
{"code":620104,"province":"","city":"","district":"西固区"},
{"code":620105,"province":"","city":"","district":"安宁区"},
{"code":620111,"province":"","city":"","district":"红古区"},
{"code":620121,"province":"","city":"","district":"永登县"},
{"code":620122,"province":"","city":"","district":"皋兰县"},
{"code":620123,"province":"","city":"","district":"榆中县"},
{"code":620200,"province":"","city":"嘉峪关市","district":""},
{"code":620300,"province":"","city":"金昌市","district":""},
{"code":620302,"province":"","city":"","district":"金川区"},
{"code":620321,"province":"","city":"","district":"永昌县"},
{"code":620400,"province":"","city":"白银市","district":""},
{"code":620402,"province":"","city":"","district":"白银区"},
{"code":620403,"province":"","city":"","district":"平川区"},
{"code":620421,"province":"","city":"","district":"靖远县"},
{"code":620422,"province":"","city":"","district":"会宁县"},
{"code":620423,"province":"","city":"","district":"景泰县"},
{"code":620500,"province":"","city":"天水市","district":""},
{"code":620502,"province":"","city":"","district":"秦州区"},
{"code":620503,"province":"","city":"","district":"麦积区"},
{"code":620521,"province":"","city":"","district":"清水县"},
{"code":620522,"province":"","city":"","district":"秦安县"},
{"code":620523,"province":"","city":"","district":"甘谷县"},
{"code":620524,"province":"","city":"","district":"武山县"},
{"code":620525,"province":"","city":"","district":"张家川回族自治县"},
{"code":620600,"province":"","city":"武威市","district":""},
{"code":620602,"province":"","city":"","district":"凉州区"},
{"code":620621,"province":"","city":"","district":"民勤县"},
{"code":620622,"province":"","city":"","district":"古浪县"},
{"code":620623,"province":"","city":"","district":"天祝藏族自治县"},
{"code":620700,"province":"","city":"张掖市","district":""},
{"code":620702,"province":"","city":"","district":"甘州区"},
{"code":620721,"province":"","city":"","district":"肃南裕固族自治县"},
{"code":620722,"province":"","city":"","district":"民乐县"},
{"code":620723,"province":"","city":"","district":"临泽县"},
{"code":620724,"province":"","city":"","district":"高台县"},
{"code":620725,"province":"","city":"","district":"山丹县"},
{"code":620800,"province":"","city":"平凉市","district":""},
{"code":620802,"province":"","city":"","district":"崆峒区"},
{"code":620821,"province":"","city":"","district":"泾川县"},
{"code":620822,"province":"","city":"","district":"灵台县"},
{"code":620823,"province":"","city":"","district":"崇信县"},
{"code":620881,"province":"","city":"","district":"华亭市"},
{"code":620825,"province":"","city":"","district":"庄浪县"},
{"code":620826,"province":"","city":"","district":"静宁县"},
{"code":620900,"province":"","city":"酒泉市","district":""},
{"code":620902,"province":"","city":"","district":"肃州区"},
{"code":620921,"province":"","city":"","district":"金塔县"},
{"code":620922,"province":"","city":"","district":"瓜州县"},
{"code":620923,"province":"","city":"","district":"肃北蒙古族自治县"},
{"code":620924,"province":"","city":"","district":"阿克塞哈萨克族自治县"},
{"code":620981,"province":"","city":"","district":"玉门市"},
{"code":620982,"province":"","city":"","district":"敦煌市"},
{"code":621000,"province":"","city":"庆阳市","district":""},
{"code":621002,"province":"","city":"","district":"西峰区"},
{"code":621021,"province":"","city":"","district":"庆城县"},
{"code":621022,"province":"","city":"","district":"环县"},
{"code":621023,"province":"","city":"","district":"华池县"},
{"code":621024,"province":"","city":"","district":"合水县"},
{"code":621025,"province":"","city":"","district":"正宁县"},
{"code":621026,"province":"","city":"","district":"宁县"},
{"code":621027,"province":"","city":"","district":"镇原县"},
{"code":621100,"province":"","city":"定西市","district":""},
{"code":621102,"province":"","city":"","district":"安定区"},
{"code":621121,"province":"","city":"","district":"通渭县"},
{"code":621122,"province":"","city":"","district":"陇西县"},
{"code":621123,"province":"","city":"","district":"渭源县"},
{"code":621124,"province":"","city":"","district":"临洮县"},
{"code":621125,"province":"","city":"","district":"漳县"},
{"code":621126,"province":"","city":"","district":"岷县"},
{"code":621200,"province":"","city":"陇南市","district":""},
{"code":621202,"province":"","city":"","district":"武都区"},
{"code":621221,"province":"","city":"","district":"成县"},
{"code":621222,"province":"","city":"","district":"文县"},
{"code":621223,"province":"","city":"","district":"宕昌县"},
{"code":621224,"province":"","city":"","district":"康县"},
{"code":621225,"province":"","city":"","district":"西和县"},
{"code":621226,"province":"","city":"","district":"礼县"},
{"code":621227,"province":"","city":"","district":"徽县"},
{"code":621228,"province":"","city":"","district":"两当县"},
{"code":622900,"province":"","city":"临夏回族自治州","district":""},
{"code":622901,"province":"","city":"","district":"临夏市"},
{"code":622921,"province":"","city":"","district":"临夏县"},
{"code":622922,"province":"","city":"","district":"康乐县"},
{"code":622923,"province":"","city":"","district":"永靖县"},
{"code":622924,"province":"","city":"","district":"广河县"},
{"code":622925,"province":"","city":"","district":"和政县"},
{"code":622926,"province":"","city":"","district":"东乡族自治县"},
{"code":622927,"province":"","city":"","district":"积石山保安族东乡族撒拉族自治县"},
{"code":623000,"province":"","city":"甘南藏族自治州","district":""},
{"code":623001,"province":"","city":"","district":"合作市"},
{"code":623021,"province":"","city":"","district":"临潭县"},
{"code":623022,"province":"","city":"","district":"卓尼县"},
{"code":623023,"province":"","city":"","district":"舟曲县"},
{"code":623024,"province":"","city":"","district":"迭部县"},
{"code":623025,"province":"","city":"","district":"玛曲县"},
{"code":623026,"province":"","city":"","district":"碌曲县"},
{"code":623027,"province":"","city":"","district":"夏河县"},
{"code":630000,"province":"青海省","city":"","district":""},
{"code":630100,"province":"","city":"西宁市","district":""},
{"code":630102,"province":"","city":"","district":"城东区"},
{"code":630103,"province":"","city":"","district":"城中区"},
{"code":630104,"province":"","city":"","district":"城西区"},
{"code":630105,"province":"","city":"","district":"城北区"},
{"code":630106,"province":"","city":"","district":"湟中区"},
{"code":630121,"province":"","city":"","district":"大通回族土族自治县"},
{"code":630123,"province":"","city":"","district":"湟源县"},
{"code":630200,"province":"","city":"海东市","district":""},
{"code":630202,"province":"","city":"","district":"乐都区"},
{"code":630203,"province":"","city":"","district":"平安区"},
{"code":630222,"province":"","city":"","district":"民和回族土族自治县"},
{"code":630223,"province":"","city":"","district":"互助土族自治县"},
{"code":630224,"province":"","city":"","district":"化隆回族自治县"},
{"code":630225,"province":"","city":"","district":"循化撒拉族自治县"},
{"code":632200,"province":"","city":"海北藏族自治州","district":""},
{"code":632221,"province":"","city":"","district":"门源回族自治县"},
{"code":632222,"province":"","city":"","district":"祁连县"},
{"code":632223,"province":"","city":"","district":"海晏县"},
{"code":632224,"province":"","city":"","district":"刚察县"},
{"code":632300,"province":"","city":"黄南藏族自治州","district":""},
{"code":632321,"province":"","city":"","district":"同仁县"},
{"code":632322,"province":"","city":"","district":"尖扎县"},
{"code":632323,"province":"","city":"","district":"泽库县"},
{"code":632324,"province":"","city":"","district":"河南蒙古族自治县"},
{"code":632500,"province":"","city":"海南藏族自治州","district":""},
{"code":632521,"province":"","city":"","district":"共和县"},
{"code":632522,"province":"","city":"","district":"同德县"},
{"code":632523,"province":"","city":"","district":"贵德县"},
{"code":632524,"province":"","city":"","district":"兴海县"},
{"code":632525,"province":"","city":"","district":"贵南县"},
{"code":632600,"province":"","city":"果洛藏族自治州","district":""},
{"code":632621,"province":"","city":"","district":"玛沁县"},
{"code":632622,"province":"","city":"","district":"班玛县"},
{"code":632623,"province":"","city":"","district":"甘德县"},
{"code":632624,"province":"","city":"","district":"达日县"},
{"code":632625,"province":"","city":"","district":"久治县"},
{"code":632626,"province":"","city":"","district":"玛多县"},
{"code":632700,"province":"","city":"玉树藏族自治州","district":""},
{"code":632701,"province":"","city":"","district":"玉树市"},
{"code":632722,"province":"","city":"","district":"杂多县"},
{"code":632723,"province":"","city":"","district":"称多县"},
{"code":632724,"province":"","city":"","district":"治多县"},
{"code":632725,"province":"","city":"","district":"囊谦县"},
{"code":632726,"province":"","city":"","district":"曲麻莱县"},
{"code":632800,"province":"","city":"海西蒙古族藏族自治州","district":""},
{"code":632801,"province":"","city":"","district":"格尔木市"},
{"code":632802,"province":"","city":"","district":"德令哈市"},
{"code":632803,"province":"","city":"","district":"茫崖市"},
{"code":632821,"province":"","city":"","district":"乌兰县"},
{"code":632822,"province":"","city":"","district":"都兰县"},
{"code":632823,"province":"","city":"","district":"天峻县"},
{"code":640000,"province":"宁夏回族自治区","city":"","district":""},
{"code":640100,"province":"","city":"银川市","district":""},
{"code":640104,"province":"","city":"","district":"兴庆区"},
{"code":640105,"province":"","city":"","district":"西夏区"},
{"code":640106,"province":"","city":"","district":"金凤区"},
{"code":640121,"province":"","city":"","district":"永宁县"},
{"code":640122,"province":"","city":"","district":"贺兰县"},
{"code":640181,"province":"","city":"","district":"灵武市"},
{"code":640200,"province":"","city":"石嘴山市","district":""},
{"code":640202,"province":"","city":"","district":"大武口区"},
{"code":640205,"province":"","city":"","district":"惠农区"},
{"code":640221,"province":"","city":"","district":"平罗县"},
{"code":640300,"province":"","city":"吴忠市","district":""},
{"code":640302,"province":"","city":"","district":"利通区"},
{"code":640303,"province":"","city":"","district":"红寺堡区"},
{"code":640323,"province":"","city":"","district":"盐池县"},
{"code":640324,"province":"","city":"","district":"同心县"},
{"code":640381,"province":"","city":"","district":"青铜峡市"},
{"code":640400,"province":"","city":"固原市","district":""},
{"code":640402,"province":"","city":"","district":"原州区"},
{"code":640422,"province":"","city":"","district":"西吉县"},
{"code":640423,"province":"","city":"","district":"隆德县"},
{"code":640424,"province":"","city":"","district":"泾源县"},
{"code":640425,"province":"","city":"","district":"彭阳县"},
{"code":640500,"province":"","city":"中卫市","district":""},
{"code":640502,"province":"","city":"","district":"沙坡头区"},
{"code":640521,"province":"","city":"","district":"中宁县"},
{"code":640522,"province":"","city":"","district":"海原县"},
{"code":650000,"province":"新疆维吾尔自治区","city":"","district":""},
{"code":650100,"province":"","city":"乌鲁木齐市","district":""},
{"code":650102,"province":"","city":"","district":"天山区"},
{"code":650103,"province":"","city":"","district":"沙依巴克区"},
{"code":650104,"province":"","city":"","district":"新市区"},
{"code":650105,"province":"","city":"","district":"水磨沟区"},
{"code":650106,"province":"","city":"","district":"头屯河区"},
{"code":650107,"province":"","city":"","district":"达坂城区"},
{"code":650109,"province":"","city":"","district":"米东区"},
{"code":650121,"province":"","city":"","district":"乌鲁木齐县"},
{"code":650200,"province":"","city":"克拉玛依市","district":""},
{"code":650202,"province":"","city":"","district":"独山子区"},
{"code":650203,"province":"","city":"","district":"克拉玛依区"},
{"code":650204,"province":"","city":"","district":"白碱滩区"},
{"code":650205,"province":"","city":"","district":"乌尔禾区"},
{"code":650400,"province":"","city":"吐鲁番市","district":""},
{"code":650402,"province":"","city":"","district":"高昌区"},
{"code":650421,"province":"","city":"","district":"鄯善县"},
{"code":650422,"province":"","city":"","district":"托克逊县"},
{"code":650500,"province":"","city":"","district":"哈密市"},
{"code":650502,"province":"","city":"","district":"伊州区"},
{"code":650521,"province":"","city":"","district":"巴里坤哈萨克自治县"},
{"code":650522,"province":"","city":"","district":"伊吾县"},
{"code":652300,"province":"","city":"昌吉回族自治州","district":""},
{"code":652301,"province":"","city":"","district":"昌吉市"},
{"code":652302,"province":"","city":"","district":"阜康市"},
{"code":652323,"province":"","city":"","district":"呼图壁县"},
{"code":652324,"province":"","city":"","district":"玛纳斯县"},
{"code":652325,"province":"","city":"","district":"奇台县"},
{"code":652327,"province":"","city":"","district":"吉木萨尔县"},
{"code":652328,"province":"","city":"","district":"木垒哈萨克自治县"},
{"code":652700,"province":"","city":"博尔塔拉蒙古自治州","district":""},
{"code":652701,"province":"","city":"","district":"博乐市"},
{"code":652702,"province":"","city":"","district":"阿拉山口市"},
{"code":652722,"province":"","city":"","district":"精河县"},
{"code":652723,"province":"","city":"","district":"温泉县"},
{"code":652800,"province":"","city":"巴音郭楞蒙古自治州","district":""},
{"code":652801,"province":"","city":"","district":"库尔勒市"},
{"code":652822,"province":"","city":"","district":"轮台县"},
{"code":652823,"province":"","city":"","district":"尉犁县"},
{"code":652824,"province":"","city":"","district":"若羌县"},
{"code":652825,"province":"","city":"","district":"且末县"},
{"code":652826,"province":"","city":"","district":"焉耆回族自治县"},
{"code":652827,"province":"","city":"","district":"和静县"},
{"code":652828,"province":"","city":"","district":"和硕县"},
{"code":652829,"province":"","city":"","district":"博湖县"},
{"code":652900,"province":"","city":"阿克苏地区","district":""},
{"code":652901,"province":"","city":"","district":"阿克苏市"},
{"code":652902,"province":"","city":"","district":"库车市"},
{"code":652922,"province":"","city":"","district":"温宿县"},
{"code":652924,"province":"","city":"","district":"沙雅县"},
{"code":652925,"province":"","city":"","district":"新和县"},
{"code":652926,"province":"","city":"","district":"拜城县"},
{"code":652927,"province":"","city":"","district":"乌什县"},
{"code":652928,"province":"","city":"","district":"阿瓦提县"},
{"code":652929,"province":"","city":"","district":"柯坪县"},
{"code":653000,"province":"","city":"克孜勒苏柯尔克孜自治州","district":""},
{"code":653001,"province":"","city":"","district":"阿图什市"},
{"code":653022,"province":"","city":"","district":"阿克陶县"},
{"code":653023,"province":"","city":"","district":"阿合奇县"},
{"code":653024,"province":"","city":"","district":"乌恰县"},
{"code":653100,"province":"","city":"喀什地区","district":""},
{"code":653101,"province":"","city":"","district":"喀什市"},
{"code":653121,"province":"","city":"","district":"疏附县"},
{"code":653122,"province":"","city":"","district":"疏勒县"},
{"code":653123,"province":"","city":"","district":"英吉沙县"},
{"code":653124,"province":"","city":"","district":"泽普县"},
{"code":653125,"province":"","city":"","district":"莎车县"},
{"code":653126,"province":"","city":"","district":"叶城县"},
{"code":653127,"province":"","city":"","district":"麦盖提县"},
{"code":653128,"province":"","city":"","district":"岳普湖县"},
{"code":653129,"province":"","city":"","district":"伽师县"},
{"code":653130,"province":"","city":"","district":"巴楚县"},
{"code":653131,"province":"","city":"","district":"塔什库尔干塔吉克自治县"},
{"code":653200,"province":"","city":"和田地区","district":""},
{"code":653201,"province":"","city":"","district":"和田市"},
{"code":653221,"province":"","city":"","district":"和田县"},
{"code":653222,"province":"","city":"","district":"墨玉县"},
{"code":653223,"province":"","city":"","district":"皮山县"},
{"code":653224,"province":"","city":"","district":"洛浦县"},
{"code":653225,"province":"","city":"","district":"策勒县"},
{"code":653226,"province":"","city":"","district":"于田县"},
{"code":653227,"province":"","city":"","district":"民丰县"},
{"code":654000,"province":"","city":"伊犁哈萨克自治州","district":""},
{"code":654002,"province":"","city":"","district":"伊宁市"},
{"code":654003,"province":"","city":"","district":"奎屯市"},
{"code":654004,"province":"","city":"","district":"霍尔果斯市"},
{"code":654021,"province":"","city":"","district":"伊宁县"},
{"code":654022,"province":"","city":"","district":"察布查尔锡伯自治县"},
{"code":654023,"province":"","city":"","district":"霍城县"},
{"code":654024,"province":"","city":"","district":"巩留县"},
{"code":654025,"province":"","city":"","district":"新源县"},
{"code":654026,"province":"","city":"","district":"昭苏县"},
{"code":654027,"province":"","city":"","district":"特克斯县"},
{"code":654028,"province":"","city":"","district":"尼勒克县"},
{"code":654200,"province":"","city":"塔城地区","district":""},
{"code":654201,"province":"","city":"","district":"塔城市"},
{"code":654202,"province":"","city":"","district":"乌苏市"},
{"code":654221,"province":"","city":"","district":"额敏县"},
{"code":654223,"province":"","city":"","district":"沙湾县"},
{"code":654224,"province":"","city":"","district":"托里县"},
{"code":654225,"province":"","city":"","district":"裕民县"},
{"code":654226,"province":"","city":"","district":"和布克赛尔蒙古自治县"},
{"code":654300,"province":"","city":"阿勒泰地区","district":""},
{"code":654301,"province":"","city":"","district":"阿勒泰市"},
{"code":654321,"province":"","city":"","district":"布尔津县"},
{"code":654322,"province":"","city":"","district":"富蕴县"},
{"code":654323,"province":"","city":"","district":"福海县"},
{"code":654324,"province":"","city":"","district":"哈巴河县"},
{"code":654325,"province":"","city":"","district":"青河县"},
{"code":654326,"province":"","city":"","district":"吉木乃县"},
{"code":659001,"province":"","city":"","district":"石河子市"},
{"code":659002,"province":"","city":"","district":"阿拉尔市"},
{"code":659003,"province":"","city":"","district":"图木舒克市"},
{"code":659004,"province":"","city":"","district":"五家渠市"},
{"code":659005,"province":"","city":"","district":"北屯市"},
{"code":659006,"province":"","city":"","district":"铁门关市"},
{"code":659007,"province":"","city":"","district":"双河市"},
{"code":659008,"province":"","city":"","district":"可克达拉市"},
{"code":659009,"province":"","city":"","district":"昆玉市"},
{"code":659010,"province":"","city":"","district":"胡杨河市"},
{"code":710000,"province":"台湾省","city":"","district":""},
{"code":810000,"province":"香港特别行政区","city":"","district":""},
{"code":820000,"province":"澳门特别行政区","city":"","district":""},

]


// WEBPACK FOOTER //
// ./src/utils/citys.js